"use client";

import ScrollReveal from "@/components/common/ScrollReveal";
import React from "react";

const ApplicationSecurityAnalysis = () => {
  return (
    <section className="relative w-full px-4 sm:px-6 lg:px-8 pb-20 pt-2">
      <div className="relative z-10 w-full max-w-[1300px] mx-auto flex flex-col gap-12 lg:gap-16">
        {/* Hero illustration */}
        <div className="relative w-full flex items-center justify-center">
          {/* The SVG graphic fills the container width (responsive, like v1).
              On desktop the three labels overlay the illustration; on mobile
              they drop into a readable vertical stack below it. */}
          <div className="relative w-full max-w-[560px] lg:max-w-[789px] mx-auto">
            <ScrollReveal direction="up" delay={0}>
              {/* The overlay layout hangs the labels 300px past the illustration's
                  left edge and 150px past its right, so it needs ~1240px of room
                  plus gutters. Below 1360px viewport width there isn't that much:
                  the left-hand label used to land at a negative x and get clipped
                  off-canvas. So the labels stay in the readable vertical stack
                  until the overlay actually fits. */}
              <div className="relative flex flex-col items-stretch min-[1360px]:block">
                {/* The artwork only occupies the first 610 units of the
                      789-unit viewBox — the rest is reserved for the desktop
                      connector, which is hidden on mobile. Crop that empty
                      column so the illustration itself fills the full width. */}
                <div className="overflow-hidden min-[1360px]:overflow-visible">
                  <svg
                    width="789"
                    height="698"
                    viewBox="0 0 789 698"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-[129.35%] min-[1360px]:w-full h-auto"
                  >
                    <g opacity="0.376465">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.826 363.951C548.826 366.568 549.632 368.053 550.875 368.053C552.271 368.053 552.938 366.428 552.938 363.858C552.938 361.382 552.302 359.756 550.89 359.756C549.695 359.756 548.826 361.21 548.826 363.951ZM554.304 363.797C554.304 367.218 553.032 369.107 550.798 369.107C548.827 369.107 547.493 367.264 547.461 363.936C547.461 360.561 548.92 358.703 550.968 358.703C553.094 358.703 554.304 360.593 554.304 363.797Z"
                        fill="#FF1236"
                      />

                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.46 378.096H550.429L548.651 379.055L548.383 378.002L550.617 376.809H551.798V387.015H550.46V378.096Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M549.242 399.957C549.242 402.045 549.886 403.231 550.876 403.231C551.99 403.231 552.523 401.934 552.523 399.883C552.523 397.907 552.015 396.609 550.889 396.609C549.936 396.609 549.242 397.77 549.242 399.957ZM553.612 399.834C553.612 402.564 552.597 404.071 550.815 404.071C549.242 404.071 548.177 402.601 548.152 399.946C548.152 397.252 549.317 395.77 550.951 395.77C552.646 395.77 553.612 397.277 553.612 399.834Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.448 414.214H550.418L548.686 415.147L548.426 414.123L550.602 412.961H551.75V422.897H550.448V414.214Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.78 435.985C548.78 438.662 549.605 440.183 550.876 440.183C552.305 440.183 552.987 438.52 552.987 435.89C552.987 433.356 552.337 431.691 550.891 431.691C549.67 431.691 548.78 433.18 548.78 435.985ZM554.384 435.826C554.384 439.327 553.083 441.259 550.797 441.259C548.78 441.259 547.415 439.374 547.383 435.968C547.383 432.515 548.876 430.613 550.972 430.613C553.146 430.613 554.384 432.547 554.384 435.826Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.44 450.337H550.411L548.729 451.243L548.477 450.248L550.59 449.119H551.705V458.771H550.44V450.337Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M549 471.997C549 474.392 549.738 475.753 550.876 475.753C552.154 475.753 552.765 474.265 552.765 471.912C552.765 469.643 552.183 468.154 550.89 468.154C549.796 468.154 549 469.487 549 471.997ZM554.016 471.854C554.016 474.988 552.851 476.717 550.805 476.717C549 476.717 547.779 475.029 547.75 471.982C547.75 468.892 549.086 467.189 550.962 467.189C552.908 467.189 554.016 468.92 554.016 471.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.511 485.606H550.476L548.446 486.7L548.141 485.499L550.691 484.137H552.038V495.786H550.511V485.606Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.31 508.027C548.31 511.301 549.318 513.159 550.871 513.159C552.618 513.159 553.453 511.125 553.453 507.912C553.453 504.813 552.657 502.779 550.891 502.779C549.397 502.779 548.31 504.6 548.31 508.027ZM555.161 507.834C555.161 512.114 553.57 514.476 550.775 514.476C548.31 514.476 546.641 512.172 546.602 508.008C546.602 503.787 548.427 501.463 550.989 501.463C553.648 501.463 555.161 503.825 555.161 507.834Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.631 526.028C548.631 528.898 549.515 530.528 550.877 530.528C552.408 530.528 553.139 528.745 553.139 525.927C553.139 523.211 552.442 521.428 550.894 521.428C549.584 521.428 548.631 523.024 548.631 526.028ZM554.637 525.86C554.637 529.612 553.241 531.683 550.792 531.683C548.63 531.683 547.167 529.663 547.133 526.012C547.133 522.312 548.733 520.273 550.979 520.273C553.309 520.273 554.637 522.345 554.637 525.86Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.466 540.1H550.435L548.624 541.076L548.352 540.005L550.627 538.789H551.829V549.183H550.466V540.1Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.146 562.054C548.146 565.537 549.219 567.515 550.872 567.515C552.73 567.515 553.618 565.351 553.618 561.932C553.618 558.635 552.772 556.471 550.892 556.471C549.303 556.471 548.146 558.409 548.146 562.054ZM555.435 561.85C555.435 566.403 553.742 568.916 550.769 568.916C548.146 568.916 546.37 566.465 546.328 562.035C546.328 557.543 548.27 555.07 550.996 555.07C553.824 555.07 555.435 557.584 555.435 561.85Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.579 574.935H550.537L548.176 576.207L547.82 574.812L550.788 573.227H552.354V586.777H550.579V574.935Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.599 598.061C548.599 600.967 549.494 602.617 550.873 602.617C552.423 602.617 553.164 600.811 553.164 597.958C553.164 595.208 552.459 593.402 550.89 593.402C549.564 593.402 548.599 595.019 548.599 598.061ZM554.68 597.89C554.68 601.689 553.268 603.786 550.787 603.786C548.598 603.786 547.117 601.741 547.082 598.045C547.082 594.298 548.702 592.234 550.976 592.234C553.337 592.234 554.68 594.331 554.68 597.89Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M548.79 616.065C548.79 618.732 549.611 620.246 550.876 620.246C552.299 620.246 552.979 618.589 552.979 615.972C552.979 613.448 552.331 611.791 550.892 611.791C549.676 611.791 548.79 613.274 548.79 616.065ZM554.37 615.909C554.37 619.395 553.074 621.319 550.799 621.319C548.79 621.319 547.431 619.442 547.398 616.05C547.398 612.612 548.886 610.719 550.972 610.719C553.138 610.719 554.37 612.642 554.37 615.909Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M550.452 630.274H550.422L548.673 631.216L548.41 630.182L550.607 629.008H551.768V639.045H550.452V630.274Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.822 359.854H528.789L526.902 360.872L526.617 359.755L528.989 358.488H530.242V369.321H528.822V359.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.268 381.958C527.268 384.446 528.036 385.861 529.216 385.861C530.544 385.861 531.179 384.314 531.179 381.87C531.179 379.513 530.574 377.967 529.23 377.967C528.094 377.967 527.268 379.351 527.268 381.958ZM532.478 381.81C532.478 385.065 531.267 386.861 529.142 386.861C527.268 386.861 525.998 385.108 525.969 381.942C525.969 378.732 527.356 376.965 529.304 376.965C531.326 376.965 532.478 378.762 532.478 381.81Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.748 396.637H528.722L527.191 397.462L526.961 396.556L528.884 395.529H529.9V404.311H528.748V396.637Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.677 417.964C527.677 419.932 528.284 421.05 529.218 421.05C530.268 421.05 530.77 419.827 530.77 417.894C530.77 416.03 530.292 414.807 529.229 414.807C528.331 414.807 527.677 415.901 527.677 417.964ZM531.798 417.847C531.798 420.421 530.84 421.842 529.16 421.842C527.677 421.842 526.672 420.456 526.648 417.951C526.648 415.412 527.747 414.014 529.288 414.014C530.887 414.014 531.798 415.436 531.798 417.847Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.766 432.485H528.738L527.129 433.352L526.887 432.401L528.909 431.32H529.977V440.555H528.766V432.485Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.241 453.991C527.241 456.517 528.021 457.951 529.219 457.951C530.566 457.951 531.211 456.382 531.211 453.901C531.211 451.509 530.597 449.939 529.233 449.939C528.081 449.939 527.241 451.344 527.241 453.991ZM532.529 453.841C532.529 457.145 531.3 458.968 529.144 458.968C527.241 458.968 525.953 457.189 525.922 453.976C525.922 450.718 527.331 448.924 529.308 448.924C531.361 448.924 532.529 450.748 532.529 453.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.774 468.378H528.745L527.079 469.276L526.828 468.291L528.922 467.172H530.028V476.736H528.774V468.378Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M526.905 490.013C526.905 492.966 527.817 494.643 529.216 494.643C530.792 494.643 531.545 492.808 531.545 489.907C531.545 487.112 530.828 485.277 529.234 485.277C527.886 485.277 526.905 486.919 526.905 490.013ZM533.086 489.838C533.086 493.7 531.651 495.832 529.129 495.832C526.905 495.832 525.399 493.752 525.363 489.996C525.363 486.187 527.01 484.09 529.322 484.09C531.72 484.09 533.086 486.222 533.086 489.838Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.75 504.674H528.724L527.188 505.501L526.957 504.593L528.886 503.562H529.905V512.375H528.75V504.674Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M526.997 526.026C526.997 528.864 527.872 530.476 529.218 530.476C530.732 530.476 531.456 528.712 531.456 525.926C531.456 523.24 530.766 521.477 529.234 521.477C527.939 521.477 526.997 523.055 526.997 526.026ZM532.937 525.86C532.937 529.57 531.557 531.618 529.134 531.618C526.997 531.618 525.55 529.621 525.516 526.011C525.516 522.351 527.098 520.336 529.319 520.336C531.624 520.336 532.937 522.383 532.937 525.86Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.861 539.548H528.826L526.756 540.662L526.445 539.44L529.044 538.051H530.417V549.921H528.861V539.548Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.223 562.039C527.223 564.585 528.008 566.031 529.216 566.031C530.574 566.031 531.223 564.449 531.223 561.949C531.223 559.539 530.605 557.957 529.231 557.957C528.068 557.957 527.223 559.373 527.223 562.039ZM532.552 561.889C532.552 565.218 531.315 567.056 529.141 567.056C527.223 567.056 525.925 565.264 525.895 562.025C525.895 558.741 527.314 556.934 529.307 556.934C531.374 556.934 532.552 558.771 532.552 561.889Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.745 576.74H528.719L527.198 577.558L526.969 576.66L528.88 575.639H529.889V584.367H528.745V576.74Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.29 598.053C527.29 600.517 528.05 601.917 529.218 601.917C530.532 601.917 531.16 600.386 531.16 597.967C531.16 595.635 530.562 594.104 529.232 594.104C528.108 594.104 527.29 595.475 527.29 598.053ZM532.446 597.91C532.446 601.13 531.249 602.908 529.146 602.908C527.29 602.908 526.034 601.175 526.004 598.04C526.004 594.863 527.378 593.113 529.306 593.113C531.307 593.113 532.446 594.891 532.446 597.91Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M527.548 616.057C527.548 618.192 528.206 619.404 529.219 619.404C530.357 619.404 530.902 618.077 530.902 615.981C530.902 613.961 530.383 612.635 529.231 612.635C528.257 612.635 527.548 613.822 527.548 616.057ZM532.015 615.931C532.015 618.722 530.978 620.262 529.155 620.262C527.548 620.262 526.459 618.76 526.434 616.044C526.434 613.291 527.624 611.775 529.295 611.775C531.029 611.775 532.015 613.316 532.015 615.931Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.742 630.789H528.717L527.208 631.602L526.98 630.71L528.876 629.697H529.877V638.355H528.742V630.789Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M526.916 652.085C526.916 655.024 527.823 656.692 529.216 656.692C530.783 656.692 531.532 654.866 531.532 651.982C531.532 649.201 530.818 647.375 529.233 647.375C527.892 647.375 526.916 649.01 526.916 652.085ZM533.066 651.913C533.066 655.753 531.638 657.874 529.129 657.874C526.916 657.874 525.419 655.806 525.383 652.069C525.383 648.279 527.022 646.193 529.321 646.193C531.707 646.193 533.066 648.314 533.066 651.913Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M528.77 666.533H528.741L527.105 667.414L526.859 666.448L528.915 665.35H530V674.735H528.77V666.533Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask0_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="504"
                        y="358"
                        width="5"
                        height="12"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M504.84 358.48H508.702V369.677H504.84V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M507.189 359.589H507.154L505.142 360.673L504.84 359.483L507.367 358.133H508.702V369.677H507.189V359.589Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.163 377.838H507.13L505.231 378.861L504.945 377.737L507.332 376.463H508.592V387.361H507.163V377.838Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.116 396.372H507.087L505.433 397.263L505.184 396.285L507.263 395.174H508.36V404.667H507.116V396.372Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.895 417.966C505.895 420.09 506.55 421.297 507.558 421.297C508.691 421.297 509.233 419.977 509.233 417.89C509.233 415.879 508.717 414.559 507.57 414.559C506.6 414.559 505.895 415.741 505.895 417.966ZM510.342 417.841C510.342 420.619 509.309 422.153 507.495 422.153C505.895 422.153 504.811 420.657 504.785 417.954C504.785 415.213 505.97 413.705 507.634 413.705C509.359 413.705 510.342 415.239 510.342 417.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.39 435.985C505.39 438.753 506.244 440.325 507.556 440.325C509.033 440.325 509.739 438.606 509.739 435.887C509.739 433.267 509.067 431.547 507.572 431.547C506.309 431.547 505.39 433.086 505.39 435.985ZM511.184 435.822C511.184 439.441 509.838 441.439 507.475 441.439C505.39 441.439 503.978 439.49 503.945 435.969C503.945 432.399 505.489 430.434 507.656 430.434C509.904 430.434 511.184 432.432 511.184 435.822Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.162 449.918H507.129L505.251 450.929L504.969 449.819L507.328 448.559H508.574V459.333H507.162V449.918Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.673 471.995C505.673 474.405 506.417 475.774 507.559 475.774C508.845 475.774 509.46 474.277 509.46 471.91C509.46 469.629 508.874 468.131 507.573 468.131C506.473 468.131 505.673 469.471 505.673 471.995ZM510.717 471.854C510.717 475.006 509.545 476.745 507.488 476.745C505.672 476.745 504.444 475.048 504.414 471.982C504.414 468.874 505.758 467.162 507.645 467.162C509.602 467.162 510.717 468.902 510.717 471.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.05 487.078H507.027L505.683 487.802L505.48 487.007L507.169 486.105H508.061V493.815H507.05V487.078Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.12 508.024C505.12 511.135 506.08 512.902 507.555 512.902C509.214 512.902 510.008 510.969 510.008 507.915C510.008 504.97 509.252 503.037 507.573 503.037C506.154 503.037 505.12 504.768 505.12 508.024ZM511.631 507.841C511.631 511.908 510.118 514.153 507.463 514.153C505.12 514.153 503.534 511.964 503.496 508.006C503.496 503.994 505.231 501.785 507.666 501.785C510.192 501.785 511.631 504.03 511.631 507.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.106 522.511H507.078L505.462 523.381L505.219 522.426L507.249 521.342H508.321V530.613H507.106V522.511Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.811 544.025C505.811 546.258 506.5 547.527 507.559 547.527C508.75 547.527 509.32 546.139 509.32 543.946C509.32 541.832 508.777 540.443 507.571 540.443C506.552 540.443 505.811 541.686 505.811 544.025ZM510.486 543.894C510.486 546.814 509.4 548.426 507.493 548.426C505.811 548.426 504.672 546.853 504.645 544.012C504.645 541.131 505.891 539.545 507.639 539.545C509.453 539.545 510.486 541.157 510.486 543.894Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.092 558.675H507.065L505.518 559.508L505.285 558.594L507.229 557.555H508.256V566.434H507.092V558.675Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.47 580.049C505.47 582.715 506.292 584.228 507.556 584.228C508.978 584.228 509.657 582.572 509.657 579.955C509.657 577.432 509.01 575.775 507.572 575.775C506.355 575.775 505.47 577.259 505.47 580.049ZM511.048 579.892C511.048 583.377 509.753 585.3 507.478 585.3C505.47 585.3 504.111 583.424 504.078 580.033C504.078 576.595 505.565 574.703 507.651 574.703C509.816 574.703 511.048 576.626 511.048 579.892Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.095 594.679H507.068L505.515 595.515L505.281 594.598L507.232 593.555H508.263V602.467H507.095V594.679Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.343 616.068C505.343 618.896 506.215 620.501 507.556 620.501C509.065 620.501 509.785 618.744 509.785 615.969C509.785 613.292 509.098 611.535 507.572 611.535C506.283 611.535 505.343 613.109 505.343 616.068ZM511.261 615.903C511.261 619.599 509.886 621.64 507.473 621.64C505.343 621.64 503.901 619.649 503.867 616.053C503.867 612.406 505.444 610.398 507.657 610.398C509.953 610.398 511.261 612.439 511.261 615.903Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.105 630.583H507.077L505.473 631.448L505.23 630.5L507.247 629.422H508.312V638.631H507.105V630.583Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M483.939 363.949C483.939 366.453 484.711 367.875 485.9 367.875C487.235 367.875 487.874 366.319 487.874 363.861C487.874 361.49 487.265 359.934 485.914 359.934C484.771 359.934 483.939 361.326 483.939 363.949ZM489.181 363.802C489.181 367.076 487.964 368.883 485.826 368.883C483.94 368.883 482.663 367.12 482.633 363.935C482.633 360.706 484.029 358.928 485.989 358.928C488.023 358.928 489.181 360.735 489.181 363.802Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.46 378.314H485.431L483.753 379.218L483.5 378.226L485.609 377.1H486.722V386.728H485.46V378.314Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M483.674 399.972C483.674 402.812 484.549 404.425 485.898 404.425C487.414 404.425 488.137 402.661 488.137 399.871C488.137 397.182 487.448 395.416 485.914 395.416C484.618 395.416 483.674 396.996 483.674 399.972ZM489.621 399.804C489.621 403.519 488.239 405.569 485.814 405.569C483.674 405.569 482.226 403.568 482.191 399.955C482.191 396.291 483.776 394.273 486 394.273C488.307 394.273 489.621 396.325 489.621 399.804Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.424 414.703H485.397L483.894 415.513L483.668 414.624L485.557 413.615H486.554V422.241H485.424V414.703Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M484.366 435.972C484.366 437.931 484.97 439.044 485.9 439.044C486.945 439.044 487.444 437.827 487.444 435.903C487.444 434.048 486.969 432.83 485.911 432.83C485.017 432.83 484.366 433.92 484.366 435.972ZM488.467 435.856C488.467 438.418 487.515 439.832 485.842 439.832C484.366 439.832 483.367 438.453 483.344 435.96C483.344 433.434 484.436 432.043 485.97 432.043C487.561 432.043 488.467 433.457 488.467 435.856Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.481 450.126H485.45L483.671 451.085L483.402 450.032L485.639 448.838H486.82V459.051H485.481V450.126Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M483.691 472.004C483.691 474.824 484.56 476.427 485.899 476.427C487.405 476.427 488.124 474.674 488.124 471.904C488.124 469.234 487.439 467.48 485.916 467.48C484.629 467.48 483.691 469.049 483.691 472.004ZM489.597 471.837C489.597 475.527 488.225 477.562 485.816 477.562C483.691 477.562 482.252 475.576 482.219 471.987C482.219 468.349 483.792 466.346 486 466.346C488.292 466.346 489.597 468.383 489.597 471.837Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M484.151 490.001C484.151 492.235 484.84 493.505 485.901 493.505C487.093 493.505 487.663 492.116 487.663 489.921C487.663 487.805 487.12 486.416 485.914 486.416C484.894 486.416 484.151 487.66 484.151 490.001ZM488.83 489.869C488.83 492.791 487.743 494.405 485.835 494.405C484.151 494.405 483.011 492.831 482.984 489.988C482.984 487.105 484.231 485.518 485.981 485.518C487.796 485.518 488.83 487.131 488.83 489.869Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.428 504.713H485.402L483.885 505.53L483.656 504.632L485.563 503.613H486.57V512.324H485.428V504.713Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.427 522.739H485.401L483.892 523.552L483.664 522.66L485.561 521.646H486.562V530.308H485.427V522.739Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.443 540.575H485.415L483.826 541.431L483.586 540.492L485.584 539.424H486.638V548.546H485.443V540.575Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.526 557.727H485.491L483.502 558.798L483.203 557.622L485.702 556.287H487.022V567.7H485.526V557.727Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.537 363.944C462.537 366.118 463.207 367.353 464.24 367.353C465.4 367.353 465.955 366.002 465.955 363.866C465.955 361.807 465.427 360.455 464.252 360.455C463.26 360.455 462.537 361.665 462.537 363.944ZM467.091 363.814C467.091 366.659 466.033 368.228 464.176 368.228C462.537 368.228 461.429 366.697 461.402 363.93C461.402 361.124 462.615 359.58 464.318 359.58C466.085 359.58 467.091 361.15 467.091 363.814Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M463.797 378.361H463.768L462.113 379.252L461.863 378.273L463.943 377.162H465.042V386.661H463.797V378.361Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.309 399.964C462.309 402.432 463.069 403.834 464.241 403.834C465.558 403.834 466.187 402.301 466.187 399.877C466.187 397.54 465.588 396.006 464.255 396.006C463.129 396.006 462.309 397.379 462.309 399.964ZM467.475 399.819C467.475 403.046 466.275 404.828 464.168 404.828C462.308 404.828 461.049 403.09 461.02 399.95C461.02 396.766 462.396 395.014 464.329 395.014C466.333 395.014 467.475 396.796 467.475 399.819Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.481 417.97C462.481 420.217 463.174 421.493 464.241 421.493C465.44 421.493 466.012 420.097 466.012 417.89C466.012 415.763 465.466 414.367 464.254 414.367C463.228 414.367 462.481 415.617 462.481 417.97ZM467.185 417.837C467.185 420.775 466.093 422.397 464.175 422.397C462.482 422.397 461.336 420.815 461.309 417.957C461.309 415.059 462.562 413.463 464.321 413.463C466.146 413.463 467.185 415.085 467.185 417.837Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M463.811 432.237H463.781L462.057 433.166L461.797 432.146L463.964 430.988H465.108V440.886H463.811V432.237Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.75 453.98C462.75 455.887 463.338 456.97 464.242 456.97C465.26 456.97 465.747 455.785 465.747 453.912C465.747 452.107 465.283 450.922 464.254 450.922C463.383 450.922 462.75 451.983 462.75 453.98ZM466.742 453.867C466.742 456.361 465.814 457.737 464.187 457.737C462.75 457.737 461.777 456.394 461.754 453.968C461.754 451.508 462.818 450.154 464.31 450.154C465.86 450.154 466.742 451.531 466.742 453.867Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M463.793 468.437H463.765L462.126 469.32L461.879 468.35L463.939 467.25H465.026V476.656H463.793V468.437Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M461.906 490.014C461.906 492.993 462.824 494.684 464.238 494.684C465.827 494.684 466.586 492.834 466.586 489.909C466.586 487.089 465.863 485.238 464.255 485.238C462.896 485.238 461.906 486.895 461.906 490.014ZM468.141 489.838C468.141 493.733 466.693 495.883 464.15 495.883C461.906 495.883 460.388 493.786 460.352 489.997C460.352 486.156 462.013 484.041 464.344 484.041C466.763 484.041 468.141 486.191 468.141 489.838Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M463.779 504.607H463.752L462.185 505.45L461.949 504.524L463.918 503.473H464.958V512.465H463.779V504.607Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M461.667 526.035C461.667 529.318 462.678 531.182 464.236 531.182C465.987 531.182 466.823 529.142 466.823 525.92C466.823 522.813 466.027 520.773 464.255 520.773C462.757 520.773 461.667 522.6 461.667 526.035ZM468.536 525.842C468.536 530.133 466.94 532.503 464.139 532.503C461.667 532.503 459.993 530.192 459.953 526.017C459.953 521.784 461.784 519.453 464.352 519.453C467.018 519.453 468.536 521.822 468.536 525.842Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.149 544.032C462.149 546.699 462.971 548.214 464.237 548.214C465.66 548.214 466.34 546.557 466.34 543.938C466.34 541.413 465.692 539.756 464.253 539.756C463.036 539.756 462.149 541.24 462.149 544.032ZM467.732 543.876C467.732 547.363 466.436 549.287 464.159 549.287C462.15 549.287 460.79 547.41 460.758 544.017C460.758 540.578 462.245 538.684 464.333 538.684C466.499 538.684 467.732 540.608 467.732 543.876Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.55 562.033C462.55 564.193 463.215 565.42 464.24 565.42C465.393 565.42 465.943 564.078 465.943 561.957C465.943 559.912 465.419 558.57 464.252 558.57C463.267 558.57 462.55 559.772 462.55 562.033ZM467.071 561.906C467.071 564.73 466.02 566.289 464.177 566.289C462.549 566.289 461.448 564.769 461.422 562.021C461.422 559.235 462.627 557.701 464.317 557.701C466.072 557.701 467.071 559.26 467.071 561.906Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M462.028 580.052C462.028 582.876 462.898 584.48 464.239 584.48C465.746 584.48 466.465 582.725 466.465 579.953C466.465 577.28 465.779 575.525 464.255 575.525C462.967 575.525 462.028 577.096 462.028 580.052ZM467.939 579.885C467.939 583.577 466.566 585.615 464.156 585.615C462.028 585.615 460.589 583.628 460.555 580.035C460.555 576.393 462.129 574.389 464.339 574.389C466.633 574.389 467.939 576.426 467.939 579.885Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M463.735 595.126H463.711L462.367 595.85L462.164 595.055L463.853 594.152H464.746V601.869H463.735V595.126Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.112 360.622H442.085L440.554 361.446L440.324 360.541L442.247 359.514H443.263V368.298H442.112V360.622Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.153 378.21H442.122L440.396 379.14L440.137 378.119L442.306 376.961H443.45V386.865H442.153V378.21Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.899 399.96C440.899 402.109 441.561 403.33 442.581 403.33C443.728 403.33 444.276 401.995 444.276 399.884C444.276 397.849 443.754 396.514 442.594 396.514C441.613 396.514 440.899 397.709 440.899 399.96ZM445.399 399.832C445.399 402.643 444.353 404.195 442.518 404.195C440.9 404.195 439.804 402.681 439.777 399.947C439.777 397.175 440.976 395.648 442.658 395.648C444.404 395.648 445.399 397.2 445.399 399.832Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.171 414.033H442.14L440.325 415.012L440.051 413.937L442.332 412.719H443.537V423.137H442.171V414.033Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.362 435.987C440.362 438.821 441.235 440.43 442.58 440.43C444.092 440.43 444.815 438.67 444.815 435.886C444.815 433.203 444.127 431.441 442.597 431.441C441.303 431.441 440.362 433.018 440.362 435.987ZM446.295 435.819C446.295 439.525 444.917 441.571 442.497 441.571C440.363 441.571 438.918 439.575 438.883 435.97C438.883 432.315 440.464 430.303 442.682 430.303C444.984 430.303 446.295 432.348 446.295 435.819Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.209 449.636H442.174L440.166 450.718L439.863 449.529L442.387 448.182H443.72V459.711H442.209V449.636Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.77 471.995C440.77 474.308 441.483 475.622 442.581 475.622C443.815 475.622 444.404 474.185 444.404 471.913C444.404 469.723 443.843 468.285 442.594 468.285C441.539 468.285 440.77 469.572 440.77 471.995ZM445.612 471.857C445.612 474.882 444.487 476.552 442.513 476.552C440.769 476.552 439.59 474.923 439.562 471.98C439.562 468.996 440.853 467.354 442.663 467.354C444.542 467.354 445.612 469.024 445.612 471.857Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.185 485.926H442.152L440.271 486.939L439.988 485.827L442.351 484.564H443.6V495.357H442.185V485.926Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M441.177 508.001C441.177 509.798 441.73 510.818 442.583 510.818C443.542 510.818 443.999 509.702 443.999 507.939C443.999 506.238 443.563 505.121 442.593 505.121C441.773 505.121 441.177 506.121 441.177 508.001ZM444.937 507.895C444.937 510.244 444.063 511.541 442.529 511.541C441.176 511.541 440.261 510.276 440.238 507.991C440.238 505.674 441.24 504.398 442.647 504.398C444.106 504.398 444.937 505.694 444.937 507.895Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.245 521.309H442.208L440.031 522.481L439.703 521.195L442.439 519.732H443.882V532.224H442.245V521.309Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.724 544.028C440.724 546.397 441.454 547.743 442.579 547.743C443.843 547.743 444.447 546.271 444.447 543.945C444.447 541.702 443.871 540.23 442.592 540.23C441.512 540.23 440.724 541.548 440.724 544.028ZM445.683 543.889C445.683 546.986 444.531 548.695 442.509 548.695C440.724 548.695 439.517 547.028 439.488 544.014C439.488 540.959 440.809 539.277 442.663 539.277C444.587 539.277 445.683 540.987 445.683 543.889Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.125 562.049C440.125 565.186 441.091 566.966 442.58 566.966C444.253 566.966 445.052 565.018 445.052 561.939C445.052 558.97 444.29 557.022 442.597 557.022C441.167 557.022 440.125 558.766 440.125 562.049ZM446.689 561.865C446.689 565.965 445.164 568.228 442.487 568.228C440.125 568.228 438.526 566.021 438.488 562.031C438.488 557.986 440.237 555.76 442.692 555.76C445.238 555.76 446.689 558.024 446.689 561.865Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.198 575.83H442.164L440.219 576.877L439.926 575.727L442.37 574.422H443.661V585.583H442.198V575.83Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.388 598.06C440.388 600.861 441.251 602.451 442.58 602.451C444.074 602.451 444.788 600.711 444.788 597.962C444.788 595.311 444.108 593.57 442.596 593.57C441.318 593.57 440.388 595.129 440.388 598.06ZM446.249 597.895C446.249 601.556 444.888 603.577 442.497 603.577C440.387 603.577 438.96 601.606 438.926 598.044C438.926 594.432 440.488 592.443 442.68 592.443C444.954 592.443 446.249 594.464 446.249 597.895Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M440.694 616.061C440.694 618.47 441.437 619.838 442.58 619.838C443.865 619.838 444.479 618.341 444.479 615.977C444.479 613.696 443.894 612.199 442.594 612.199C441.494 612.199 440.694 613.539 440.694 616.061ZM445.737 615.919C445.737 619.069 444.565 620.807 442.509 620.807C440.695 620.807 439.467 619.111 439.438 616.047C439.438 612.941 440.78 611.23 442.666 611.23C444.622 611.23 445.737 612.968 445.737 615.919Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.091 630.933H442.066L440.624 631.709L440.406 630.857L442.219 629.889H443.176V638.166H442.091V630.933Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.131 648.566H442.103L440.485 649.436L440.242 648.481L442.274 647.395H443.348V656.675H442.131V648.566Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M442.123 666.645H442.095L440.512 667.497L440.273 666.562L442.263 665.498H443.314V674.587H442.123V666.645Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.475 360.384H420.447L418.806 361.268L418.559 360.297L420.621 359.195H421.71V368.614H420.475V360.384Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M419.285 381.95C419.285 384.039 419.93 385.226 420.921 385.226C422.035 385.226 422.568 383.928 422.568 381.876C422.568 379.898 422.061 378.6 420.933 378.6C419.979 378.6 419.285 379.762 419.285 381.95ZM423.659 381.826C423.659 384.559 422.643 386.067 420.859 386.067C419.285 386.067 418.22 384.596 418.195 381.938C418.195 379.243 419.36 377.76 420.996 377.76C422.693 377.76 423.659 379.268 423.659 381.826Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.503 396.135H420.472L418.707 397.085L418.441 396.041L420.658 394.857H421.829V404.983H420.503V396.135Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.437 417.986C418.437 421.158 419.416 422.959 420.92 422.959C422.612 422.959 423.421 420.989 423.421 417.874C423.421 414.87 422.651 412.898 420.938 412.898C419.491 412.898 418.437 414.663 418.437 417.986ZM425.078 417.799C425.078 421.947 423.536 424.237 420.828 424.237C418.437 424.237 416.82 422.003 416.781 417.967C416.781 413.875 418.551 411.623 421.034 411.623C423.611 411.623 425.078 413.914 425.078 417.799Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M419.12 435.98C419.12 438.283 419.831 439.591 420.923 439.591C422.152 439.591 422.739 438.16 422.739 435.898C422.739 433.718 422.179 432.287 420.936 432.287C419.886 432.287 419.12 433.568 419.12 435.98ZM423.941 435.842C423.941 438.854 422.821 440.516 420.855 440.516C419.12 440.516 417.945 438.895 417.918 435.966C417.918 432.995 419.203 431.359 421.005 431.359C422.875 431.359 423.941 433.022 423.941 435.842Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.545 449.7H420.511L418.532 450.766L418.234 449.595L420.721 448.268H422.033V459.621H420.545V449.7Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.846 472C418.846 474.652 419.664 476.159 420.922 476.159C422.336 476.159 423.012 474.511 423.012 471.906C423.012 469.396 422.368 467.748 420.937 467.748C419.727 467.748 418.846 469.223 418.846 472ZM424.397 471.844C424.397 475.312 423.107 477.226 420.843 477.226C418.845 477.226 417.493 475.359 417.461 471.986C417.461 468.565 418.94 466.682 421.016 466.682C423.17 466.682 424.397 468.596 424.397 471.844Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.679 490.013C418.679 492.877 419.563 494.504 420.921 494.504C422.449 494.504 423.18 492.724 423.18 489.911C423.18 487.2 422.484 485.42 420.937 485.42C419.63 485.42 418.679 487.013 418.679 490.013ZM424.674 489.844C424.674 493.589 423.282 495.657 420.836 495.657C418.678 495.657 417.218 493.64 417.184 489.996C417.184 486.302 418.781 484.268 421.023 484.268C423.35 484.268 424.674 486.336 424.674 489.844Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.39 505.33H420.369L419.139 505.992L418.953 505.265L420.499 504.439H421.316V511.499H420.39V505.33Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M419.121 526.018C419.121 528.316 419.83 529.621 420.92 529.621C422.145 529.621 422.731 528.193 422.731 525.937C422.731 523.762 422.173 522.334 420.933 522.334C419.884 522.334 419.121 523.612 419.121 526.018ZM423.931 525.884C423.931 528.888 422.814 530.546 420.852 530.546C419.121 530.546 417.95 528.928 417.922 526.005C417.922 523.042 419.204 521.41 421.002 521.41C422.868 521.41 423.931 523.068 423.931 525.884Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.483 540.373H420.453L418.769 541.279L418.516 540.284L420.633 539.152H421.751V548.821H420.483V540.373Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.927 562.038C418.927 564.585 419.712 566.031 420.919 566.031C422.278 566.031 422.927 564.448 422.927 561.948C422.927 559.538 422.309 557.955 420.935 557.955C419.772 557.955 418.927 559.372 418.927 562.038ZM424.257 561.889C424.257 565.218 423.019 567.056 420.845 567.056C418.927 567.056 417.628 565.264 417.598 562.024C417.598 558.74 419.018 556.932 421.011 556.932C423.079 556.932 424.257 558.769 424.257 561.889Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.547 580.055C418.547 583.086 419.482 584.807 420.919 584.807C422.535 584.807 423.308 582.924 423.308 579.949C423.308 577.08 422.572 575.197 420.936 575.197C419.554 575.197 418.547 576.883 418.547 580.055ZM424.89 579.878C424.89 583.84 423.416 586.026 420.83 586.026C418.547 586.026 417.002 583.893 416.965 580.038C416.965 576.13 418.655 573.979 421.027 573.979C423.488 573.979 424.89 576.165 424.89 579.878Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M420.472 594.531H420.444L418.822 595.405L418.578 594.447L420.616 593.357H421.692V602.664H420.472V594.531Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418.582 616.07C418.582 619.055 419.503 620.75 420.918 620.75C422.511 620.75 423.272 618.895 423.272 615.964C423.272 613.139 422.547 611.285 420.935 611.285C419.574 611.285 418.582 612.946 418.582 616.07ZM424.829 615.894C424.829 619.797 423.377 621.95 420.83 621.95C418.582 621.95 417.06 619.85 417.023 616.053C417.023 612.204 418.688 610.084 421.024 610.084C423.448 610.084 424.829 612.238 424.829 615.894Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask1_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="396"
                        y="358"
                        width="5"
                        height="12"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M396.645 358.48H400.303V369.371H396.645V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M398.87 359.817H398.836L396.931 360.843L396.645 359.716L399.039 358.438H400.303V369.371H398.87V359.817Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.324 381.958C397.324 384.434 398.088 385.841 399.263 385.841C400.584 385.841 401.215 384.302 401.215 381.87C401.215 379.526 400.614 377.986 399.277 377.986C398.147 377.986 397.324 379.364 397.324 381.958ZM402.508 381.811C402.508 385.05 401.305 386.837 399.19 386.837C397.324 386.837 396.062 385.093 396.031 381.943C396.031 378.749 397.413 376.99 399.351 376.99C401.363 376.99 402.508 378.778 402.508 381.811Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.083 399.972C397.083 402.756 397.942 404.337 399.262 404.337C400.747 404.337 401.457 402.607 401.457 399.873C401.457 397.238 400.781 395.508 399.278 395.508C398.007 395.508 397.083 397.056 397.083 399.972ZM402.91 399.806C402.91 403.447 401.556 405.456 399.18 405.456C397.083 405.456 395.663 403.496 395.629 399.955C395.629 396.364 397.182 394.387 399.361 394.387C401.622 394.387 402.91 396.397 402.91 399.806Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.887 413.674H398.852L396.869 414.742L396.57 413.569L399.062 412.238H400.378V423.618H398.887V413.674Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.199 435.983C397.199 438.617 398.012 440.113 399.261 440.113C400.666 440.113 401.338 438.476 401.338 435.89C401.338 433.396 400.698 431.76 399.276 431.76C398.074 431.76 397.199 433.224 397.199 435.983ZM402.712 435.829C402.712 439.273 401.431 441.173 399.184 441.173C397.199 441.173 395.856 439.319 395.824 435.969C395.824 432.571 397.293 430.701 399.354 430.701C401.494 430.701 402.712 432.602 402.712 435.829Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.879 449.784H398.845L396.906 450.83L396.613 449.682L399.051 448.381H400.338V459.51H398.879V449.784Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.534 471.993C397.534 474.199 398.215 475.453 399.261 475.453C400.439 475.453 401.001 474.082 401.001 471.915C401.001 469.826 400.465 468.455 399.274 468.455C398.267 468.455 397.534 469.682 397.534 471.993ZM402.153 471.862C402.153 474.747 401.081 476.339 399.196 476.339C397.534 476.339 396.41 474.785 396.383 471.979C396.383 469.133 397.614 467.566 399.34 467.566C401.133 467.566 402.153 469.16 402.153 471.862Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.152 490.01C397.152 492.703 397.984 494.234 399.261 494.234C400.699 494.234 401.386 492.56 401.386 489.914C401.386 487.364 400.732 485.689 399.277 485.689C398.048 485.689 397.152 487.188 397.152 490.01ZM402.792 489.85C402.792 493.373 401.482 495.317 399.182 495.317C397.152 495.317 395.779 493.42 395.746 489.993C395.746 486.518 397.249 484.605 399.357 484.605C401.546 484.605 402.792 486.55 402.792 489.85Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M396.926 508.021C396.926 511.007 397.847 512.703 399.263 512.703C400.856 512.703 401.617 510.848 401.617 507.916C401.617 505.09 400.892 503.234 399.28 503.234C397.917 503.234 396.926 504.896 396.926 508.021ZM403.174 507.846C403.174 511.75 401.723 513.904 399.174 513.904C396.925 513.904 395.403 511.803 395.367 508.004C395.367 504.153 397.032 502.033 399.368 502.033C401.793 502.033 403.174 504.188 403.174 507.846Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.458 526.018C397.458 528.325 398.169 529.635 399.263 529.635C400.494 529.635 401.082 528.202 401.082 525.937C401.082 523.754 400.522 522.321 399.277 522.321C398.224 522.321 397.458 523.604 397.458 526.018ZM402.285 525.883C402.285 528.899 401.164 530.563 399.195 530.563C397.458 530.563 396.281 528.939 396.254 526.005C396.254 523.03 397.54 521.393 399.346 521.393C401.219 521.393 402.285 523.057 402.285 525.883Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.749 541.139H398.726L397.4 541.854L397.199 541.069L398.867 540.178H399.748V547.795H398.749V541.139Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.858 558.022H398.826L396.974 559.019L396.695 557.925L399.022 556.682H400.251V567.307H398.858V558.022Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.825 576.392H398.795L397.112 577.298L396.859 576.304L398.974 575.174H400.09V584.83H398.825V576.392Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.96 592.997H398.92L396.583 594.255L396.23 592.874L399.167 591.305H400.718V604.717H398.96V592.997Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M397.596 616.057C397.596 618.187 398.252 619.397 399.262 619.397C400.398 619.397 400.941 618.073 400.941 615.982C400.941 613.966 400.425 612.643 399.275 612.643C398.303 612.643 397.596 613.827 397.596 616.057ZM402.054 615.931C402.054 618.716 401.018 620.253 399.2 620.253C397.596 620.253 396.51 618.754 396.484 616.044C396.484 613.298 397.672 611.785 399.339 611.785C401.069 611.785 402.054 613.322 402.054 615.931Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M398.893 629.724H398.858L396.853 630.804L396.551 629.619L399.071 628.273H400.401V639.779H398.893V629.724Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M396.652 652.092C396.652 655.424 397.68 657.315 399.259 657.315C401.037 657.315 401.886 655.245 401.886 651.975C401.886 648.822 401.077 646.752 399.279 646.752C397.759 646.752 396.652 648.605 396.652 652.092ZM403.625 651.897C403.625 656.252 402.005 658.656 399.162 658.656C396.653 658.656 394.954 656.311 394.914 652.074C394.914 647.778 396.772 645.412 399.379 645.412C402.084 645.412 403.625 647.816 403.625 651.897Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M375.856 363.945C375.856 366.177 376.544 367.445 377.604 367.445C378.795 367.445 379.365 366.058 379.365 363.866C379.365 361.752 378.822 360.365 377.617 360.365C376.599 360.365 375.856 361.607 375.856 363.945ZM380.53 363.813C380.53 366.732 379.444 368.343 377.538 368.343C375.856 368.343 374.718 366.771 374.691 363.931C374.691 361.052 375.936 359.467 377.683 359.467C379.496 359.467 380.53 361.078 380.53 363.813Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M375.764 381.954C375.764 384.307 376.489 385.644 377.606 385.644C378.86 385.644 379.461 384.182 379.461 381.871C379.461 379.643 378.889 378.182 377.619 378.182C376.545 378.182 375.764 379.49 375.764 381.954ZM380.688 381.815C380.688 384.892 379.544 386.59 377.535 386.59C375.763 386.59 374.563 384.933 374.535 381.94C374.535 378.905 375.847 377.234 377.689 377.234C379.6 377.234 380.688 378.933 380.688 381.815Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.178 396.195H377.147L375.41 397.131L375.148 396.103L377.332 394.938H378.484V404.905H377.178V396.195Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M375.683 417.972C375.683 420.425 376.438 421.818 377.602 421.818C378.911 421.818 379.537 420.294 379.537 417.886C379.537 415.563 378.94 414.039 377.617 414.039C376.497 414.039 375.683 415.403 375.683 417.972ZM380.816 417.827C380.816 421.036 379.624 422.806 377.53 422.806C375.682 422.806 374.432 421.078 374.402 417.958C374.402 414.795 375.77 413.053 377.69 413.053C379.682 413.053 380.816 414.824 380.816 417.827Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.089 433.119H377.067L375.753 433.827L375.555 433.05L377.206 432.168H378.077V439.707H377.089V433.119Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M375.244 453.999C375.244 457.01 376.172 458.72 377.601 458.72C379.208 458.72 379.976 456.849 379.976 453.892C379.976 451.042 379.244 449.17 377.619 449.17C376.244 449.17 375.244 450.845 375.244 453.999ZM381.547 453.821C381.547 457.759 380.083 459.932 377.512 459.932C375.244 459.932 373.708 457.812 373.672 453.981C373.672 450.097 375.351 447.959 377.708 447.959C380.154 447.959 381.547 450.133 381.547 453.821Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M376.095 471.988C376.095 473.919 376.69 475.016 377.606 475.016C378.637 475.016 379.129 473.816 379.129 471.919C379.129 470.091 378.66 468.891 377.617 468.891C376.736 468.891 376.095 469.965 376.095 471.988ZM380.138 471.873C380.138 474.399 379.198 475.793 377.55 475.793C376.095 475.793 375.109 474.433 375.086 471.975C375.086 469.484 376.163 468.113 377.676 468.113C379.244 468.113 380.138 469.507 380.138 471.873Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.16 486.409H377.132L375.476 487.301L375.227 486.322L377.307 485.211H378.406V494.712H377.16V486.409Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.111 504.911H377.086L375.66 505.679L375.445 504.836L377.237 503.879H378.183V512.061H377.111V504.911Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.138 522.653H377.111L375.561 523.488L375.328 522.572L377.275 521.531H378.303V530.425H377.138V522.653Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M375.878 544.024C375.878 546.229 376.557 547.481 377.603 547.481C378.781 547.481 379.342 546.111 379.342 543.946C379.342 541.859 378.807 540.488 377.616 540.488C376.61 540.488 375.878 541.715 375.878 544.024ZM380.493 543.894C380.493 546.777 379.421 548.369 377.538 548.369C375.878 548.369 374.753 546.817 374.727 544.012C374.727 541.168 375.956 539.602 377.682 539.602C379.473 539.602 380.493 541.193 380.493 543.894Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask2_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="351"
                        y="358"
                        width="10"
                        height="13"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M351.805 358.48H360.098V370.209H351.805V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask2_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M353.46 363.962C353.46 367.133 354.437 368.934 355.942 368.934C357.634 368.934 358.443 366.964 358.443 363.85C358.443 360.847 357.672 358.877 355.96 358.877C354.513 358.877 353.46 360.641 353.46 363.962ZM360.098 363.774C360.098 367.921 358.556 370.209 355.849 370.209C353.46 370.209 351.843 367.977 351.805 363.943C351.805 359.853 353.573 357.602 356.055 357.602C358.631 357.602 360.098 359.891 360.098 363.774Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M354.215 381.952C354.215 384.16 354.895 385.414 355.943 385.414C357.121 385.414 357.683 384.042 357.683 381.874C357.683 379.784 357.148 378.412 355.956 378.412C354.949 378.412 354.215 379.64 354.215 381.952ZM358.836 381.821C358.836 384.708 357.763 386.301 355.878 386.301C354.215 386.301 353.089 384.747 353.062 381.938C353.062 379.091 354.295 377.523 356.022 377.523C357.816 377.523 358.836 379.117 358.836 381.821Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M353.718 399.972C353.718 402.812 354.593 404.426 355.942 404.426C357.457 404.426 358.181 402.661 358.181 399.871C358.181 397.182 357.491 395.416 355.958 395.416C354.661 395.416 353.718 396.996 353.718 399.972ZM359.664 399.804C359.664 403.519 358.283 405.569 355.858 405.569C353.718 405.569 352.269 403.568 352.234 399.955C352.234 396.291 353.819 394.273 356.043 394.273C358.35 394.273 359.664 396.325 359.664 399.804Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M354.236 417.967C354.236 420.149 354.909 421.389 355.945 421.389C357.109 421.389 357.665 420.033 357.665 417.889C357.665 415.823 357.135 414.467 355.957 414.467C354.961 414.467 354.236 415.681 354.236 417.967ZM358.805 417.838C358.805 420.692 357.744 422.267 355.88 422.267C354.237 422.267 353.124 420.731 353.098 417.954C353.098 415.14 354.315 413.59 356.023 413.59C357.795 413.59 358.805 415.165 358.805 417.838Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.493 432.475H355.466L353.853 433.344L353.609 432.39L355.637 431.307H356.707V440.565H355.493V432.475Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.511 450.31H355.481L353.786 451.224L353.531 450.221L355.661 449.084H356.784V458.807H355.511V450.31Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.634 467.022H355.595L353.295 468.261L352.949 466.901L355.838 465.357H357.363V478.55H355.634V467.022Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.554 485.857H355.521L353.609 486.888L353.32 485.756L355.724 484.473H356.994V495.45H355.554V485.857Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.393 505.519H355.373L354.23 506.133L354.059 505.459L355.494 504.691H356.252V511.247H355.393V505.519Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M353.872 526.024C353.872 528.668 354.687 530.169 355.941 530.169C357.352 530.169 358.026 528.527 358.026 525.931C358.026 523.428 357.383 521.785 355.957 521.785C354.75 521.785 353.872 523.257 353.872 526.024ZM359.406 525.869C359.406 529.325 358.12 531.233 355.863 531.233C353.872 531.233 352.524 529.372 352.492 526.008C352.492 522.598 353.966 520.721 356.036 520.721C358.183 520.721 359.406 522.629 359.406 525.869Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.513 540.316H355.483L353.773 541.237L353.516 540.227L355.665 539.078H356.8V548.893H355.513V540.316Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M354.001 562.038C354.001 564.518 354.765 565.926 355.942 565.926C357.265 565.926 357.897 564.386 357.897 561.951C357.897 559.604 357.295 558.062 355.956 558.062C354.824 558.062 354.001 559.442 354.001 562.038ZM359.192 561.892C359.192 565.134 357.986 566.923 355.869 566.923C354.001 566.923 352.737 565.178 352.707 562.023C352.707 558.825 354.09 557.064 356.031 557.064C358.045 557.064 359.192 558.854 359.192 561.892Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M354.323 580.039C354.323 582.111 354.962 583.288 355.945 583.288C357.051 583.288 357.579 582 357.579 579.966C357.579 578.005 357.076 576.717 355.957 576.717C355.012 576.717 354.323 577.87 354.323 580.039ZM358.661 579.916C358.661 582.626 357.653 584.121 355.885 584.121C354.324 584.121 353.267 582.663 353.242 580.026C353.242 577.354 354.398 575.883 356.02 575.883C357.702 575.883 358.661 577.378 358.661 579.916Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.593 593.527H355.557L353.467 594.653L353.152 593.418L355.778 592.016H357.164V604.005H355.593V593.527Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M355.546 611.971H355.514L353.628 612.987L353.344 611.872L355.714 610.605H356.965V621.432H355.546V611.971Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.793 360.841H333.768L332.34 361.61L332.125 360.765L333.919 359.807H334.867V368.002H333.793V360.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.861 378.172H333.831L332.087 379.112L331.824 378.08L334.016 376.91H335.172V386.917H333.861V378.172Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.921 395.532H333.886L331.84 396.635L331.531 395.425L334.102 394.051H335.46V405.792H333.921V395.532Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.863 414.134H333.832L332.063 415.088L331.797 414.041L334.02 412.854H335.193V423.006H333.863V414.134Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M332.572 435.976C332.572 438.166 333.247 439.409 334.286 439.409C335.455 439.409 336.013 438.05 336.013 435.899C336.013 433.826 335.481 432.465 334.299 432.465C333.3 432.465 332.572 433.683 332.572 435.976ZM337.157 435.847C337.157 438.711 336.092 440.291 334.223 440.291C332.573 440.291 331.456 438.749 331.43 435.963C331.43 433.139 332.651 431.584 334.365 431.584C336.144 431.584 337.157 433.165 337.157 435.847Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.765 451.176H333.743L332.453 451.871L332.258 451.108L333.879 450.242H334.735V457.646H333.765V451.176Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M332.281 471.998C332.281 474.557 333.07 476.011 334.285 476.011C335.65 476.011 336.302 474.421 336.302 471.908C336.302 469.485 335.681 467.895 334.299 467.895C333.131 467.895 332.281 469.318 332.281 471.998ZM337.639 471.847C337.639 475.193 336.394 477.041 334.209 477.041C332.281 477.041 330.976 475.238 330.945 471.983C330.945 468.682 332.373 466.865 334.376 466.865C336.454 466.865 337.639 468.713 337.639 471.847Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M332.745 489.998C332.745 491.963 333.351 493.079 334.283 493.079C335.333 493.079 335.833 491.859 335.833 489.928C335.833 488.067 335.356 486.846 334.295 486.846C333.398 486.846 332.745 487.939 332.745 489.998ZM336.859 489.881C336.859 492.451 335.903 493.87 334.226 493.87C332.745 493.87 331.743 492.485 331.719 489.985C331.719 487.45 332.815 486.055 334.353 486.055C335.95 486.055 336.859 487.473 336.859 489.881Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.791 504.921H333.767L332.346 505.686L332.133 504.846L333.918 503.893H334.86V512.045H333.791V504.921Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.965 521.14H333.927L331.671 522.354L331.332 521.021L334.166 519.508H335.662V532.449H333.965V521.14Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.914 539.674H333.879L331.869 540.755L331.566 539.568L334.092 538.219H335.425V549.752H333.914V539.674Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M333.762 559.259H333.74L332.465 559.945L332.273 559.192L333.875 558.336H334.721V565.652H333.762V559.259Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M332.649 580.038C332.649 582.128 333.293 583.315 334.285 583.315C335.4 583.315 335.933 582.017 335.933 579.965C335.933 577.986 335.425 576.688 334.298 576.688C333.344 576.688 332.649 577.85 332.649 580.038ZM337.024 579.916C337.024 582.649 336.007 584.156 334.224 584.156C332.649 584.156 331.584 582.686 331.559 580.027C331.559 577.332 332.724 575.848 334.36 575.848C336.057 575.848 337.024 577.356 337.024 579.916Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M332.262 598.056C332.262 600.637 333.058 602.103 334.282 602.103C335.66 602.103 336.318 600.499 336.318 597.964C336.318 595.521 335.691 593.916 334.297 593.916C333.12 593.916 332.262 595.353 332.262 598.056ZM337.665 597.903C337.665 601.279 336.411 603.142 334.206 603.142C332.261 603.142 330.945 601.325 330.914 598.04C330.914 594.711 332.354 592.877 334.375 592.877C336.471 592.877 337.665 594.74 337.665 597.903Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.179 360.397H312.151L310.516 361.277L310.27 360.311L312.324 359.213H313.409V368.597H312.179V360.397Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M311.022 381.949C311.022 383.997 311.654 385.161 312.626 385.161C313.719 385.161 314.241 383.888 314.241 381.876C314.241 379.937 313.744 378.664 312.638 378.664C311.703 378.664 311.022 379.803 311.022 381.949ZM315.31 381.827C315.31 384.506 314.315 385.984 312.565 385.984C311.023 385.984 309.978 384.542 309.953 381.936C309.953 379.294 311.096 377.84 312.699 377.84C314.363 377.84 315.31 379.319 315.31 381.827Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.229 395.898H312.196L310.322 396.908L310.039 395.799L312.395 394.541H313.639V405.299H312.229V395.898Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.789 417.97C310.789 420.32 311.514 421.655 312.628 421.655C313.882 421.655 314.481 420.195 314.481 417.887C314.481 415.663 313.91 414.203 312.641 414.203C311.57 414.203 310.789 415.51 310.789 417.97ZM315.706 417.831C315.706 420.904 314.565 422.599 312.559 422.599C310.789 422.599 309.59 420.945 309.562 417.956C309.562 414.926 310.872 413.258 312.712 413.258C314.62 413.258 315.706 414.954 315.706 417.831Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.818 435.977C310.818 438.285 311.53 439.596 312.625 439.596C313.856 439.596 314.445 438.162 314.445 435.895C314.445 433.71 313.884 432.275 312.639 432.275C311.585 432.275 310.818 433.559 310.818 435.977ZM315.649 435.841C315.649 438.86 314.527 440.525 312.557 440.525C310.818 440.525 309.641 438.9 309.613 435.964C309.613 432.987 310.901 431.348 312.707 431.348C314.582 431.348 315.649 433.014 315.649 435.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.206 450.137H312.175L310.4 451.094L310.133 450.043L312.363 448.852H313.541V459.039H312.206V450.137Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.723 471.997C310.723 474.429 311.473 475.811 312.627 475.811C313.924 475.811 314.544 474.3 314.544 471.911C314.544 469.609 313.954 468.098 312.64 468.098C311.531 468.098 310.723 469.45 310.723 471.997ZM315.813 471.853C315.813 475.033 314.631 476.788 312.555 476.788C310.722 476.788 309.482 475.076 309.453 471.983C309.453 468.846 310.809 467.119 312.713 467.119C314.688 467.119 315.813 468.875 315.813 471.853Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.208 486.163H312.178L310.407 487.117L310.141 486.069L312.365 484.881H313.54V495.041H312.208V486.163Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.241 503.817H312.208L310.272 504.859L309.98 503.715L312.413 502.416H313.698V513.525H312.241V503.817Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.21 522.119H312.179L310.381 523.088L310.109 522.025L312.37 520.816H313.564V531.14H312.21V522.119Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.225 539.992H312.193L310.332 540.994L310.051 539.894L312.39 538.645H313.625V549.325H312.225V539.992Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.162 558.668H312.135L310.585 559.503L310.352 558.586L312.3 557.545H313.328V566.443H312.162V558.668Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.905 580.042C310.905 582.24 311.584 583.489 312.626 583.489C313.798 583.489 314.359 582.122 314.359 579.964C314.359 577.884 313.825 576.518 312.639 576.518C311.636 576.518 310.905 577.741 310.905 580.042ZM315.507 579.912C315.507 582.786 314.438 584.373 312.561 584.373C310.905 584.373 309.785 582.825 309.758 580.029C309.758 577.194 310.984 575.633 312.704 575.633C314.489 575.633 315.507 577.219 315.507 579.912Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.2 594.297H312.171L310.44 595.229L310.18 594.206L312.354 593.045H313.502V602.975H312.2V594.297Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.183 616.073C310.183 619.192 311.145 620.963 312.623 620.963C314.287 620.963 315.081 619.025 315.081 615.963C315.081 613.012 314.324 611.074 312.642 611.074C311.218 611.074 310.183 612.809 310.183 616.073ZM316.709 615.89C316.709 619.967 315.193 622.217 312.531 622.217C310.182 622.217 308.593 620.023 308.555 616.056C308.555 612.035 310.294 609.82 312.735 609.82C315.267 609.82 316.709 612.071 316.709 615.89Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.395 634.077C310.395 636.927 311.274 638.546 312.625 638.546C314.146 638.546 314.872 636.775 314.872 633.976C314.872 631.279 314.18 629.508 312.642 629.508C311.341 629.508 310.395 631.093 310.395 634.077ZM316.359 633.91C316.359 637.636 314.974 639.692 312.541 639.692C310.394 639.692 308.941 637.687 308.906 634.061C308.906 630.385 310.496 628.361 312.726 628.361C315.042 628.361 316.359 630.418 316.359 633.91Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M312.277 647.523H312.241L310.137 648.655L309.82 647.413L312.463 646H313.859V658.071H312.277V647.523Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M289.349 363.943C289.349 366.01 289.986 367.184 290.967 367.184C292.07 367.184 292.597 365.9 292.597 363.87C292.597 361.913 292.094 360.629 290.979 360.629C290.035 360.629 289.349 361.778 289.349 363.943ZM293.675 363.82C293.675 366.523 292.67 368.014 290.906 368.014C289.349 368.014 288.294 366.559 288.27 363.93C288.27 361.264 289.422 359.797 291.04 359.797C292.719 359.797 293.675 361.289 293.675 363.82Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.663 376.904H290.622L288.288 378.162L287.938 376.781L290.869 375.215H292.419V388.609H290.663V376.904Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.472 396.931H290.447L289.054 397.682L288.844 396.857L290.595 395.922H291.52V403.92H290.472V396.931Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.633 413.265H290.595L288.42 414.437L288.094 413.151L290.825 411.691H292.269V424.168H290.633V413.265Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M289.512 435.97C289.512 437.833 290.086 438.89 290.969 438.89C291.963 438.89 292.438 437.733 292.438 435.904C292.438 434.141 291.985 432.984 290.98 432.984C290.129 432.984 289.512 434.019 289.512 435.97ZM293.409 435.86C293.409 438.295 292.504 439.638 290.914 439.638C289.511 439.638 288.561 438.328 288.539 435.958C288.539 433.557 289.577 432.234 291.035 432.234C292.548 432.234 293.409 433.579 293.409 435.86Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M288.8 453.995C288.8 456.762 289.653 458.334 290.966 458.334C292.444 458.334 293.149 456.615 293.149 453.897C293.149 451.277 292.476 449.556 290.983 449.556C289.719 449.556 288.8 451.096 288.8 453.995ZM294.593 453.83C294.593 457.45 293.248 459.447 290.884 459.447C288.8 459.447 287.387 457.498 287.355 453.978C287.355 450.409 288.898 448.443 291.064 448.443C293.313 448.443 294.593 450.442 294.593 453.83Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.555 468.099H290.523L288.727 469.067L288.457 468.004L290.713 466.799H291.906V477.108H290.555V468.099Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M288.903 490.009C288.903 492.645 289.716 494.142 290.966 494.142C292.373 494.142 293.045 492.505 293.045 489.917C293.045 487.421 292.404 485.783 290.982 485.783C289.778 485.783 288.903 487.249 288.903 490.009ZM294.42 489.853C294.42 493.3 293.139 495.202 290.888 495.202C288.903 495.202 287.559 493.346 287.527 489.994C287.527 486.594 288.996 484.723 291.06 484.723C293.201 484.723 294.42 486.625 294.42 489.853Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M288.997 508.014C288.997 510.53 289.772 511.958 290.966 511.958C292.309 511.958 292.95 510.395 292.95 507.925C292.95 505.544 292.339 503.98 290.982 503.98C289.832 503.98 288.997 505.38 288.997 508.014ZM294.263 507.865C294.263 511.155 293.039 512.97 290.891 512.97C288.997 512.97 287.714 511.2 287.684 507.999C287.684 504.755 289.086 502.969 291.055 502.969C293.099 502.969 294.263 504.784 294.263 507.865Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M288.976 526.024C288.976 528.567 289.759 530.011 290.965 530.011C292.323 530.011 292.971 528.431 292.971 525.934C292.971 523.527 292.353 521.947 290.981 521.947C289.82 521.947 288.976 523.362 288.976 526.024ZM294.298 525.873C294.298 529.198 293.061 531.033 290.89 531.033C288.975 531.033 287.678 529.243 287.648 526.008C287.648 522.73 289.066 520.924 291.056 520.924C293.122 520.924 294.298 522.759 294.298 525.873Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.528 540.411H290.498L288.832 541.308L288.582 540.324L290.675 539.205H291.78V548.765H290.528V540.411Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.512 558.578H290.484L288.892 559.435L288.652 558.495L290.653 557.426H291.71V566.563H290.512V558.578Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.478 576.92H290.453L289.016 577.694L288.801 576.845L290.606 575.881H291.559V584.124H290.478V576.92Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.499 594.72H290.471L288.938 595.545L288.707 594.639L290.633 593.609H291.653V602.411H290.499V594.72Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask3_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="265"
                        y="358"
                        width="9"
                        height="13"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M265.301 358.48H273.327V370.006H265.301V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask3_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M266.903 363.959C266.903 367.028 267.849 368.771 269.305 368.771C270.944 368.771 271.726 366.865 271.726 363.851C271.726 360.945 270.98 359.037 269.324 359.037C267.922 359.037 266.903 360.744 266.903 363.959ZM273.327 363.777C273.327 367.791 271.835 370.006 269.214 370.006C266.903 370.006 265.337 367.845 265.301 363.941C265.301 359.983 267.011 357.803 269.414 357.803C271.908 357.803 273.327 360.019 273.327 363.777Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M266.881 381.968C266.881 385.062 267.835 386.82 269.303 386.82C270.955 386.82 271.744 384.898 271.744 381.859C271.744 378.929 270.992 377.006 269.322 377.006C267.909 377.006 266.881 378.727 266.881 381.968ZM273.359 381.785C273.359 385.832 271.854 388.065 269.211 388.065C266.881 388.065 265.302 385.886 265.266 381.95C265.266 377.959 266.99 375.762 269.413 375.762C271.927 375.762 273.359 377.995 273.359 381.785Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M266.825 399.977C266.825 403.145 267.802 404.944 269.304 404.944C270.995 404.944 271.802 402.976 271.802 399.865C271.802 396.867 271.032 394.898 269.323 394.898C267.876 394.898 266.825 396.66 266.825 399.977ZM273.455 399.79C273.455 403.932 271.915 406.218 269.21 406.218C266.825 406.218 265.21 403.987 265.172 399.959C265.172 395.874 266.937 393.625 269.417 393.625C271.99 393.625 273.455 395.911 273.455 399.79Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.966 413.348H268.928L266.793 414.499L266.473 413.235L269.154 411.803H270.572V424.055H268.966V413.348Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.854 432.488H268.826L267.218 433.354L266.977 432.403L268.997 431.324H270.064V440.551H268.854V432.488Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.905 449.971H268.872L267.02 450.969L266.742 449.874L269.068 448.631H270.298V459.258H268.905V449.971Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.917 467.843H268.883L266.967 468.875L266.68 467.741L269.086 466.455H270.358V477.451H268.917V467.843Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M267.284 490.006C267.284 492.586 268.08 494.053 269.304 494.053C270.682 494.053 271.34 492.449 271.34 489.915C271.34 487.472 270.713 485.867 269.32 485.867C268.141 485.867 267.284 487.303 267.284 490.006ZM272.687 489.854C272.687 493.229 271.432 495.092 269.227 495.092C267.284 495.092 265.968 493.274 265.938 489.992C265.938 486.663 267.376 484.83 269.396 484.83C271.493 484.83 272.687 486.693 272.687 489.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.843 504.641H268.816L267.264 505.477L267.031 504.559L268.98 503.518H270.011V512.423H268.843V504.641Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M267.357 526.021C267.357 528.511 268.125 529.926 269.306 529.926C270.635 529.926 271.27 528.379 271.27 525.934C271.27 523.577 270.665 522.029 269.321 522.029C268.184 522.029 267.357 523.415 267.357 526.021ZM272.569 525.874C272.569 529.13 271.359 530.927 269.232 530.927C267.357 530.927 266.087 529.174 266.059 526.007C266.059 522.796 267.446 521.027 269.395 521.027C271.417 521.027 272.569 522.825 272.569 525.874Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.819 540.912H268.793L267.36 541.684L267.145 540.837L268.945 539.875H269.896V548.098H268.819V540.912Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.834 558.768H268.808L267.304 559.578L267.078 558.689L268.966 557.68H269.965V566.308H268.834V558.768Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.909 575.985H268.876L267.004 576.993L266.723 575.886L269.074 574.629H270.318V585.375H268.909V575.985Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M267.638 598.049C267.638 600.184 268.295 601.396 269.308 601.396C270.448 601.396 270.992 600.07 270.992 597.974C270.992 595.954 270.473 594.627 269.321 594.627C268.346 594.627 267.638 595.815 267.638 598.049ZM272.105 597.923C272.105 600.714 271.068 602.254 269.245 602.254C267.637 602.254 266.549 600.751 266.523 598.036C266.523 595.283 267.713 593.768 269.384 593.768C271.118 593.768 272.105 595.308 272.105 597.923Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M246.51 616.057C246.51 618.283 247.195 619.547 248.252 619.547C249.44 619.547 250.007 618.164 250.007 615.978C250.007 613.871 249.466 612.488 248.265 612.488C247.249 612.488 246.51 613.727 246.51 616.057ZM251.168 615.927C251.168 618.837 250.086 620.443 248.185 620.443C246.51 620.443 245.374 618.877 245.348 616.045C245.348 613.174 246.588 611.594 248.33 611.594C250.138 611.594 251.168 613.2 251.168 615.927Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.822 612.887H268.796L267.336 613.673L267.117 612.81L268.951 611.83H269.921V620.209H268.822V612.887Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M267.638 634.064C267.638 636.199 268.296 637.411 269.308 637.411C270.448 637.411 270.991 636.085 270.991 633.989C270.991 631.969 270.473 630.643 269.321 630.643C268.346 630.643 267.638 631.83 267.638 634.064ZM272.104 633.938C272.104 636.729 271.067 638.269 269.245 638.269C267.637 638.269 266.549 636.766 266.523 634.052C266.523 631.298 267.713 629.783 269.384 629.783C271.118 629.783 272.104 631.323 272.104 633.938Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M268.93 647.829H268.895L266.935 648.884L266.641 647.725L269.103 646.41H270.404V657.658H268.93V647.829Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M267.133 670.093C267.133 672.87 267.989 674.446 269.306 674.446C270.787 674.446 271.495 672.721 271.495 669.995C271.495 667.367 270.821 665.643 269.322 665.643C268.054 665.643 267.133 667.187 267.133 670.093ZM272.944 669.929C272.944 673.559 271.593 675.562 269.223 675.562C267.133 675.562 265.717 673.608 265.684 670.077C265.684 666.496 267.231 664.525 269.404 664.525C271.659 664.525 272.944 666.528 272.944 669.929Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.225 360.141H247.194L245.44 361.086L245.176 360.048L247.38 358.871H248.545V368.937H247.225V360.141Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.743 381.955C245.743 384.388 246.493 385.77 247.648 385.77C248.947 385.77 249.567 384.259 249.567 381.869C249.567 379.566 248.975 378.053 247.662 378.053C246.551 378.053 245.743 379.406 245.743 381.955ZM250.838 381.811C250.838 384.993 249.654 386.75 247.576 386.75C245.744 386.75 244.502 385.036 244.473 381.941C244.473 378.803 245.83 377.074 247.734 377.074C249.712 377.074 250.838 378.831 250.838 381.811Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.581 399.969C245.581 402.609 246.395 404.109 247.648 404.109C249.058 404.109 249.731 402.468 249.731 399.875C249.731 397.376 249.089 395.734 247.663 395.734C246.457 395.734 245.581 397.203 245.581 399.969ZM251.109 399.812C251.109 403.265 249.825 405.17 247.569 405.17C245.581 405.17 244.235 403.311 244.203 399.953C244.203 396.547 245.675 394.672 247.742 394.672C249.887 394.672 251.109 396.578 251.109 399.812Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.194 414.488H247.166L245.562 415.352L245.32 414.403L247.336 413.326H248.401V422.533H247.194V414.488Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M246.207 435.97C246.207 437.811 246.775 438.856 247.648 438.856C248.631 438.856 249.101 437.713 249.101 435.905C249.101 434.161 248.653 433.018 247.66 433.018C246.818 433.018 246.207 434.041 246.207 435.97ZM250.061 435.862C250.061 438.269 249.166 439.597 247.594 439.597C246.207 439.597 245.268 438.301 245.246 435.959C245.246 433.585 246.273 432.277 247.714 432.277C249.21 432.277 250.061 433.606 250.061 435.862Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.236 450.075H247.204L245.4 451.047L245.129 449.98L247.395 448.77H248.593V459.122H247.236V450.075Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.83 471.995C245.83 474.318 246.547 475.638 247.65 475.638C248.89 475.638 249.482 474.195 249.482 471.912C249.482 469.712 248.917 468.268 247.663 468.268C246.602 468.268 245.83 469.561 245.83 471.995ZM250.695 471.856C250.695 474.895 249.565 476.573 247.58 476.573C245.83 476.573 244.645 474.936 244.617 471.98C244.617 468.983 245.913 467.332 247.732 467.332C249.62 467.332 250.695 469.01 250.695 471.856Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.478 490.011C245.478 492.783 246.332 494.357 247.647 494.357C249.127 494.357 249.833 492.635 249.833 489.913C249.833 487.289 249.16 485.566 247.664 485.566C246.397 485.566 245.478 487.108 245.478 490.011ZM251.28 489.847C251.28 493.472 249.933 495.472 247.565 495.472C245.478 495.472 244.064 493.52 244.031 489.995C244.031 486.42 245.576 484.451 247.746 484.451C249.998 484.451 251.28 486.453 251.28 489.847Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.876 508.01C245.876 510.272 246.574 511.558 247.647 511.558C248.855 511.558 249.431 510.152 249.431 507.93C249.431 505.789 248.881 504.383 247.66 504.383C246.627 504.383 245.876 505.642 245.876 508.01ZM250.611 507.877C250.611 510.835 249.511 512.467 247.579 512.467C245.876 512.467 244.722 510.875 244.695 507.997C244.695 505.079 245.957 503.473 247.727 503.473C249.565 503.473 250.611 505.105 250.611 507.877Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.206 522.415H247.177L245.516 523.309L245.266 522.328L247.352 521.213H248.455V530.744H247.206V522.415Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.274 539.738H247.238L245.26 540.804L244.961 539.634L247.449 538.305H248.763V549.666H247.274V539.738Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.942 562.033C245.942 564.212 246.614 565.45 247.648 565.45C248.811 565.45 249.367 564.096 249.367 561.956C249.367 559.894 248.837 558.539 247.662 558.539C246.666 558.539 245.942 559.752 245.942 562.033ZM250.503 561.904C250.503 564.753 249.444 566.326 247.583 566.326C245.942 566.326 244.831 564.792 244.805 562.02C244.805 559.209 246.02 557.662 247.725 557.662C249.496 557.662 250.503 559.234 250.503 561.904Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M245.175 580.058C245.175 583.215 246.148 585.007 247.645 585.007C249.33 585.007 250.135 583.046 250.135 579.948C250.135 576.96 249.367 574.998 247.664 574.998C246.222 574.998 245.175 576.754 245.175 580.058ZM251.781 579.873C251.781 583.999 250.247 586.277 247.551 586.277C245.175 586.277 243.565 584.056 243.527 580.04C243.527 575.969 245.287 573.729 247.757 573.729C250.322 573.729 251.781 576.006 251.781 579.873Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.212 594.399H247.183L245.5 595.305L245.246 594.31L247.361 593.18H248.479V602.839H247.212V594.399Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M247.235 630.188H247.203L245.414 631.151L245.145 630.094L247.392 628.893H248.58V639.161H247.235V630.188Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask4_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="222"
                        y="358"
                        width="8"
                        height="12"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M222.141 358.48H229.852V369.767H222.141V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask4_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M223.68 363.957C223.68 366.906 224.589 368.581 225.988 368.581C227.562 368.581 228.313 366.748 228.313 363.853C228.313 361.062 227.596 359.229 226.006 359.229C224.659 359.229 223.68 360.869 223.68 363.957ZM229.852 363.783C229.852 367.639 228.418 369.767 225.9 369.767C223.679 369.767 222.175 367.691 222.141 363.94C222.141 360.137 223.784 358.043 226.092 358.043C228.488 358.043 229.852 360.172 229.852 363.783Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.527 378.569H225.5L223.941 379.41L223.707 378.487L225.665 377.441H226.7V386.387H225.527V378.569Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M224.366 399.959C224.366 402.031 225.005 403.208 225.988 403.208C227.094 403.208 227.622 401.921 227.622 399.886C227.622 397.925 227.119 396.637 226 396.637C225.054 396.637 224.366 397.789 224.366 399.959ZM228.704 399.836C228.704 402.546 227.696 404.041 225.927 404.041C224.367 404.041 223.31 402.581 223.285 399.946C223.285 397.274 224.44 395.803 226.062 395.803C227.745 395.803 228.704 397.299 228.704 399.836Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M224.463 417.965C224.463 419.915 225.064 421.022 225.99 421.022C227.03 421.022 227.527 419.81 227.527 417.896C227.527 416.05 227.053 414.838 226.001 414.838C225.11 414.838 224.463 415.922 224.463 417.965ZM228.544 417.848C228.544 420.398 227.596 421.806 225.931 421.806C224.463 421.806 223.468 420.432 223.445 417.952C223.445 415.437 224.532 414.053 226.059 414.053C227.642 414.053 228.544 415.46 228.544 417.848Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.663 431.197H225.624L223.414 432.388L223.082 431.08L225.858 429.598H227.325V442.277H225.663V431.197Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.634 449.494H225.597L223.523 450.611L223.211 449.384L225.817 447.992H227.194V459.897H225.634V449.494Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.619 467.643H225.583L223.575 468.726L223.273 467.537L225.796 466.189H227.13V477.715H225.619V467.643Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.527 486.616H225.5L223.941 487.456L223.707 486.534L225.665 485.488H226.7V494.433H225.527V486.616Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M224.622 508.002C224.622 509.747 225.16 510.739 225.989 510.739C226.92 510.739 227.365 509.654 227.365 507.941C227.365 506.288 226.941 505.203 225.999 505.203C225.202 505.203 224.622 506.174 224.622 508.002ZM228.276 507.898C228.276 510.18 227.427 511.441 225.937 511.441C224.622 511.441 223.731 510.212 223.711 507.991C223.711 505.74 224.684 504.5 226.051 504.5C227.468 504.5 228.276 505.759 228.276 507.898Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.536 522.525H225.508L223.898 523.391L223.656 522.441L225.679 521.359H226.747V530.598H225.536V522.525Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M224.159 544.029C224.159 546.367 224.88 547.695 225.99 547.695C227.238 547.695 227.834 546.243 227.834 543.946C227.834 541.732 227.265 540.279 226.003 540.279C224.935 540.279 224.159 541.58 224.159 544.029ZM229.053 543.89C229.053 546.948 227.917 548.636 225.92 548.636C224.159 548.636 222.965 546.989 222.938 544.015C222.938 540.998 224.242 539.338 226.072 539.338C227.972 539.338 229.053 541.025 229.053 543.89Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225.547 558.443H225.517L223.862 559.334L223.613 558.356L225.693 557.244H226.792V566.745H225.547V558.443Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M224.113 580.044C224.113 582.44 224.852 583.8 225.988 583.8C227.267 583.8 227.878 582.311 227.878 579.96C227.878 577.692 227.296 576.203 226.003 576.203C224.909 576.203 224.113 577.536 224.113 580.044ZM229.128 579.903C229.128 583.035 227.963 584.764 225.917 584.764C224.113 584.764 222.891 583.078 222.863 580.03C222.863 576.94 224.198 575.238 226.074 575.238C228.019 575.238 229.128 576.968 229.128 579.903Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.919 360.016H203.887L202.074 360.993L201.801 359.92L204.079 358.703H205.283V369.107H203.919V360.016Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M202.214 381.96C202.214 384.66 203.046 386.194 204.327 386.194C205.769 386.194 206.457 384.516 206.457 381.864C206.457 379.309 205.8 377.631 204.343 377.631C203.11 377.631 202.214 379.132 202.214 381.96ZM207.866 381.801C207.866 385.332 206.553 387.28 204.247 387.28C202.214 387.28 200.837 385.379 200.805 381.945C200.805 378.462 202.31 376.545 204.423 376.545C206.617 376.545 207.866 378.494 207.866 381.801Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.886 396.379H203.857L202.206 397.268L201.957 396.292L204.031 395.184H205.127V404.656H203.886V396.379Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.944 413.792H203.91L201.981 414.831L201.691 413.69L204.115 412.396H205.395V423.464H203.944V413.792Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.866 432.604H203.838L202.285 433.441L202.051 432.522L204.003 431.479H205.035V440.395H203.866V432.604Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M202.86 453.979C202.86 455.858 203.44 456.926 204.331 456.926C205.335 456.926 205.814 455.758 205.814 453.912C205.814 452.133 205.357 450.965 204.343 450.965C203.484 450.965 202.86 452.01 202.86 453.979ZM206.795 453.868C206.795 456.326 205.881 457.683 204.276 457.683C202.86 457.683 201.901 456.359 201.879 453.967C201.879 451.544 202.927 450.209 204.398 450.209C205.925 450.209 206.795 451.566 206.795 453.868Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M202.697 471.991C202.697 474.076 203.341 475.261 204.33 475.261C205.444 475.261 205.975 473.965 205.975 471.917C205.975 469.942 205.468 468.646 204.343 468.646C203.39 468.646 202.697 469.806 202.697 471.991ZM207.063 471.866C207.063 474.594 206.049 476.1 204.268 476.1C202.698 476.1 201.634 474.631 201.609 471.978C201.609 469.288 202.772 467.807 204.404 467.807C206.099 467.807 207.063 469.313 207.063 471.866Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.88 486.487H203.851L202.232 487.359L201.988 486.401L204.023 485.314H205.098V494.608H203.88V486.487Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.917 504.107H203.885L202.084 505.076L201.812 504.012L204.076 502.803H205.271V513.138H203.917V504.107Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.851 522.795H203.825L202.34 523.594L202.117 522.717L203.981 521.721H204.967V530.236H203.851V522.795Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M201.912 544.041C201.912 547.129 202.864 548.883 204.329 548.883C205.977 548.883 206.764 546.964 206.764 543.932C206.764 541.009 206.014 539.09 204.348 539.09C202.937 539.09 201.912 540.808 201.912 544.041ZM208.376 543.859C208.376 547.897 206.874 550.125 204.237 550.125C201.912 550.125 200.337 547.951 200.301 544.023C200.301 540.041 202.022 537.848 204.438 537.848C206.947 537.848 208.376 540.076 208.376 543.859Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M202.365 562.037C202.365 564.549 203.139 565.975 204.331 565.975C205.672 565.975 206.312 564.414 206.312 561.948C206.312 559.571 205.702 558.01 204.346 558.01C203.199 558.01 202.365 559.407 202.365 562.037ZM207.623 561.89C207.623 565.174 206.402 566.986 204.257 566.986C202.366 566.986 201.084 565.219 201.055 562.023C201.055 558.784 202.455 557 204.421 557C206.462 557 207.623 558.813 207.623 561.89Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M202.74 580.039C202.74 582.072 203.368 583.228 204.331 583.228C205.417 583.228 205.936 581.964 205.936 579.968C205.936 578.043 205.441 576.779 204.344 576.779C203.416 576.779 202.74 577.911 202.74 580.039ZM206.996 579.919C206.996 582.577 206.008 584.044 204.272 584.044C202.741 584.044 201.704 582.614 201.68 580.026C201.68 577.404 202.813 575.961 204.404 575.961C206.056 575.961 206.996 577.428 206.996 579.919Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.858 594.756H203.831L202.314 595.573L202.086 594.677L203.992 593.658H204.999V602.363H203.858V594.756Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.889 612.443H203.859L202.192 613.34L201.941 612.355L204.036 611.236H205.142V620.801H203.889V612.443Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M203.895 630.402H203.865L202.176 631.312L201.922 630.314L204.044 629.18H205.166V638.873H203.895V630.402Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M201.891 652.09C201.891 655.203 202.85 656.971 204.327 656.971C205.988 656.971 206.781 655.037 206.781 651.981C206.781 649.034 206.025 647.1 204.345 647.1C202.924 647.1 201.891 648.831 201.891 652.09ZM208.405 651.908C208.405 655.976 206.892 658.223 204.234 658.223C201.891 658.223 200.303 656.032 200.266 652.072C200.266 648.058 202.001 645.848 204.437 645.848C206.966 645.848 208.405 648.094 208.405 651.908Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M201.777 670.1C201.777 673.356 202.782 675.206 204.326 675.206C206.065 675.206 206.895 673.182 206.895 669.985C206.895 666.903 206.103 664.879 204.345 664.879C202.859 664.879 201.777 666.691 201.777 670.1ZM208.594 669.908C208.594 674.165 207.011 676.515 204.23 676.515C201.778 676.515 200.117 674.224 200.078 670.081C200.078 665.881 201.893 663.568 204.442 663.568C207.088 663.568 208.594 665.919 208.594 669.908Z"
                        fill="#FF1236"
                      />
                      <mask
                        id="mask5_715_56015"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="178"
                        y="358"
                        width="9"
                        height="12"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M178.938 358.48H186.42V369.593H178.938V358.48Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask5_715_56015)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M180.431 363.956C180.431 366.816 181.313 368.442 182.67 368.442C184.198 368.442 184.927 366.664 184.927 363.854C184.927 361.145 184.231 359.367 182.687 359.367C181.38 359.367 180.431 360.958 180.431 363.956ZM186.42 363.786C186.42 367.528 185.029 369.593 182.585 369.593C180.431 369.593 178.971 367.578 178.938 363.939C178.938 360.248 180.533 358.217 182.773 358.217C185.097 358.217 186.42 360.282 186.42 363.786Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.304 377.594H182.268L180.255 378.678L179.953 377.488L182.482 376.137H183.818V387.689H182.304V377.594Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.468 399.972C180.468 402.784 181.335 404.381 182.669 404.381C184.17 404.381 184.887 402.634 184.887 399.872C184.887 397.21 184.203 395.463 182.686 395.463C181.402 395.463 180.468 397.027 180.468 399.972ZM186.354 399.805C186.354 403.482 184.986 405.512 182.585 405.512C180.467 405.512 179.033 403.532 179 399.955C179 396.329 180.567 394.332 182.768 394.332C185.053 394.332 186.354 396.362 186.354 399.805Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.248 414.166H182.217L180.463 415.111L180.199 414.073L182.403 412.896H183.568V422.962H182.248V414.166Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.862 435.978C180.862 438.29 181.575 439.602 182.672 439.602C183.905 439.602 184.495 438.166 184.495 435.896C184.495 433.708 183.933 432.271 182.685 432.271C181.63 432.271 180.862 433.557 180.862 435.978ZM185.701 435.842C185.701 438.865 184.577 440.532 182.603 440.532C180.863 440.532 179.684 438.906 179.656 435.965C179.656 432.984 180.945 431.342 182.754 431.342C184.632 431.342 185.701 433.011 185.701 435.842Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.229 450.367H182.2L180.531 451.266L180.281 450.28L182.377 449.16H183.484V458.731H182.229V450.367Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.202 468.654H182.175L180.637 469.483L180.406 468.573L182.338 467.541H183.359V476.368H182.202V468.654Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.211 486.618H182.183L180.625 487.458L180.391 486.536L182.348 485.49H183.383V494.432H182.211V486.618Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.858 508.012C180.858 510.33 181.573 511.648 182.673 511.648C183.911 511.648 184.502 510.207 184.502 507.93C184.502 505.736 183.939 504.295 182.687 504.295C181.629 504.295 180.858 505.585 180.858 508.012ZM185.712 507.875C185.712 510.906 184.584 512.58 182.605 512.58C180.858 512.58 179.676 510.948 179.648 507.998C179.648 505.008 180.941 503.361 182.756 503.361C184.639 503.361 185.712 505.034 185.712 507.875Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.307 521.634H182.271L180.246 522.723L179.941 521.527L182.485 520.168H183.83V531.787H182.307V521.634Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M181.051 544.022C181.051 546.095 181.69 547.273 182.674 547.273C183.78 547.273 184.309 545.984 184.309 543.948C184.309 541.986 183.805 540.697 182.686 540.697C181.739 540.697 181.051 541.851 181.051 544.022ZM185.392 543.9C185.392 546.611 184.383 548.107 182.612 548.107C181.051 548.107 179.993 546.647 179.969 544.01C179.969 541.335 181.125 539.863 182.748 539.863C184.432 539.863 185.392 541.36 185.392 543.9Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.445 562.045C180.445 564.888 181.322 566.503 182.67 566.503C184.189 566.503 184.914 564.737 184.914 561.945C184.914 559.253 184.222 557.486 182.688 557.486C181.389 557.486 180.445 559.068 180.445 562.045ZM186.397 561.877C186.397 565.595 185.015 567.646 182.586 567.646C180.445 567.646 178.995 565.645 178.961 562.028C178.961 558.361 180.546 556.342 182.771 556.342C185.081 556.342 186.397 558.394 186.397 561.877Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.26 576.123H182.228L180.42 577.097L180.148 576.028L182.42 574.814H183.62V585.191H182.26V576.123Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.993 598.048C180.993 600.191 181.653 601.407 182.67 601.407C183.813 601.407 184.359 600.077 184.359 597.973C184.359 595.945 183.839 594.613 182.683 594.613C181.704 594.613 180.993 595.805 180.993 598.048ZM185.478 597.923C185.478 600.724 184.436 602.27 182.606 602.27C180.993 602.27 179.901 600.762 179.875 598.037C179.875 595.273 181.069 593.752 182.746 593.752C184.487 593.752 185.478 595.299 185.478 597.923Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.214 612.618H182.186L180.601 613.471L180.363 612.535L182.354 611.471H183.406V620.564H182.214V612.618Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.323 634.08C180.323 637.079 181.248 638.782 182.67 638.782C184.27 638.782 185.035 636.919 185.035 633.975C185.035 631.137 184.306 629.273 182.688 629.273C181.318 629.273 180.323 630.941 180.323 634.08ZM186.599 633.904C186.599 637.824 185.14 639.987 182.58 639.987C180.323 639.987 178.793 637.877 178.758 634.062C178.758 630.196 180.43 628.066 182.776 628.066C185.212 628.066 186.599 630.23 186.599 633.904Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M182.207 648.705H182.179L180.627 649.541L180.395 648.624L182.344 647.582H183.374V656.487H182.207V648.705Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.118 363.948C159.118 366.367 159.864 367.74 161.011 367.74C162.302 367.74 162.918 366.238 162.918 363.864C162.918 361.574 162.33 360.07 161.026 360.07C159.921 360.07 159.118 361.416 159.118 363.948ZM164.18 363.805C164.18 366.968 163.004 368.713 160.939 368.713C159.118 368.713 157.884 367.01 157.855 363.934C157.855 360.815 159.203 359.098 161.097 359.098C163.061 359.098 164.18 360.844 164.18 363.805Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.588 378.155H160.557L158.806 379.098L158.543 378.062L160.743 376.887H161.906V386.936H160.588V378.155Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M158.524 399.978C158.524 403.151 159.502 404.954 161.009 404.954C162.702 404.954 163.511 402.982 163.511 399.866C163.511 396.861 162.74 394.889 161.027 394.889C159.578 394.889 158.524 396.654 158.524 399.978ZM165.167 399.789C165.167 403.94 163.624 406.23 160.914 406.23C158.524 406.23 156.905 403.995 156.867 399.958C156.867 395.865 158.636 393.611 161.121 393.611C163.699 393.611 165.167 395.903 165.167 399.789Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.248 417.97C159.248 420.224 159.943 421.505 161.013 421.505C162.216 421.505 162.791 420.105 162.791 417.89C162.791 415.755 162.243 414.354 161.027 414.354C159.997 414.354 159.248 415.608 159.248 417.97ZM163.968 417.836C163.968 420.785 162.871 422.412 160.946 422.412C159.248 422.412 158.097 420.825 158.07 417.957C158.07 415.048 159.328 413.447 161.092 413.447C162.924 413.447 163.968 415.075 163.968 417.836Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.266 435.975C159.266 438.206 159.954 439.473 161.012 439.473C162.203 439.473 162.771 438.087 162.771 435.896C162.771 433.785 162.228 432.398 161.025 432.398C160.006 432.398 159.266 433.639 159.266 435.975ZM163.935 435.844C163.935 438.761 162.85 440.371 160.945 440.371C159.266 440.371 158.128 438.8 158.102 435.963C158.102 433.086 159.345 431.502 161.091 431.502C162.903 431.502 163.935 433.112 163.935 435.844Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.065 453.99C159.065 456.473 159.831 457.883 161.009 457.883C162.335 457.883 162.968 456.341 162.968 453.902C162.968 451.551 162.364 450.008 161.024 450.008C159.89 450.008 159.065 451.389 159.065 453.99ZM164.263 453.843C164.263 457.09 163.056 458.883 160.935 458.883C159.066 458.883 157.799 457.135 157.77 453.975C157.77 450.773 159.154 449.01 161.098 449.01C163.115 449.01 164.263 450.802 164.263 453.843Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.638 467.703H160.602L158.622 468.77L158.324 467.599L160.812 466.27H162.127V477.636H160.638V467.703Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.59 486.21H160.558L158.81 487.152L158.547 486.117L160.744 484.943H161.905V494.98H160.59V486.21Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.14 508.011C159.14 510.404 159.878 511.763 161.013 511.763C162.29 511.763 162.9 510.276 162.9 507.927C162.9 505.662 162.318 504.176 161.027 504.176C159.935 504.176 159.14 505.507 159.14 508.011ZM164.148 507.871C164.148 510.999 162.985 512.725 160.941 512.725C159.14 512.725 157.919 511.041 157.891 507.997C157.891 504.912 159.224 503.213 161.098 503.213C163.041 503.213 164.148 504.939 164.148 507.871Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M158.951 526.024C158.951 528.655 159.762 530.149 161.01 530.149C162.414 530.149 163.085 528.514 163.085 525.931C163.085 523.441 162.445 521.806 161.026 521.806C159.824 521.806 158.951 523.27 158.951 526.024ZM164.457 525.869C164.457 529.309 163.178 531.207 160.932 531.207C158.951 531.207 157.609 529.356 157.578 526.009C157.578 522.616 159.044 520.748 161.104 520.748C163.241 520.748 164.457 522.646 164.457 525.869Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M158.53 544.042C158.53 547.207 159.506 549.004 161.008 549.004C162.696 549.004 163.503 547.038 163.503 543.931C163.503 540.935 162.734 538.969 161.026 538.969C159.581 538.969 158.53 540.73 158.53 544.042ZM165.155 543.857C165.155 547.994 163.616 550.278 160.914 550.278C158.531 550.278 156.917 548.05 156.879 544.024C156.879 539.943 158.643 537.695 161.12 537.695C163.691 537.695 165.155 539.98 165.155 543.857Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M159.486 562.027C159.486 563.977 160.088 565.084 161.012 565.084C162.052 565.084 162.549 563.872 162.549 561.958C162.549 560.113 162.075 558.902 161.023 558.902C160.133 558.902 159.486 559.987 159.486 562.027ZM163.566 561.913C163.566 564.461 162.618 565.868 160.954 565.868C159.486 565.868 158.492 564.496 158.469 562.016C158.469 559.502 159.555 558.119 161.081 558.119C162.664 558.119 163.566 559.525 163.566 561.913Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.615 575.98H160.582L158.708 576.989L158.426 575.881L160.781 574.623H162.026V585.381H160.615V575.98Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.56 594.564H160.532L158.925 595.429L158.684 594.479L160.702 593.4H161.768V602.619H160.56V594.564Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M160.515 613.028H160.491L159.097 613.779L158.887 612.955L160.638 612.02H161.564V620.018H160.515V613.028Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M158.726 634.078C158.726 636.995 159.625 638.652 161.009 638.652C162.566 638.652 163.31 636.839 163.31 633.975C163.31 631.214 162.601 629.4 161.026 629.4C159.694 629.4 158.726 631.024 158.726 634.078ZM164.832 633.906C164.832 637.72 163.414 639.826 160.923 639.826C158.726 639.826 157.237 637.772 157.203 634.06C157.203 630.298 158.829 628.227 161.113 628.227C163.482 628.227 164.832 630.332 164.832 633.906Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.873 360.724H138.847L137.364 361.523L137.141 360.646L139.004 359.65H139.989V368.161H138.873V360.724Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.496 381.956C137.496 384.328 138.227 385.676 139.353 385.676C140.619 385.676 141.224 384.202 141.224 381.873C141.224 379.627 140.648 378.152 139.367 378.152C138.283 378.152 137.496 379.472 137.496 381.956ZM142.462 381.815C142.462 384.918 141.308 386.629 139.283 386.629C137.496 386.629 136.286 384.959 136.258 381.942C136.258 378.882 137.58 377.197 139.437 377.197C141.364 377.197 142.462 378.91 142.462 381.815Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.065 399.973C137.065 402.889 137.965 404.546 139.349 404.546C140.906 404.546 141.65 402.734 141.65 399.869C141.65 397.108 140.94 395.295 139.366 395.295C138.034 395.295 137.065 396.918 137.065 399.973ZM143.172 399.799C143.172 403.615 141.754 405.72 139.263 405.72C137.066 405.72 135.578 403.665 135.543 399.955C135.543 396.192 137.17 394.121 139.453 394.121C141.822 394.121 143.172 396.227 143.172 399.799Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.989 417.96C137.989 419.704 138.527 420.695 139.355 420.695C140.286 420.695 140.731 419.611 140.731 417.898C140.731 416.246 140.307 415.162 139.365 415.162C138.569 415.162 137.989 416.132 137.989 417.96ZM141.641 417.857C141.641 420.138 140.792 421.397 139.303 421.397C137.989 421.397 137.099 420.169 137.078 417.949C137.078 415.7 138.05 414.461 139.416 414.461C140.833 414.461 141.641 415.72 141.641 417.857Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.832 433.184H138.809L137.526 433.875L137.332 433.116L138.945 432.254H139.797V439.621H138.832V433.184Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M136.623 454.007C136.623 457.49 137.698 459.47 139.35 459.47C141.21 459.47 142.098 457.305 142.098 453.883C142.098 450.585 141.251 448.42 139.371 448.42C137.78 448.42 136.623 450.358 136.623 454.007ZM143.916 453.802C143.916 458.358 142.222 460.872 139.247 460.872C136.623 460.872 134.846 458.419 134.805 453.987C134.805 449.493 136.747 447.02 139.474 447.02C142.305 447.02 143.916 449.535 143.916 453.802Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.895 468.546H138.866L137.278 469.402L137.039 468.462L139.035 467.396H140.089V476.509H138.895V468.546Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.943 486.047H138.911L137.087 487.03L136.812 485.95L139.104 484.727H140.315V495.195H138.943V486.047Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M139.052 502.962H139.011L136.676 504.218L136.324 502.839L139.258 501.271H140.808V514.669H139.052V502.962Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M136.944 526.032C136.944 529.106 137.891 530.85 139.348 530.85C140.989 530.85 141.772 528.941 141.772 525.925C141.772 523.016 141.025 521.107 139.367 521.107C137.964 521.107 136.944 522.816 136.944 526.032ZM143.375 525.852C143.375 529.869 141.881 532.086 139.258 532.086C136.944 532.086 135.377 529.924 135.34 526.015C135.34 522.053 137.053 519.871 139.458 519.871C141.953 519.871 143.375 522.088 143.375 525.852Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.923 540.289H138.893L137.17 541.216L136.91 540.198L139.076 539.041H140.22V548.931H138.923V540.289Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.506 562.034C137.506 564.396 138.234 565.737 139.354 565.737C140.615 565.737 141.217 564.27 141.217 561.951C141.217 559.716 140.643 558.248 139.369 558.248C138.29 558.248 137.506 559.562 137.506 562.034ZM142.448 561.896C142.448 564.983 141.3 566.687 139.283 566.687C137.506 566.687 136.301 565.025 136.273 562.021C136.273 558.976 137.589 557.299 139.438 557.299C141.356 557.299 142.448 559.003 142.448 561.896Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.853 577.058H138.829L137.457 577.797L137.25 576.986L138.974 576.064H139.885V583.939H138.853V577.058Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M138.997 593.576H138.961L136.893 594.689L136.582 593.468L139.179 592.08H140.551V603.94H138.997V593.576Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.283 360.011H117.251L115.436 360.988L115.164 359.915L117.443 358.697H118.648V369.11H117.283V360.011Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.281 378.067H117.25L115.457 379.033L115.188 377.973L117.439 376.77H118.63V387.057H117.281V378.067Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.214 396.743H117.189L115.706 397.541L115.484 396.664L117.345 395.67H118.329V404.172H117.214V396.743Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.698 417.975C115.698 420.525 116.484 421.974 117.694 421.974C119.056 421.974 119.706 420.389 119.706 417.884C119.706 415.47 119.086 413.885 117.71 413.885C116.544 413.885 115.698 415.304 115.698 417.975ZM121.038 417.824C121.038 421.16 119.797 423 117.619 423C115.699 423 114.397 421.205 114.367 417.96C114.367 414.67 115.789 412.859 117.785 412.859C119.857 412.859 121.038 414.7 121.038 417.824Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.064 435.997C115.064 439.352 116.098 441.257 117.69 441.257C119.48 441.257 120.336 439.173 120.336 435.878C120.336 432.702 119.52 430.617 117.71 430.617C116.178 430.617 115.064 432.483 115.064 435.997ZM122.087 435.798C122.087 440.186 120.455 442.607 117.591 442.607C115.064 442.607 113.352 440.245 113.312 435.977C113.312 431.65 115.183 429.268 117.809 429.268C120.534 429.268 122.087 431.689 122.087 435.798Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M116.281 453.978C116.281 455.782 116.837 456.806 117.693 456.806C118.656 456.806 119.116 455.686 119.116 453.915C119.116 452.207 118.677 451.086 117.704 451.086C116.88 451.086 116.281 452.089 116.281 453.978ZM120.057 453.871C120.057 456.229 119.18 457.531 117.64 457.531C116.281 457.531 115.362 456.261 115.34 453.966C115.34 451.64 116.345 450.359 117.757 450.359C119.222 450.359 120.057 451.662 120.057 453.871Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.811 471.997C115.811 474.404 116.554 475.771 117.695 475.771C118.981 475.771 119.594 474.276 119.594 471.912C119.594 469.633 119.009 468.137 117.71 468.137C116.61 468.137 115.811 469.476 115.811 471.997ZM120.85 471.854C120.85 475.002 119.679 476.74 117.624 476.74C115.811 476.74 114.583 475.045 114.555 471.983C114.555 468.877 115.896 467.168 117.781 467.168C119.737 467.168 120.85 468.906 120.85 471.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.25 486.43H117.221L115.575 487.317L115.328 486.343L117.396 485.238H118.488V494.684H117.25V486.43Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.24 504.559H117.211L115.621 505.415L115.383 504.476L117.379 503.408H118.435V512.531H117.24V504.559Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M117.249 522.456H117.22L115.578 523.341L115.332 522.37L117.394 521.268H118.484V530.689H117.249V522.456Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.376 544.039C115.376 546.999 116.288 548.68 117.692 548.68C119.272 548.68 120.026 546.84 120.026 543.935C120.026 541.134 119.307 539.295 117.71 539.295C116.359 539.295 115.376 540.942 115.376 544.039ZM121.571 543.864C121.571 547.733 120.132 549.869 117.605 549.869C115.376 549.869 113.867 547.786 113.832 544.022C113.832 540.205 115.481 538.104 117.798 538.104C120.202 538.104 121.571 540.239 121.571 543.864Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.811 562.037C115.811 564.444 116.553 565.811 117.694 565.811C118.979 565.811 119.592 564.315 119.592 561.953C119.592 559.675 119.007 558.18 117.708 558.18C116.609 558.18 115.811 559.518 115.811 562.037ZM120.847 561.896C120.847 565.041 119.677 566.778 117.622 566.778C115.81 566.778 114.583 565.085 114.555 562.023C114.555 558.919 115.895 557.211 117.779 557.211C119.734 557.211 120.847 558.947 120.847 561.896Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.5692 360.594H95.5413L93.998 361.425L93.7656 360.512L95.7051 359.477H96.73V368.334H95.5692V360.594Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6651 377.614H95.6297L93.6262 378.694L93.3242 377.508L95.8421 376.164H97.1724V387.661H95.6651V377.614Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6395 395.891H95.6063L93.7279 396.903L93.4453 395.792L95.8056 394.531H97.0525V405.309H95.6395V395.891Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.5705 414.607H95.5431L93.9947 415.442L93.7617 414.525L95.7075 413.486H96.7352V422.373H95.5705V414.607Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.701 431.263H95.6627L93.484 432.436L93.1562 431.148L95.8934 429.686H97.3396V442.187H95.701V431.263Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M94.6875 453.977C94.6875 455.699 95.2185 456.677 96.0355 456.677C96.9553 456.677 97.3938 455.607 97.3938 453.916C97.3938 452.285 96.9753 451.215 96.0464 451.215C95.259 451.215 94.6875 452.173 94.6875 453.977ZM98.2927 453.874C98.2927 456.126 97.4557 457.37 95.9843 457.37C94.6877 457.37 93.809 456.157 93.7891 453.966C93.7891 451.745 94.7488 450.521 96.0974 450.521C97.4962 450.521 98.2927 451.765 98.2927 453.874Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.4946 469.404H95.4735L94.2853 470.044L94.1055 469.341L95.5996 468.543H96.3887V475.364H95.4946V469.404Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M93.9863 490.01C93.9863 492.624 94.7919 494.109 96.0326 494.109C97.4286 494.109 98.0949 492.485 98.0949 489.917C98.0949 487.441 97.4594 485.816 96.048 485.816C94.8542 485.816 93.9863 487.271 93.9863 490.01ZM99.4593 489.854C99.4593 493.273 98.1878 495.16 95.9548 495.16C93.9862 495.16 92.6519 493.32 92.6211 489.993C92.6211 486.621 94.0787 484.764 96.1256 484.764C98.25 484.764 99.4593 486.651 99.4593 489.854Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M93.7656 508.02C93.7656 510.919 94.6586 512.564 96.034 512.564C97.5807 512.564 98.3195 510.763 98.3195 507.918C98.3195 505.176 97.6144 503.375 96.0511 503.375C94.7277 503.375 93.7656 504.988 93.7656 508.02ZM99.8309 507.85C99.8309 511.638 98.4218 513.729 95.9479 513.729C93.7658 513.729 92.2876 511.69 92.2539 508.003C92.2539 504.267 93.8691 502.209 96.1363 502.209C98.4903 502.209 99.8309 504.3 99.8309 507.85Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.5932 522.398H95.5635L93.8957 523.296L93.6445 522.311L95.7405 521.191H96.8475V530.762H95.5932V522.398Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M93.3056 544.046C93.3056 547.528 94.379 549.505 96.0302 549.505C97.8886 549.505 98.7758 547.341 98.7758 543.924C98.7758 540.628 97.9297 538.465 96.0519 538.465C94.4612 538.465 93.3056 540.402 93.3056 544.046ZM100.593 543.841C100.593 548.393 98.8997 550.905 95.9268 550.905C93.3056 550.905 91.53 548.455 91.4883 544.026C91.4883 539.537 93.4289 537.064 96.1535 537.064C98.9819 537.064 100.593 539.577 100.593 543.841Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M93.6416 562.047C93.6416 565.101 94.5825 566.836 96.0322 566.836C97.6622 566.836 98.4404 564.939 98.4404 561.94C98.4404 559.048 97.6982 557.15 96.0504 557.15C94.655 557.15 93.6416 558.85 93.6416 562.047ZM100.034 561.868C100.034 565.86 98.5494 568.064 95.9407 568.064C93.6415 568.064 92.0834 565.915 92.0469 562.03C92.0469 558.091 93.7494 555.922 96.14 555.922C98.6213 555.922 100.034 558.126 100.034 561.868Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M94.2549 580.043C94.2549 582.314 94.9554 583.604 96.0322 583.604C97.2444 583.604 97.8233 582.192 97.8233 579.963C97.8233 577.814 97.2712 576.402 96.0465 576.402C95.0085 576.402 94.2549 577.666 94.2549 580.043ZM99.0082 579.909C99.0082 582.878 97.9045 584.516 95.965 584.516C94.255 584.516 93.0971 582.918 93.0703 580.029C93.0703 577.101 94.3361 575.488 96.1135 575.488C97.9576 575.488 99.0082 577.127 99.0082 579.909Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6041 594.32H95.5732L93.853 595.246L93.5938 594.23L95.7559 593.074H96.8984V602.948H95.6041V594.32Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6295 612.072H95.597L93.7579 613.062L93.4805 611.975L95.7917 610.74H97.0129V621.295H95.6295V612.072Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6596 629.767H95.6242L93.6384 630.836L93.3398 629.662L95.8349 628.33H97.1526V639.725H95.6596V629.767Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M93.749 652.086C93.749 655.003 94.6483 656.659 96.0322 656.659C97.5892 656.659 98.3326 654.847 98.3326 651.983C98.3326 649.223 97.6235 647.41 96.0494 647.41C94.7173 647.41 93.749 649.033 93.749 652.086ZM99.8538 651.914C99.8538 655.728 98.4356 657.833 95.9451 657.833C93.7487 657.833 92.2614 655.78 92.2266 652.069C92.2266 648.308 93.8526 646.236 96.1353 646.236C98.5047 646.236 99.8538 648.341 99.8538 651.914Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M95.6092 666.299H95.5783L93.8329 667.238L93.5703 666.207L95.7633 665.035H96.9218V675.051H95.6092V666.299Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.4531 363.947C72.4531 366.4 73.2091 367.794 74.3732 367.794C75.6835 367.794 76.3087 366.269 76.3087 363.86C76.3087 361.537 75.7127 360.012 74.3886 360.012C73.2679 360.012 72.4531 361.377 72.4531 363.947ZM77.5893 363.802C77.5893 367.011 76.396 368.782 74.3007 368.782C72.4531 368.782 71.201 367.054 71.1719 363.933C71.1719 360.768 72.5399 359.025 74.4605 359.025C76.4543 359.025 77.5893 360.797 77.5893 363.802Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.9428 378.266H73.9131L72.2128 379.182L71.957 378.176L74.0935 377.035H75.2217V386.793H73.9428V378.266Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.9822 395.878H73.9486L72.0644 396.894L71.7812 395.778L74.1484 394.514H75.3999V405.329H73.9822V395.878Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.1133 417.981C72.1133 420.869 73.004 422.51 74.3743 422.51C75.9158 422.51 76.6524 420.716 76.6524 417.879C76.6524 415.145 75.9507 413.35 74.3914 413.35C73.0725 413.35 72.1133 414.956 72.1133 417.981ZM78.1597 417.81C78.1597 421.587 76.7551 423.672 74.2886 423.672C72.1133 423.672 70.6403 421.638 70.6055 417.964C70.6055 414.239 72.2161 412.188 74.4771 412.188C76.8236 412.188 78.1597 414.272 78.1597 417.81Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.8895 432.811H73.8638L72.4062 433.596L72.1875 432.734L74.018 431.756H74.9857V440.119H73.8895V432.811Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.1221 453.995C72.1221 456.87 73.0087 458.504 74.3722 458.504C75.9074 458.504 76.6405 456.717 76.6405 453.893C76.6405 451.172 75.9411 449.385 74.3899 449.385C73.0767 449.385 72.1221 450.984 72.1221 453.995ZM78.1405 453.825C78.1405 457.586 76.7428 459.661 74.2871 459.661C72.1221 459.661 70.6554 457.636 70.6211 453.978C70.6211 450.271 72.2243 448.229 74.4744 448.229C76.8107 448.229 78.1405 450.305 78.1405 453.825Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.3652 472C72.3652 474.569 73.1577 476.029 74.3767 476.029C75.7487 476.029 76.4035 474.433 76.4035 471.909C76.4035 469.476 75.7789 467.879 74.3921 467.879C73.2182 467.879 72.3652 469.308 72.3652 472ZM77.7446 471.846C77.7446 475.207 76.4948 477.062 74.3007 477.062C72.3652 477.062 71.0537 475.253 71.0234 471.984C71.0234 468.669 72.4565 466.844 74.468 466.844C76.5559 466.844 77.7446 468.699 77.7446 471.846Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.3848 490.006C72.3848 492.547 73.1687 493.991 74.3739 493.991C75.7305 493.991 76.3785 492.412 76.3785 489.917C76.3785 487.511 75.7608 485.932 74.3894 485.932C73.2286 485.932 72.3848 487.345 72.3848 490.006ZM77.7038 489.856C77.7038 493.18 76.4683 495.013 74.2981 495.013C72.3843 495.013 71.0877 493.224 71.0586 489.992C71.0586 486.715 72.4745 484.91 74.4643 484.91C76.5283 484.91 77.7038 486.744 77.7038 489.856Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.9327 504.419H73.9035L72.2489 505.31L72 504.332L74.0788 503.221H75.1779V512.717H73.9327V504.419Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.5996 526.018C72.5996 528.289 73.3002 529.58 74.377 529.58C75.5897 529.58 76.1686 528.168 76.1686 525.938C76.1686 523.789 75.6165 522.377 74.3912 522.377C73.3533 522.377 72.5996 523.64 72.5996 526.018ZM77.353 525.884C77.353 528.854 76.2494 530.493 74.3093 530.493C72.5993 530.493 71.4409 528.894 71.4141 526.005C71.4141 523.076 72.6804 521.463 74.4578 521.463C76.3025 521.463 77.353 523.102 77.353 525.884Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.5068 544.027C72.5068 546.413 73.2422 547.768 74.3744 547.768C75.647 547.768 76.2551 546.286 76.2551 543.944C76.2551 541.685 75.6756 540.203 74.3887 540.203C73.2987 540.203 72.5068 541.53 72.5068 544.027ZM77.4999 543.888C77.4999 547.006 76.3403 548.728 74.3031 548.728C72.507 548.728 71.2903 547.049 71.2617 544.014C71.2617 540.938 72.5915 539.244 74.4584 539.244C76.3962 539.244 77.4999 540.965 77.4999 543.888Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.9026 558.758H73.8757L72.3673 559.57L72.1406 558.679L74.0356 557.666H75.037V566.322H73.9026V558.758Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.198 580.051C72.198 582.833 73.0556 584.413 74.375 584.413C75.8601 584.413 76.5692 582.685 76.5692 579.954C76.5692 577.32 75.8932 575.592 74.3922 575.592C73.1212 575.592 72.198 577.14 72.198 580.051ZM78.0199 579.888C78.0199 583.525 76.6679 585.532 74.2922 585.532C72.198 585.532 70.7792 583.574 70.7461 580.036C70.7461 576.448 72.2968 574.473 74.4738 574.473C76.733 574.473 78.0199 576.48 78.0199 579.888Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.8874 594.915H73.8623L72.4195 595.692L72.2031 594.839L74.0153 593.871H74.9722V602.149H73.8874V594.915Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.903 612.789H73.8762L72.3706 613.6L72.1445 612.71L74.0355 611.699H75.0347V620.338H73.903V612.789Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.8291 363.948C50.8291 366.358 51.5725 367.728 52.7166 367.728C54.0036 367.728 54.6179 366.23 54.6179 363.863C54.6179 361.58 54.0315 360.082 52.7309 360.082C51.6296 360.082 50.8291 361.422 50.8291 363.948ZM55.8753 363.805C55.8753 366.957 54.7031 368.697 52.6443 368.697C50.8287 368.697 49.5989 366.999 49.5703 363.933C49.5703 360.824 50.9143 359.111 52.8013 359.111C54.7602 359.111 55.8753 360.852 55.8753 363.805Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.5945 381.961C50.5945 384.67 51.4298 386.21 52.715 386.21C54.1612 386.21 54.852 384.526 54.852 381.865C54.852 379.301 54.1937 377.617 52.7315 377.617C51.4937 377.617 50.5945 379.124 50.5945 381.961ZM56.2657 381.801C56.2657 385.344 54.948 387.299 52.6345 387.299C50.5945 387.299 49.2122 385.392 49.1797 381.945C49.1797 378.451 50.6904 376.527 52.8115 376.527C55.0119 376.527 56.2657 378.483 56.2657 381.801Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2409 396.717H52.2146L50.7216 397.522L50.4961 396.639L52.3728 395.637H53.3645V404.206H52.2409V396.717Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.6066 417.977C50.6066 420.671 51.4373 422.202 52.7157 422.202C54.155 422.202 54.8419 420.528 54.8419 417.881C54.8419 415.33 54.187 413.654 52.7322 413.654C51.5007 413.654 50.6066 415.154 50.6066 417.977ZM56.2481 417.817C56.2481 421.341 54.9378 423.286 52.6363 423.286C50.6066 423.286 49.2312 421.389 49.1992 417.96C49.1992 414.484 50.7019 412.57 52.8116 412.57C55.0012 412.57 56.2481 414.516 56.2481 417.817Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2256 432.89H52.2005L50.7805 433.655L50.5664 432.814L52.3512 431.861H53.2938V440.011H52.2256V432.89Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.6172 453.993C50.6172 456.674 51.4439 458.196 52.7154 458.196C54.1468 458.196 54.8296 456.531 54.8296 453.899C54.8296 451.361 54.1776 449.695 52.7314 449.695C51.5073 449.695 50.6172 451.186 50.6172 453.993ZM56.2288 453.835C56.2288 457.34 54.9254 459.275 52.6364 459.275C50.6176 459.275 49.2502 457.387 49.2188 453.978C49.2188 450.52 50.7129 448.617 52.8111 448.617C54.9887 448.617 56.2288 450.552 56.2288 453.835Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.6201 472.001C50.6201 474.678 51.4457 476.2 52.7161 476.2C54.1457 476.2 54.8286 474.536 54.8286 471.906C54.8286 469.371 54.1771 467.707 52.732 467.707C51.5091 467.707 50.6201 469.196 50.6201 472.001ZM56.2253 471.842C56.2253 475.344 54.9236 477.277 52.6369 477.277C50.6203 477.277 49.2541 475.391 49.2227 471.985C49.2227 468.531 50.7157 466.629 52.8116 466.629C54.9869 466.629 56.2253 468.563 56.2253 471.842Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2384 486.776H52.2122L50.7277 487.576L50.5039 486.697L52.3692 485.701H53.3552V494.222H52.2384V486.776Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.182 505.384H52.1608L50.9556 506.033L50.7734 505.321L52.2882 504.512H53.0886V511.427H52.182V505.384Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2408 522.781H52.2146L50.725 523.584L50.5 522.703L52.3721 521.703H53.3616V530.252H52.2408V522.781Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.268 540.481H52.2389L50.6055 541.36L50.3594 540.395L52.4119 539.299H53.4962V548.673H52.268V540.481Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.3925 557.22H52.3537L50.1281 558.418L49.793 557.103L52.5889 555.609H54.0665V568.377H52.3925V557.22Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2719 576.453H52.2428L50.5888 577.344L50.3398 576.367L52.4181 575.256H53.516V584.747H52.2719V576.453Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M52.2874 594.34H52.2571L50.5466 595.261L50.2891 594.25L52.4387 593.102H53.5743V602.917H52.2874V594.34Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M51.0098 616.056C51.0098 618.237 51.6823 619.476 52.7169 619.476C53.8811 619.476 54.4372 618.121 54.4372 615.979C54.4372 613.914 53.9067 612.559 52.7306 612.559C51.7343 612.559 51.0098 613.773 51.0098 616.056ZM55.5754 615.928C55.5754 618.78 54.5146 620.354 52.6522 620.354C51.0096 620.354 49.8968 618.819 49.8711 616.044C49.8711 613.23 51.0872 611.682 52.7943 611.682C54.566 611.682 55.5754 613.256 55.5754 615.928Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M50.8027 634.07C50.8027 636.514 51.5564 637.903 52.7165 637.903C54.0212 637.903 54.6446 636.383 54.6446 633.984C54.6446 631.669 54.0497 630.15 52.7308 630.15C51.614 630.15 50.8027 631.511 50.8027 634.07ZM55.9197 633.927C55.9197 637.122 54.7309 638.887 52.6436 638.887C50.8028 638.887 49.5553 637.166 49.5273 634.057C49.5273 630.903 50.8896 629.168 52.8029 629.168C54.7886 629.168 55.9197 630.932 55.9197 633.927Z"
                        fill="#FF1236"
                      />
                    </g>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M415.287 359C414.341 359 413.575 358.235 413.575 357.291V108.153C413.575 93.9625 402.003 82.4174 387.78 82.4174H215.22C200.997 82.4174 189.425 93.9625 189.425 108.153V357.291C189.425 358.235 188.659 359 187.713 359C186.767 359 186 358.235 186 357.291V108.153C186 92.0778 199.108 79 215.22 79H387.78C403.892 79 417 92.0778 417 108.153V357.291C417 358.235 416.233 359 415.287 359Z"
                      fill="white"
                    />
                    <mask
                      id="mask6_715_56015"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="610"
                      height="785"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 785H610V0H0V785Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask6_715_56015)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M204.415 354.565H395.586V141.434H204.415V354.565ZM201 358H399V138H201V358Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M271.012 110.02C269.95 110.02 269.085 110.871 269.085 111.917V112.084C269.085 113.13 269.95 113.981 271.012 113.981H329.988C331.051 113.981 331.916 113.13 331.916 112.084V111.917C331.916 110.871 331.051 110.02 329.988 110.02H271.012ZM329.988 118H271.012C267.697 118 265 115.346 265 112.084V111.917C265 108.654 267.697 106 271.012 106H329.988C333.303 106 336 108.654 336 111.917V112.084C336 115.346 333.303 118 329.988 118Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M494 107.5L481 99.7503L468 92V107.5V123L481 115.25L494 107.5Z"
                        fill="#EC1938"
                      />
                      <g id="play-right">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M476.043 84.5801V108.42L496.032 96.4999L476.043 84.5801ZM474.022 114C473.678 114 473.333 113.912 473.024 113.736C472.392 113.377 472 112.706 472 111.979V81.0212C472 80.2945 472.392 79.6224 473.024 79.2635C473.656 78.9047 474.433 78.9126 475.057 79.2855L501.014 94.764C501.625 95.129 502 95.7882 502 96.4997C502 97.2117 501.625 97.8714 501.014 98.2353L475.057 113.714C474.739 113.905 474.381 114 474.022 114Z"
                          fill="white"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M113 232.5L126.001 224.75L139 217V232.5V248L126.001 240.25L113 232.5Z"
                        fill="#FF1236"
                      />
                      <g id="play-left">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M112.978 222.501L132.943 234.413V210.588L112.978 222.501ZM134.971 240C134.61 240 134.25 239.904 133.929 239.713L107.987 224.234C107.374 223.869 107 223.211 107 222.5C107 221.79 107.375 221.131 107.987 220.766L133.929 205.287C134.556 204.913 135.336 204.904 135.971 205.262C136.607 205.621 137 206.293 137 207.021V237.979C137 238.707 136.607 239.379 135.971 239.737C135.661 239.913 135.316 240 134.971 240Z"
                          fill="white"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M418 226H473V224H418V226Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M417 227H475V223H417V227Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M368.303 51.791V56.2103L372.353 54.0006L368.303 51.791ZM366 60V48L377 54.0003L366 60Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M31.3027 246.107V250.894L35.3531 248.501L31.3027 246.107ZM29 255V242L40 248.5L29 255Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M505.297 165.102V169.897L509.354 167.499L505.297 165.102ZM503 174V161L514 167.5L503 174Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M507.088 458.471V462.527L510.777 460.499L507.088 458.471ZM505 466V455L515 460.5L505 466Z"
                        fill="#EC1938"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M255.446 551.154L257.452 554.815L259.503 551.127L255.446 551.154ZM257.44 559L252 549.074L263 549L257.44 559Z"
                        fill="#EC1938"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M186.145 425.768L187.58 429.825L190.202 426.547L186.145 425.768ZM183 423L194 425.11L186.891 434L183 423Z"
                        fill="#EC1938"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M154.658 50.9989L158.641 53.1722V48.8262L154.658 50.9989ZM161 57L150 50.9997L161 45V57Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M51 163H71V143H51V163Z"
                        fill="#EC1938"
                      />
                      <g id="square">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M61.0449 168.956H76.9551V153.045H61.0449V168.956ZM57 173H81V149H57V173Z"
                          fill="white"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M120 176H126.8V171H120V176ZM133.6 176H140.4V171H133.6V176ZM147.2 176H154V171H147.2V176Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M480 227H486.8V222H480V227ZM493.6 227H500.4V222H493.6V227ZM507.2 227H514V222H507.2V227Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M413 355.999H418V349.199H413V355.999ZM413 342.4H418V335.6H413V342.4ZM413 328.8H418V322H413V328.8Z"
                        fill="#EC1938"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M201 280.999H206V274.199H201V280.999ZM201 267.4H206V260.6H201V267.4ZM201 253.8H206V247H201V253.8Z"
                        fill="#EC1938"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M350.5 0C344.71 0 340 4.70993 340 10.4997C340 16.2895 344.71 21 350.5 21C356.29 21 361 16.2895 361 10.4997C361 4.70993 356.29 0 350.5 0Z"
                        fill="#EC1938"
                      />
                      <g id="circle-1">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M357.5 7C351.71 7 347 11.7098 347 17.4994C347 23.2896 351.71 28 357.5 28C363.29 28 368 23.2896 368 17.4994C368 11.7098 363.29 7 357.5 7ZM357.5 8.04102C362.724 8.04102 366.959 12.2753 366.959 17.499C366.959 22.7237 362.724 26.958 357.5 26.958C352.276 26.958 348.041 22.7237 348.041 17.499C348.041 12.2753 352.276 8.04102 357.5 8.04102Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M357.5 9.32031C352.99 9.32031 349.319 12.9901 349.319 17.5006C349.319 22.0111 352.99 25.6808 357.5 25.6808C362.011 25.6808 365.681 22.0111 365.681 17.5006C365.681 12.9901 362.011 9.32031 357.5 9.32031ZM357.5 29C351.159 29 346 23.841 346 17.5C346 11.159 351.159 6 357.5 6C363.841 6 369 11.159 369 17.5C369 23.841 363.841 29 357.5 29Z"
                          fill="white"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M281.94 469.572H322.06V443.037L351.246 425.482L372.751 447.04L392.103 427.64L370.671 406.155L382.579 382.279H414.581V358.428C399.633 358.428 374.926 358.43 368.763 358.438C367.172 367.718 362.79 383.843 350.797 397.457C338.531 411.381 322.113 418.442 302 418.442C281.887 418.442 265.469 411.381 253.202 397.457C241.204 383.836 236.822 367.701 235.237 358.438C229.073 358.43 204.366 358.428 189.419 358.428V382.279H221.421L233.329 406.155L211.897 427.64L231.249 447.04L252.753 425.482L281.94 443.037V469.572ZM325.479 473H278.521V444.977L253.283 429.798L231.249 451.886L207.062 427.64L229.169 405.478L219.307 385.706H186V355L236.145 355.013C236.854 355.014 238.174 355.018 238.383 356.487C239.691 365.047 243.692 381.482 255.765 395.188C267.354 408.343 282.91 415.014 302 415.014C321.09 415.014 336.646 408.343 348.235 395.188C360.307 381.482 364.309 365.047 365.619 356.47C365.826 355.018 367.146 355.014 367.856 355.013L391.8 355.002L418 355V385.706H384.692L374.831 405.478L396.939 427.64L372.751 451.886L350.716 429.798L325.479 444.977V473Z"
                        fill="#EC1938"
                      />

                      <g id="skull-2">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M489 431C488.448 431 488 430.539 488 429.97V373.029C488 372.461 488.448 372 489 372C489.552 372 490 372.461 490 373.029V429.97C490 430.539 489.552 431 489 431Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M450.066 395.894H487.934V388.107H450.066V395.894ZM488.967 398H449.033C448.463 398 448 397.529 448 396.947V387.054C448 386.471 448.463 386 449.033 386H488.967C489.538 386 490 386.471 490 387.054V396.947C490 397.529 489.538 398 488.967 398Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M483.964 414H456.036C455.464 414 455 413.553 455 413C455 412.447 455.464 412 456.036 412H483.964C484.536 412 485 412.447 485 413C485 413.553 484.536 414 483.964 414Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M472.991 420H457.009C456.452 420 456 419.553 456 419C456 418.447 456.452 418 457.009 418H472.991C473.548 418 474 418.447 474 419C474 419.553 473.548 420 472.991 420Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M449.968 404.61H468.032V401.389H449.968V404.61ZM469.016 407H448.984C448.441 407 448 406.466 448 405.805V400.195C448 399.535 448.441 399 448.984 399H469.016C469.559 399 470 399.535 470 400.195V405.805C470 406.466 469.559 407 469.016 407Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M453.977 378.096C451.821 378.096 450.066 379.875 450.066 382.063V420.937C450.066 423.125 451.821 424.905 453.977 424.905H487.934V378.096H453.977ZM488.967 427H453.977C450.681 427 448 424.28 448 420.937V382.063C448 378.72 450.681 376 453.977 376H488.967C489.537 376 490 376.469 490 377.048V425.952C490 426.532 489.537 427 488.967 427Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 387C503.235 387 502.726 386.528 502.726 385.945V383.35C502.262 383.611 501.648 383.533 501.279 383.139C500.867 382.699 500.917 382.033 501.392 381.65L503.117 380.258C503.454 379.987 503.929 379.924 504.334 380.095C504.74 380.267 505 380.641 505 381.055V385.945C505 386.528 504.491 387 503.863 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 387H502.191C501.533 387 501 386.553 501 386C501 385.447 501.533 385 502.191 385H505.809C506.467 385 507 385.447 507 386C507 386.553 506.467 387 505.809 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M508.175 384.889H509.825V382.109H508.175V384.889ZM510.108 387H507.892C506.849 387 506 386.177 506 385.164V381.837C506 380.823 506.849 380 507.892 380H510.108C511.152 380 512 380.823 512 381.837V385.164C512 386.177 511.152 387 510.108 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M521.175 384.889H522.825V382.109H521.175V384.889ZM523.107 387H520.891C519.849 387 519 386.177 519 385.164V381.837C519 380.823 519.849 380 520.891 380H523.107C524.151 380 525 380.823 525 381.837V385.164C525 386.177 524.151 387 523.107 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M527.863 387C527.235 387 526.727 386.528 526.727 385.945V383.35C526.263 383.611 525.647 383.533 525.279 383.139C524.867 382.699 524.917 382.033 525.392 381.65L527.117 380.258C527.454 379.987 527.93 379.924 528.335 380.095C528.74 380.267 529 380.641 529 381.055V385.945C529 386.528 528.491 387 527.863 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M529.808 387H526.192C525.533 387 525 386.553 525 386C525 385.447 525.533 385 526.192 385H529.808C530.466 385 531 385.447 531 386C531 386.553 530.466 387 529.808 387Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M497.175 392.889H498.825V390.109H497.175V392.889ZM499.108 395H496.892C495.848 395 495 394.177 495 393.165V389.836C495 388.823 495.848 388 496.892 388H499.108C500.151 388 501 388.823 501 389.836V393.165C501 394.177 500.151 395 499.108 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 395C503.235 395 502.726 394.528 502.726 393.945V391.349C502.261 391.611 501.648 391.532 501.279 391.137C500.867 390.698 500.917 390.032 501.392 389.65L503.117 388.259C503.454 387.988 503.93 387.924 504.335 388.095C504.741 388.267 505 388.642 505 389.055V393.945C505 394.528 504.491 395 503.863 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 394H502.191C501.533 394 501 393.553 501 393C501 392.447 501.533 392 502.191 392H505.809C506.467 392 507 392.447 507 393C507 393.553 506.467 394 505.809 394Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M508.175 392.889H509.825V390.109H508.175V392.889ZM510.108 395H507.892C506.849 395 506 394.177 506 393.165V389.836C506 388.823 506.849 388 507.892 388H510.108C511.152 388 512 388.823 512 389.836V393.165C512 394.177 511.152 395 510.108 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M515.863 395C515.235 395 514.726 394.528 514.726 393.945V391.349C514.261 391.611 513.648 391.532 513.279 391.137C512.867 390.698 512.917 390.032 513.392 389.65L515.117 388.259C515.453 387.988 515.929 387.924 516.335 388.095C516.741 388.267 517 388.642 517 389.055V393.945C517 394.528 516.491 395 515.863 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M517.808 394H514.192C513.533 394 513 393.553 513 393C513 392.447 513.533 392 514.192 392H517.808C518.466 392 519 392.447 519 393C519 393.553 518.466 394 517.808 394Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M521.175 392.889H522.825V390.109H521.175V392.889ZM523.107 395H520.891C519.849 395 519 394.177 519 393.165V389.836C519 388.823 519.849 388 520.891 388H523.107C524.151 388 525 388.823 525 389.836V393.165C525 394.177 524.151 395 523.107 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M527.863 395C527.235 395 526.727 394.528 526.727 393.945V391.349C526.262 391.611 525.647 391.532 525.279 391.137C524.867 390.698 524.917 390.032 525.392 389.65L527.117 388.259C527.454 387.988 527.93 387.924 528.335 388.095C528.741 388.267 529 388.642 529 389.055V393.945C529 394.528 528.491 395 527.863 395Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M529.808 394H526.192C525.533 394 525 393.553 525 393C525 392.447 525.533 392 526.192 392H529.808C530.466 392 531 392.447 531 393C531 393.553 530.466 394 529.808 394Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M497.175 398.889H498.825V396.109H497.175V398.889ZM499.108 401H496.892C495.848 401 495 400.177 495 399.164V395.836C495 394.823 495.848 394 496.892 394H499.108C500.151 394 501 394.823 501 395.836V399.164C501 400.177 500.151 401 499.108 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 401C503.235 401 502.726 400.528 502.726 399.945V397.35C502.262 397.61 501.648 397.532 501.279 397.139C500.867 396.699 500.917 396.033 501.392 395.651L503.117 394.259C503.454 393.988 503.929 393.923 504.334 394.095C504.74 394.267 505 394.642 505 395.055V399.945C505 400.528 504.491 401 503.863 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 401H502.191C501.533 401 501 400.553 501 400C501 399.447 501.533 399 502.191 399H505.809C506.467 399 507 399.447 507 400C507 400.553 506.467 401 505.809 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M515.863 401C515.235 401 514.726 400.528 514.726 399.945V397.35C514.262 397.61 513.648 397.532 513.279 397.139C512.867 396.699 512.917 396.033 513.392 395.651L515.117 394.259C515.453 393.988 515.929 393.923 516.335 394.095C516.74 394.267 517 394.642 517 395.055V399.945C517 400.528 516.491 401 515.863 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M517.808 401H514.192C513.533 401 513 400.553 513 400C513 399.447 513.533 399 514.192 399H517.808C518.466 399 519 399.447 519 400C519 400.553 518.466 401 517.808 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M527.863 401C527.235 401 526.727 400.528 526.727 399.945V397.35C526.263 397.61 525.647 397.532 525.279 397.139C524.867 396.699 524.917 396.033 525.392 395.651L527.117 394.259C527.454 393.988 527.93 393.923 528.335 394.095C528.74 394.267 529 394.642 529 395.055V399.945C529 400.528 528.491 401 527.863 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M529.808 401H526.192C525.533 401 525 400.553 525 400C525 399.447 525.533 399 526.192 399H529.808C530.466 399 531 399.447 531 400C531 400.553 530.466 401 529.808 401Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M497.175 406.889H498.825V404.109H497.175V406.889ZM499.108 409H496.892C495.848 409 495 408.177 495 407.164V403.835C495 402.823 495.848 402 496.892 402H499.108C500.151 402 501 402.823 501 403.835V407.164C501 408.177 500.151 409 499.108 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 409C503.235 409 502.726 408.528 502.726 407.945V405.35C502.262 405.612 501.648 405.533 501.279 405.139C500.867 404.7 500.917 404.033 501.392 403.651L503.117 402.259C503.454 401.987 503.929 401.924 504.334 402.095C504.74 402.267 505 402.642 505 403.055V407.945C505 408.528 504.491 409 503.863 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 409H502.191C501.533 409 501 408.553 501 408C501 407.447 501.533 407 502.191 407H505.809C506.467 407 507 407.447 507 408C507 408.553 506.467 409 505.809 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M508.175 406.889H509.825V404.109H508.175V406.889ZM510.108 409H507.892C506.849 409 506 408.177 506 407.164V403.835C506 402.823 506.849 402 507.892 402H510.108C511.152 402 512 402.823 512 403.835V407.164C512 408.177 511.152 409 510.108 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M515.863 409C515.235 409 514.726 408.528 514.726 407.945V405.35C514.262 405.612 513.648 405.533 513.279 405.139C512.867 404.7 512.917 404.033 513.392 403.651L515.117 402.259C515.453 401.987 515.929 401.924 516.335 402.095C516.74 402.267 517 402.642 517 403.055V407.945C517 408.528 516.491 409 515.863 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M517.808 409H514.192C513.533 409 513 408.553 513 408C513 407.447 513.533 407 514.192 407H517.808C518.466 407 519 407.447 519 408C519 408.553 518.466 409 517.808 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M521.175 406.889H522.825V404.109H521.175V406.889ZM523.107 409H520.891C519.849 409 519 408.177 519 407.164V403.835C519 402.823 519.849 402 520.891 402H523.107C524.151 402 525 402.823 525 403.835V407.164C525 408.177 524.151 409 523.107 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M527.863 409C527.235 409 526.727 408.528 526.727 407.945V405.35C526.263 405.612 525.647 405.533 525.279 405.139C524.867 404.7 524.917 404.033 525.392 403.651L527.117 402.259C527.454 401.987 527.93 401.924 528.335 402.095C528.74 402.267 529 402.642 529 403.055V407.945C529 408.528 528.491 409 527.863 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M529.808 409H526.192C525.533 409 525 408.553 525 408C525 407.447 525.533 407 526.192 407H529.808C530.466 407 531 407.447 531 408C531 408.553 530.466 409 529.808 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 416C503.235 416 502.726 415.528 502.726 414.945V412.35C502.262 412.611 501.648 412.533 501.279 412.139C500.867 411.699 500.917 411.033 501.392 410.651L503.117 409.259C503.454 408.988 503.929 408.923 504.334 409.096C504.74 409.267 505 409.642 505 410.055V414.945C505 415.528 504.491 416 503.863 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 416H502.191C501.533 416 501 415.553 501 415C501 414.448 501.533 414 502.191 414H505.809C506.467 414 507 414.448 507 415C507 415.553 506.467 416 505.809 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M508.175 413.889H509.825V411.109H508.175V413.889ZM510.108 416H507.892C506.849 416 506 415.177 506 414.163V410.836C506 409.823 506.849 409 507.892 409H510.108C511.152 409 512 409.823 512 410.836V414.163C512 415.177 511.152 416 510.108 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M515.863 416C515.235 416 514.726 415.528 514.726 414.945V412.35C514.262 412.611 513.648 412.533 513.279 412.139C512.867 411.699 512.917 411.033 513.392 410.651L515.117 409.259C515.453 408.988 515.929 408.923 516.335 409.096C516.74 409.267 517 409.642 517 410.055V414.945C517 415.528 516.491 416 515.863 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M517.808 416H514.192C513.533 416 513 415.553 513 415C513 414.448 513.533 414 514.192 414H517.808C518.466 414 519 414.448 519 415C519 415.553 518.466 416 517.808 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M521.175 413.889H522.825V411.109H521.175V413.889ZM523.107 416H520.891C519.849 416 519 415.177 519 414.163V410.836C519 409.823 519.849 409 520.891 409H523.107C524.151 409 525 409.823 525 410.836V414.163C525 415.177 524.151 416 523.107 416Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M497.175 422.889H498.825V420.109H497.175V422.889ZM499.108 425H496.892C495.848 425 495 424.176 495 423.164V419.836C495 418.823 495.848 418 496.892 418H499.108C500.151 418 501 418.823 501 419.836V423.164C501 424.176 500.151 425 499.108 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M503.863 425C503.235 425 502.726 424.527 502.726 423.945V421.35C502.262 421.612 501.648 421.533 501.279 421.14C500.867 420.7 500.917 420.033 501.392 419.651L503.117 418.259C503.454 417.987 503.929 417.924 504.334 418.096C504.74 418.267 505 418.642 505 419.055V423.945C505 424.527 504.491 425 503.863 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M505.809 425H502.191C501.533 425 501 424.552 501 424C501 423.447 501.533 423 502.191 423H505.809C506.467 423 507 423.447 507 424C507 424.552 506.467 425 505.809 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M508.175 422.889H509.825V420.109H508.175V422.889ZM510.108 425H507.892C506.849 425 506 424.176 506 423.164V419.836C506 418.823 506.849 418 507.892 418H510.108C511.152 418 512 418.823 512 419.836V423.164C512 424.176 511.152 425 510.108 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M521.175 422.889H522.825V420.109H521.175V422.889ZM523.107 425H520.891C519.849 425 519 424.176 519 423.164V419.836C519 418.823 519.849 418 520.891 418H523.107C524.151 418 525 418.823 525 419.836V423.164C525 424.176 524.151 425 523.107 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M527.863 425C527.235 425 526.727 424.527 526.727 423.945V421.35C526.263 421.612 525.647 421.533 525.279 421.14C524.867 420.7 524.917 420.033 525.392 419.651L527.117 418.259C527.454 417.987 527.93 417.924 528.335 418.096C528.74 418.267 529 418.642 529 419.055V423.945C529 424.527 528.491 425 527.863 425Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M529.808 425H526.192C525.533 425 525 424.552 525 424C525 423.447 525.533 423 526.192 423H529.808C530.466 423 531 423.447 531 424C531 424.552 530.466 425 529.808 425Z"
                          fill="#FF1236"
                        />
                      </g>

                      {/* start */}
                      <g id="skull-1">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M439.692 527C437.592 527 435.611 525.733 434.832 523.684L423.33 493.455C422.327 490.817 423.687 487.864 426.362 486.874L462.973 473.328C464.023 472.939 465.146 472.896 466.222 473.2C466.793 473.361 467.122 473.949 466.958 474.511C466.795 475.073 466.199 475.401 465.628 475.237C465 475.059 464.344 475.085 463.728 475.312L427.117 488.858C425.552 489.438 424.755 491.166 425.343 492.71L436.843 522.94C437.432 524.485 439.184 525.268 440.751 524.69L459.564 517.728C460.122 517.527 460.74 517.8 460.947 518.349C461.156 518.897 460.875 519.507 460.32 519.713L441.506 526.675C440.909 526.895 440.295 527 439.692 527Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M438.871 448.111C437.034 448.111 435.168 448.434 433.349 449.116C429.413 450.59 426.285 453.512 424.54 457.345C422.796 461.176 422.649 465.451 424.126 469.38L430.216 485.584L435.027 483.782L428.937 467.578C427.941 464.929 428.04 462.047 429.216 459.464C430.391 456.882 432.5 454.912 435.154 453.918C437.809 452.924 440.696 453.022 443.282 454.195C445.871 455.369 447.844 457.475 448.84 460.124L449.769 462.599L454.58 460.797L453.65 458.322C451.279 452.013 445.255 448.111 438.871 448.111ZM429.597 488C429.169 488 428.767 487.738 428.608 487.314L422.146 470.122C420.47 465.666 420.637 460.817 422.615 456.471C424.592 452.126 428.141 448.811 432.606 447.139C441.839 443.681 452.167 448.365 455.63 457.581L456.932 461.044C457.138 461.591 456.86 462.199 456.314 462.404L449.522 464.948C449.26 465.048 448.969 465.036 448.714 464.92C448.458 464.804 448.259 464.592 448.16 464.33L446.859 460.866C446.062 458.744 444.481 457.059 442.408 456.119C440.335 455.177 438.023 455.1 435.898 455.896C433.773 456.692 432.084 458.27 431.142 460.338C430.199 462.408 430.12 464.716 430.918 466.837L437.379 484.03C437.478 484.292 437.468 484.583 437.352 484.837C437.236 485.092 437.023 485.291 436.76 485.389L429.97 487.932C429.847 487.978 429.721 488 429.597 488Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M458.298 474C458.235 474 458.173 473.996 458.11 473.988C457.402 473.894 456.911 473.287 457.014 472.632L457.422 470.025C457.525 469.37 458.187 468.923 458.89 469.011C459.598 469.105 460.089 469.713 459.986 470.366L459.578 472.974C459.484 473.57 458.931 474 458.298 474Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M452.92 471C452.796 471 452.669 470.98 452.546 470.937L449.707 469.957C449.147 469.764 448.86 469.183 449.067 468.66C449.274 468.137 449.895 467.869 450.454 468.063L453.294 469.042C453.853 469.235 454.14 469.816 453.933 470.339C453.772 470.747 453.359 471 452.92 471Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M463.326 504C463.266 504 463.206 503.996 463.146 503.988C462.421 503.895 461.914 503.26 462.012 502.568L462.364 500.092C462.463 499.401 463.134 498.922 463.853 499.01C464.578 499.104 465.086 499.74 464.988 500.432L464.635 502.909C464.545 503.54 463.977 504 463.326 504Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M488.326 508C488.266 508 488.206 507.996 488.146 507.988C487.421 507.895 486.914 507.259 487.012 506.569L487.364 504.093C487.462 503.402 488.134 502.919 488.853 503.011C489.578 503.105 490.086 503.741 489.988 504.433L489.635 506.909C489.545 507.54 488.977 508 488.326 508Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M476.498 523C476.233 523 475.966 522.982 475.697 522.943L469.444 522.053C466.896 521.69 464.891 519.66 464.456 517.002L464.016 514.308C463.916 513.699 464.306 513.12 464.887 513.016C465.471 512.913 466.02 513.319 466.12 513.93L466.561 516.624C466.837 518.313 468.111 519.603 469.731 519.834L475.984 520.724C477.61 520.966 479.161 520.068 479.857 518.515L480.966 516.042C481.217 515.482 481.853 515.244 482.387 515.505C482.92 515.769 483.149 516.436 482.898 516.996L481.789 519.469C480.81 521.652 478.747 523 476.498 523Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M467.491 489.17C466.55 489.17 465.64 489.475 464.878 490.055C463.958 490.755 463.366 491.771 463.21 492.917C463.055 494.062 463.354 495.201 464.055 496.121C464.755 497.042 465.772 497.635 466.918 497.789C468.063 497.948 469.202 497.644 470.122 496.945C471.042 496.244 471.634 495.228 471.791 494.082C471.945 492.936 471.646 491.797 470.945 490.878C470.245 489.957 469.229 489.365 468.083 489.21C467.884 489.182 467.687 489.17 467.491 489.17ZM467.514 500C467.22 500 466.923 499.98 466.626 499.94C464.906 499.707 463.379 498.817 462.328 497.436C461.277 496.054 460.827 494.346 461.06 492.625C461.293 490.906 462.183 489.379 463.564 488.329C464.946 487.277 466.653 486.825 468.374 487.061C470.094 487.294 471.62 488.184 472.672 489.565C473.723 490.946 474.174 492.654 473.94 494.374C473.707 496.095 472.817 497.62 471.436 498.672C470.293 499.542 468.926 500 467.514 500Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M485.498 490.168C483.366 490.168 481.504 491.747 481.209 493.917C480.888 496.282 482.552 498.468 484.919 498.789C487.282 499.109 489.469 497.448 489.79 495.081C489.946 493.935 489.646 492.797 488.946 491.876C488.245 490.957 487.228 490.364 486.082 490.208C485.886 490.181 485.691 490.168 485.498 490.168ZM485.504 501C485.214 501 484.922 500.98 484.626 500.941C481.075 500.458 478.578 497.175 479.059 493.625C479.541 490.072 482.816 487.586 486.374 488.057C489.926 488.54 492.423 491.822 491.94 495.373C491.499 498.63 488.702 500.999 485.504 501Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M475.458 504.638C475.513 504.638 475.567 504.642 475.621 504.649C476.028 504.703 476.378 504.954 476.555 505.314L476.97 506.17C477.169 506.579 477.675 506.751 478.096 506.56C478.513 506.367 478.692 505.876 478.494 505.468L476.726 501.835C476.604 501.582 476.361 501.409 476.078 501.372C475.791 501.33 475.514 501.439 475.327 501.649L472.628 504.691C472.325 505.034 472.364 505.553 472.716 505.849C472.839 505.954 472.991 506.022 473.153 506.042C473.43 506.083 473.717 505.976 473.905 505.765L474.541 505.047C474.773 504.786 475.109 504.638 475.458 504.638ZM477.739 509C476.756 509 475.807 508.57 475.181 507.808C474.509 508.284 473.672 508.497 472.828 508.384C472.199 508.3 471.613 508.043 471.131 507.639C469.766 506.488 469.616 504.475 470.793 503.147L473.491 500.105C474.217 499.286 475.307 498.882 476.404 499.03C477.502 499.176 478.442 499.846 478.917 500.822L480.685 504.455C481.457 506.041 480.76 507.943 479.132 508.695C478.682 508.902 478.206 509 477.739 509Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M477.345 511.632C477.393 511.632 477.441 511.635 477.489 511.643L477.847 511.693C478.308 511.757 478.673 512.121 478.745 512.589C478.846 513.25 479.345 513.754 479.988 513.843C480.634 513.931 481.244 513.58 481.515 512.97C481.707 512.539 482.158 512.29 482.617 512.349L484.899 512.665L487.201 505.56C487.36 505.072 487.833 504.769 488.343 504.835L490.656 505.155C491.152 505.229 491.641 505.091 492.038 504.785C492.436 504.476 492.691 504.029 492.759 503.527L493.746 496.132C494.944 487.156 488.759 478.724 479.961 477.335C475.656 476.655 471.317 477.773 467.746 480.481C464.106 483.242 461.671 487.432 461.064 491.977L460.124 499.024C460.057 499.527 460.187 500.026 460.489 500.43C460.791 500.834 461.229 501.094 461.724 501.161L464.037 501.482C464.54 501.552 464.923 501.977 464.948 502.491L465.304 509.961L467.586 510.275C468.048 510.339 468.414 510.704 468.485 511.173C468.586 511.835 469.085 512.339 469.729 512.427C470.367 512.518 470.985 512.166 471.255 511.555C471.447 511.121 471.902 510.862 472.359 510.934L472.718 510.984C473.179 511.048 473.544 511.413 473.615 511.881C473.716 512.542 474.216 513.046 474.858 513.135C475.504 513.226 476.114 512.872 476.385 512.264C476.557 511.875 476.935 511.632 477.345 511.632ZM480.192 516C480.03 516 479.868 515.989 479.704 515.967C478.704 515.828 477.845 515.281 477.289 514.491C476.547 515.104 475.578 515.393 474.575 515.258C473.574 515.119 472.716 514.575 472.16 513.783C471.417 514.397 470.445 514.685 469.444 514.551C468.145 514.372 467.085 513.506 466.617 512.304L464.153 511.964C463.65 511.894 463.267 511.471 463.242 510.955L462.885 503.486L461.44 503.286C459.269 502.986 457.742 500.945 458.036 498.736L458.977 491.689C459.659 486.579 462.396 481.868 466.486 478.764C470.513 475.71 475.413 474.453 480.284 475.219C490.209 476.786 497.183 486.297 495.833 496.421L494.846 503.816C494.703 504.886 494.159 505.835 493.314 506.489C492.468 507.144 491.423 507.424 490.372 507.279L488.927 507.079L486.625 514.183C486.466 514.672 485.985 514.974 485.483 514.909L483.019 514.568C482.349 515.468 481.311 516 480.192 516Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M451.298 506C446.723 506 443 502.186 443 497.499C443 492.813 446.723 489 451.298 489C451.896 489 452.38 489.496 452.38 490.108C452.38 490.722 451.896 491.217 451.298 491.217C447.916 491.217 445.165 494.036 445.165 497.499C445.165 500.964 447.916 503.783 451.298 503.783C452.381 503.783 453.445 503.491 454.374 502.937C454.891 502.629 455.553 502.808 455.854 503.338C456.153 503.867 455.978 504.546 455.462 504.853C454.202 505.604 452.763 506 451.298 506Z"
                          fill="#FF1236"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M111.714 301H84.2867C83.5754 301 83 300.329 83 299.5C83 298.67 83.5754 298 84.2867 298H111.714C112.425 298 113 298.67 113 299.5C113 300.329 112.425 301 111.714 301Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M144 314.548C144.331 314.548 144.663 314.675 144.915 314.928L150.863 320.873L152.872 318.863L146.926 312.917C146.421 312.41 146.421 311.591 146.926 311.084L152.872 305.139L150.863 303.129L144.915 309.074C144.409 309.58 143.589 309.58 143.083 309.074L137.137 303.129L135.128 305.139L141.074 311.084C141.58 311.591 141.58 312.41 141.074 312.917L135.128 318.863L137.137 320.873L143.083 314.928C143.337 314.675 143.668 314.548 144 314.548ZM150.863 324C150.52 324 150.19 323.864 149.947 323.62L143.999 317.675L138.053 323.62C137.81 323.864 137.481 324 137.137 324C136.793 324 136.464 323.864 136.221 323.62L132.379 319.778C131.874 319.272 131.874 318.452 132.379 317.945L138.325 312L132.379 306.054C131.874 305.548 131.874 304.728 132.379 304.222L136.221 300.379C136.706 299.894 137.568 299.894 138.053 300.379L143.999 306.325L149.947 300.379C150.19 300.136 150.518 300 150.863 300C151.207 300 151.536 300.136 151.779 300.379L155.621 304.222C156.126 304.728 156.126 305.548 155.621 306.054L149.675 312L155.621 317.945C156.126 318.452 156.126 319.272 155.621 319.778L151.779 323.62C151.536 323.864 151.207 324 150.863 324Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M73.31 286.58C71.2757 286.58 69.6201 288.211 69.6201 290.216V339.683C69.6201 343.396 72.6868 346.418 76.4554 346.418H139.547C143.316 346.418 146.381 343.396 146.381 339.683V332.5C145.673 332.576 144.984 332.612 144.306 332.612C132.924 332.612 123.664 323.487 123.664 312.272C123.664 308.395 124.797 304.604 126.893 301.358H110.975C110.62 301.358 110.279 301.216 110.032 300.963L95.9391 286.58H73.31ZM139.547 349H76.4549C71.242 349 67 344.82 67 339.684V290.216C67 286.788 69.8303 284 73.3096 284H96.4947C96.8499 284 97.1902 284.142 97.4375 284.394L111.531 298.777H129.47C129.979 298.777 130.441 299.067 130.658 299.521C130.872 299.975 130.802 300.512 130.474 300.895C127.772 304.079 126.284 308.121 126.284 312.272C126.284 322.065 134.368 330.031 144.306 330.031C145.307 330.031 146.341 329.937 147.463 329.741C147.847 329.674 148.235 329.779 148.532 330.022C148.829 330.268 149 330.629 149 331.012V339.684C149 344.82 144.76 349 139.547 349Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M78.6318 348.186C78.847 351.672 81.8247 354.445 85.4543 354.445H148.544C152.313 354.445 155.379 351.456 155.379 347.781V328.795C153.414 330.018 151.241 330.911 148.957 331.429V338.968C148.957 344.05 144.717 348.186 139.504 348.186H78.6318ZM148.545 357H85.4547C80.2419 357 76 352.864 76 347.782V346.909C76 346.203 76.5859 345.632 77.3095 345.632H139.504C143.273 345.632 146.338 342.643 146.338 338.968V330.388C146.338 329.768 146.793 329.238 147.421 329.13C150.529 328.594 153.443 327.269 155.847 325.299C156.237 324.98 156.783 324.909 157.242 325.12C157.704 325.329 158 325.781 158 326.277V347.782C158 352.864 153.758 357 148.545 357Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M144.5 293.602C134.632 293.602 126.603 301.631 126.603 311.5C126.603 321.37 134.632 329.398 144.5 329.398C154.369 329.398 162.398 321.37 162.398 311.5C162.398 301.631 154.369 293.602 144.5 293.602ZM144.499 332C133.196 332 124 322.803 124 311.5C124 300.196 133.196 291 144.499 291C155.803 291 165 300.196 165 311.5C165 322.803 155.803 332 144.499 332Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M91.5005 331H88.5008C87.6716 331 87 330.329 87 329.5C87 328.67 87.6716 328 88.5008 328H91.5005C92.3298 328 93 328.67 93 329.5C93 330.329 92.3298 331 91.5005 331Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M104.502 331H99.4975C98.6693 331 98 330.329 98 329.5C98 328.67 98.6693 328 99.4975 328H104.502C105.33 328 106 328.67 106 329.5C106 330.329 105.33 331 104.502 331Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.5 331H112.501C111.672 331 111 330.329 111 329.5C111 328.67 111.672 328 112.501 328H115.5C116.33 328 117 328.67 117 329.5C117 330.329 116.33 331 115.5 331Z"
                        fill="white"
                      />
                      <g id="skull-4">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M222.805 542C222.145 542 221.61 541.468 221.61 540.814V505.336C221.61 503.212 219.869 501.484 217.728 501.484H185.519C185.195 501.484 184.886 501.353 184.66 501.122L170.309 486.372H147.272C145.132 486.372 143.39 488.1 143.39 490.224V540.814C143.39 541.468 142.855 542 142.195 542C141.535 542 141 541.468 141 540.814V490.224C141 486.792 143.814 484 147.272 484H170.816C171.14 484 171.45 484.131 171.676 484.362L186.027 499.112H217.728C221.186 499.112 224 501.904 224 505.336V540.814C224 541.468 223.464 542 222.805 542Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M184.834 501H157.166C156.522 501 156 500.328 156 499.5C156 498.672 156.522 498 157.166 498H184.834C185.478 498 186 498.672 186 499.5C186 500.328 185.478 501 184.834 501Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M154.71 523.999C161.354 531.928 171.853 536.633 183 536.633C194.147 536.633 204.646 531.928 211.29 523.999C204.646 516.071 194.147 511.365 183 511.365C171.853 511.365 161.354 516.071 154.71 523.999ZM183 539C170.795 539 159.301 533.666 152.254 524.732C151.915 524.302 151.915 523.698 152.254 523.268C159.301 514.334 170.795 509 183 509C195.205 509 206.698 514.334 213.746 523.268C214.085 523.698 214.085 524.302 213.746 524.732C206.698 533.666 195.205 539 183 539Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M183 511.365C176.034 511.365 170.365 517.033 170.365 524C170.365 530.966 176.034 536.633 183 536.633C189.966 536.633 195.634 530.966 195.634 524C195.634 517.033 189.966 511.365 183 511.365ZM183 539C174.729 539 168 532.271 168 524C168 515.729 174.729 509 183 509C191.271 509 198 515.729 198 524C198 532.271 191.271 539 183 539Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M182.5 531C178.364 531 175 527.636 175 523.5C175 522.84 175.535 522.305 176.195 522.305C176.855 522.305 177.39 522.84 177.39 523.5C177.39 526.317 179.682 528.609 182.5 528.609C185.318 528.609 187.61 526.317 187.61 523.5C187.61 520.683 185.318 518.391 182.5 518.391C181.84 518.391 181.305 517.855 181.305 517.195C181.305 516.535 181.84 516 182.5 516C186.636 516 190 519.364 190 523.5C190 527.636 186.636 531 182.5 531Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M182.5 551C181.672 551 181 550.416 181 549.696V543.304C181 542.584 181.672 542 182.5 542C183.328 542 184 542.584 184 543.304V549.696C184 550.416 183.328 551 182.5 551Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M198.625 557C197.867 557 197.251 556.477 197.251 555.834V549.679H193.374C192.616 549.679 192 549.157 192 548.513V541.166C192 540.522 192.616 540 193.374 540C194.133 540 194.749 540.522 194.749 541.166V547.347H198.625C199.384 547.347 200 547.869 200 548.513V555.834C200 556.477 199.384 557 198.625 557Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M182.501 550.5C180.846 550.5 179.5 551.846 179.5 553.5C179.5 555.155 180.846 556.502 182.501 556.502C184.155 556.502 185.501 555.155 185.501 553.5C185.501 551.846 184.155 550.5 182.501 550.5ZM182.501 559C179.467 559 177 556.533 177 553.5C177 550.467 179.467 548 182.501 548C185.534 548 188 550.467 188 553.5C188 556.533 185.534 559 182.501 559Z"
                          fill="#FF1236"
                        />

                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M198.499 558.5C196.845 558.5 195.499 559.846 195.499 561.5C195.499 563.155 196.845 564.502 198.499 564.502C200.154 564.502 201.5 563.155 201.5 561.5C201.5 559.846 200.154 558.5 198.499 558.5ZM198.499 567C195.466 567 193 564.533 193 561.5C193 558.467 195.466 556 198.499 556C201.533 556 204 558.467 204 561.5C204 564.533 201.533 567 198.499 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M210.5 548.5C208.845 548.5 207.499 549.845 207.499 551.5C207.499 553.155 208.845 554.501 210.5 554.501C212.154 554.501 213.5 553.155 213.5 551.5C213.5 549.845 212.154 548.5 210.5 548.5ZM210.5 557C207.467 557 205 554.532 205 551.499C205 548.467 207.467 546 210.5 546C213.533 546 216 548.467 216 551.499C216 554.532 213.533 557 210.5 557Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M210.664 548C209.926 548 209.328 547.476 209.328 546.831V542.421H204.336C203.599 542.421 203 541.897 203 541.252V537.169C203 536.523 203.599 536 204.336 536C205.074 536 205.672 536.523 205.672 537.169V540.083H210.664C211.402 540.083 212 540.607 212 541.252V546.831C212 547.476 211.402 548 210.664 548Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M166.375 557C165.616 557 165 556.477 165 555.834V548.513C165 547.869 165.616 547.347 166.375 547.347H170.251V541.166C170.251 540.522 170.867 540 171.625 540C172.384 540 173 540.522 173 541.166V548.513C173 549.157 172.384 549.679 171.625 549.679H167.749V555.834C167.749 556.477 167.133 557 166.375 557Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M165.501 558.5C163.845 558.5 162.5 559.846 162.5 561.5C162.5 563.155 163.845 564.502 165.501 564.502C167.155 564.502 168.501 563.155 168.501 561.5C168.501 559.846 167.155 558.5 165.501 558.5ZM165.501 567C162.467 567 160 564.533 160 561.5C160 558.467 162.467 556 165.501 556C168.533 556 171 558.467 171 561.5C171 564.533 168.533 567 165.501 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M154.5 548.5C152.845 548.5 151.499 549.845 151.499 551.5C151.499 553.155 152.845 554.501 154.5 554.501C156.154 554.501 157.5 553.155 157.5 551.5C157.5 549.845 156.154 548.5 154.5 548.5ZM154.5 557C151.467 557 149 554.532 149 551.499C149 548.467 151.467 546 154.5 546C157.533 546 160 548.467 160 551.499C160 554.532 157.533 557 154.5 557Z"
                          fill="#FF1236"
                        />

                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M154.336 548C153.598 548 153 547.476 153 546.831V541.252C153 540.607 153.598 540.083 154.336 540.083H159.328V537.169C159.328 536.523 159.927 536 160.664 536C161.402 536 162 536.523 162 537.169V541.252C162 541.897 161.402 542.421 160.664 542.421H155.672V546.831C155.672 547.476 155.074 548 154.336 548Z"
                          fill="#FF1236"
                        />
                      </g>

                      {/* skull */}
                      <g id="skull-5">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M126.408 423H77.7809C71.2844 423 66 417.662 66 411.1C66 404.539 71.2844 399.201 77.7809 399.201C79.304 399.201 80.802 399.499 82.2007 400.074C83.104 392.758 89.2986 387.079 96.7818 387.079C98.2016 387.079 99.5986 387.284 100.951 387.69C103.236 380.255 110.176 375 117.985 375C126.939 375 134.373 381.645 135.62 390.424C137.131 389.971 138.696 389.743 140.29 389.743C144.038 389.743 147.568 390.982 150.5 393.326C151.07 393.782 151.167 394.619 150.716 395.195C150.264 395.772 149.436 395.867 148.866 395.413C146.403 393.443 143.438 392.402 140.29 392.402C138.454 392.402 136.666 392.763 134.976 393.475C134.58 393.644 134.127 393.604 133.765 393.371C133.401 393.139 133.174 392.742 133.154 392.309C132.781 384.095 126.118 377.66 117.985 377.66C110.905 377.66 104.663 382.727 103.144 389.708C103.06 390.092 102.813 390.418 102.469 390.6C102.125 390.783 101.717 390.801 101.359 390.652C99.8948 390.046 98.3551 389.738 96.7818 389.738C90.1312 389.738 84.7207 395.203 84.7207 401.921C84.7219 401.944 84.7344 402.155 84.7356 402.177C84.7447 402.668 84.4856 403.125 84.061 403.365C83.6376 403.604 83.1166 403.589 82.7074 403.324C81.23 402.366 79.5271 401.86 77.7809 401.86C72.7367 401.86 68.6331 406.006 68.6331 411.1C68.6331 416.195 72.7367 420.34 77.7809 420.34H126.408C127.134 420.34 127.724 420.936 127.724 421.67C127.724 422.405 127.134 423 126.408 423Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M87.6446 409C87.0659 409 86.53 408.6 86.351 407.978C85.1319 403.739 81.5162 400.889 77.3547 400.889C76.6063 400.889 76 400.242 76 399.444C76 398.646 76.6063 398 77.3547 398C82.713 398 87.3688 401.669 88.94 407.13C89.1596 407.893 88.7575 408.701 88.0426 408.936C87.9105 408.979 87.7767 409 87.6446 409Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M102.825 400C102.271 400 101.744 399.705 101.515 399.214C100.51 397.068 100 394.789 100 392.44C100 388.886 101.179 385.468 103.408 382.555C103.854 381.97 104.738 381.824 105.387 382.229C106.032 382.633 106.194 383.432 105.747 384.016C103.849 386.497 102.844 389.41 102.844 392.44C102.844 394.444 103.278 396.386 104.134 398.215C104.44 398.868 104.101 399.621 103.377 399.898C103.197 399.967 103.01 400 102.825 400Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M127.395 398C127.121 398 126.844 397.917 126.601 397.745C125.967 397.292 125.809 396.397 126.249 395.745C129.513 390.896 134.88 388 140.603 388C141.374 388 142 388.644 142 389.438C142 390.23 141.374 390.874 140.603 390.874C135.795 390.874 131.287 393.307 128.543 397.382C128.273 397.784 127.837 398 127.395 398Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M105.655 448C104.913 448 104.31 447.422 104.31 446.709V434.027H93.3451C92.6026 434.027 92 433.449 92 432.737V421.291C92 420.578 92.6026 420 93.3451 420C94.0871 420 94.6897 420.578 94.6897 421.291V431.445H105.655C106.397 431.445 107 432.023 107 432.737V446.709C107 447.422 106.397 448 105.655 448Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M107.5 437H104.5C103.672 437 103 436.328 103 435.5C103 434.672 103.672 434 104.5 434H107.5C108.328 434 109 434.672 109 435.5C109 436.328 108.328 437 107.5 437Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M120.511 437H115.489C114.667 437 114 436.328 114 435.5C114 434.672 114.667 434 115.489 434H120.511C121.333 434 122 434.672 122 435.5C122 436.328 121.333 437 120.511 437Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M132.5 437H129.5C128.672 437 128 436.328 128 435.5C128 434.672 128.672 434 129.5 434H132.5C133.328 434 134 434.672 134 435.5C134 436.328 133.328 437 132.5 437Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M136.266 423C136.161 423 136.054 422.985 135.947 422.953C135.271 422.749 134.865 421.951 135.041 421.171L135.51 419.093C135.686 418.313 136.373 417.843 137.053 418.048C137.73 418.251 138.135 419.049 137.959 419.829L137.489 421.907C137.342 422.565 136.828 423 136.266 423Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M157.266 429C157.161 429 157.054 428.985 156.947 428.953C156.271 428.749 155.865 427.952 156.041 427.171L156.51 425.093C156.685 424.314 157.374 423.843 158.053 424.048C158.73 424.251 159.135 425.049 158.959 425.829L158.489 427.907C158.342 428.565 157.828 429 157.266 429Z"
                          fill="#FF1236"
                        />

                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M145.61 442C145.121 442 144.625 441.937 144.134 441.807L138.452 440.302C135.989 439.65 134.249 437.475 134.123 434.89L134.002 432.428C133.964 431.677 134.533 431.037 135.27 431.001C136.013 430.977 136.636 431.541 136.673 432.29L136.794 434.754C136.862 436.146 137.8 437.318 139.125 437.669L144.808 439.174C146.137 439.528 147.514 438.967 148.241 437.786L149.528 435.696C149.92 435.059 150.744 434.867 151.372 435.265C151.998 435.664 152.188 436.503 151.796 437.14L150.508 439.231C149.428 440.986 147.571 442 145.61 442Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M142.494 409.764C141.838 409.764 141.19 409.938 140.61 410.278C139.748 410.784 139.136 411.594 138.885 412.56C138.633 413.526 138.773 414.532 139.278 415.393C139.783 416.254 140.592 416.867 141.559 417.118C143.55 417.635 145.598 416.438 146.116 414.444C146.368 413.478 146.228 412.472 145.724 411.611C145.219 410.75 144.408 410.137 143.442 409.886C143.129 409.804 142.81 409.764 142.494 409.764ZM142.5 420C141.958 420 141.41 419.932 140.863 419.791C139.183 419.352 137.774 418.287 136.896 416.791C136.018 415.293 135.775 413.544 136.213 411.864C136.65 410.185 137.716 408.776 139.212 407.897C140.71 407.018 142.457 406.775 144.138 407.213C147.607 408.116 149.693 411.672 148.789 415.14C148.029 418.06 145.386 420 142.5 420Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M152.883 416.557C152.364 418.551 153.564 420.595 155.558 421.115C156.525 421.367 157.53 421.226 158.391 420.721C159.252 420.216 159.864 419.406 160.116 418.44C160.368 417.475 160.228 416.469 159.723 415.608C159.218 414.747 158.407 414.134 157.442 413.883C155.441 413.363 153.402 414.564 152.883 416.557ZM156.512 424C155.961 424 155.408 423.929 154.863 423.788C151.394 422.884 149.307 419.329 150.211 415.862C151.114 412.396 154.667 410.307 158.138 411.211C161.606 412.115 163.693 415.67 162.789 419.136C162.352 420.815 161.286 422.224 159.789 423.103C158.779 423.697 157.653 424 156.512 424Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M146.933 425.05C147.05 425.05 147.169 425.065 147.285 425.097C147.74 425.22 148.104 425.575 148.253 426.039L148.515 426.855C148.577 427.049 148.781 427.154 148.975 427.09C149.159 427.025 149.262 426.813 149.199 426.617L148.083 423.15C148.045 423.029 147.951 422.938 147.832 422.907C147.716 422.875 147.589 422.907 147.498 422.992L144.898 425.453C144.751 425.59 144.74 425.829 144.874 425.982C144.922 426.036 144.98 426.073 145.046 426.091C145.093 426.104 145.25 426.133 145.383 426.007L145.997 425.427C146.257 425.181 146.592 425.05 146.933 425.05ZM148.863 430C147.891 430 146.967 429.53 146.372 428.735C145.743 429.015 145.033 429.076 144.347 428.89C143.758 428.731 143.228 428.399 142.816 427.927C141.651 426.596 141.745 424.526 143.025 423.313L145.626 420.852C146.414 420.106 147.503 419.826 148.535 420.107C149.565 420.387 150.383 421.18 150.722 422.231L151.837 425.698C152.388 427.406 151.497 429.261 149.854 429.833C149.526 429.947 149.191 430 148.863 430Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M147.53 430.055C147.638 430.055 147.749 430.068 147.858 430.097L148.179 430.181C148.737 430.327 149.132 430.823 149.151 431.402C149.167 431.858 149.467 432.239 149.897 432.353C150.324 432.461 150.776 432.279 151.012 431.888C151.309 431.392 151.894 431.151 152.452 431.299L154.227 431.764L156.972 425.88C157.238 425.31 157.87 425.012 158.477 425.17L160.549 425.711C160.905 425.804 161.277 425.753 161.594 425.566C161.912 425.378 162.138 425.078 162.231 424.72L163.927 418.175C165.941 410.408 161.324 402.324 153.636 400.155C149.874 399.093 145.895 399.609 142.432 401.607C138.897 403.645 136.284 407.071 135.264 411.006L133.648 417.242C133.555 417.6 133.607 417.973 133.793 418.293C133.979 418.612 134.278 418.839 134.634 418.932L136.706 419.474C137.313 419.633 137.721 420.203 137.676 420.832L137.215 427.312L138.99 427.777C139.547 427.923 139.942 428.419 139.962 428.997C139.977 429.453 140.278 429.836 140.709 429.949C141.142 430.065 141.588 429.875 141.822 429.484C142.119 428.988 142.707 428.75 143.265 428.895L143.585 428.98C144.142 429.125 144.536 429.621 144.556 430.2C144.572 430.655 144.872 431.037 145.304 431.15C145.731 431.262 146.181 431.077 146.416 430.686C146.656 430.288 147.082 430.055 147.53 430.055ZM150.16 435C149.857 435 149.548 434.961 149.242 434.881C148.369 434.653 147.645 434.124 147.169 433.416C146.408 433.8 145.519 433.909 144.647 433.679C143.774 433.451 143.051 432.921 142.574 432.214C141.815 432.599 140.928 432.706 140.053 432.478C138.835 432.158 137.908 431.253 137.536 430.097L135.513 429.568C134.906 429.409 134.499 428.839 134.543 428.21L135.004 421.73L133.979 421.462C132.95 421.193 132.087 420.537 131.549 419.615C131.011 418.694 130.863 417.618 131.13 416.584L132.746 410.347C133.941 405.738 136.999 401.725 141.135 399.34C145.21 396.989 149.9 396.385 154.34 397.639C163.382 400.19 168.813 409.699 166.445 418.834L164.749 425.378C164.48 426.412 163.828 427.28 162.911 427.82C161.994 428.36 160.921 428.509 159.893 428.241L158.868 427.973L156.123 433.856C155.858 434.427 155.223 434.727 154.618 434.566L152.594 434.037C151.932 434.656 151.065 435 150.16 435Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M98.5 429C97.672 429 97 428.328 97 427.499V421.501C97 420.672 97.672 420 98.5 420C99.328 420 100 420.672 100 421.501V427.499C100 428.328 99.328 429 98.5 429Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M98.5 439C97.672 439 97 438.328 97 437.499V431.501C97 430.672 97.672 430 98.5 430C99.328 430 100 430.672 100 431.501V437.499C100 438.328 99.328 439 98.5 439Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M91.5003 439C90.6722 439 90 438.328 90 437.499V431.501C90 430.672 90.6722 430 91.5003 430C92.3278 430 93 430.672 93 431.501V437.499C93 438.328 92.3278 439 91.5003 439Z"
                          fill="#FF1236"
                        />
                      </g>
                      {/* end skull */}
                      <g id="skull-3">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M305.93 526.803H314.682V521.17L305.93 526.803ZM315.841 529H302.159C301.65 529 301.201 528.685 301.051 528.225C300.902 527.764 301.086 527.264 301.508 526.994L315.189 518.19C315.546 517.961 316.005 517.938 316.383 518.127C316.763 518.317 317 518.691 317 519.098V527.903C317 528.509 316.481 529 315.841 529Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M356.505 526.244V541.349L358.089 539.931C358.744 539.343 359.597 538.985 360.496 538.892V526.244H356.505ZM355.449 545C355.213 545 354.975 544.94 354.766 544.818C354.746 544.808 354.576 544.717 354.565 544.71C354.212 544.502 354 544.151 354 543.773V525.121C354 524.502 354.561 524 355.252 524H361.748C362.44 524 363 524.502 363 525.121V540.083C363 540.434 362.817 540.764 362.505 540.976C362.192 541.189 361.789 541.258 361.41 541.163C360.843 541.02 360.263 541.154 359.859 541.516L356.335 544.672C356.093 544.888 355.773 545 355.449 545Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M303.184 587.818H333.622V586.102C332.339 585.595 331.128 584.996 330.006 584.316L327.552 586.771C326.16 588.16 323.895 588.16 322.504 586.771L319.588 583.856C318.198 582.466 318.198 580.202 319.588 578.81L322.041 576.357C320.738 574.229 319.786 571.938 319.205 569.529H315.743C313.775 569.529 312.173 567.929 312.173 565.961V561.84C312.173 559.872 313.775 558.271 315.743 558.271H319.205C319.787 555.861 320.738 553.571 322.041 551.442L319.588 548.99C318.197 547.599 318.197 545.336 319.588 543.945L322.504 541.03C323.895 539.639 326.16 539.639 327.552 541.03L330.004 543.482C332.133 542.179 334.424 541.229 336.836 540.647V537.186C336.836 535.218 338.437 533.618 340.405 533.618H344.528C346.496 533.618 348.096 535.218 348.096 537.186V540.647C350.087 541.128 352.001 541.866 353.816 542.851V521.184H315.312L303.184 529.421V587.818ZM334.714 590H302.092C301.489 590 301 589.512 301 588.909V528.842C301 528.48 301.179 528.142 301.479 527.939L314.362 519.189C314.544 519.065 314.757 519 314.976 519H354.908C355.511 519 356 519.489 356 520.091V544.77C356 545.17 355.78 545.539 355.428 545.729C355.077 545.92 354.648 545.904 354.312 545.684C351.988 544.17 349.457 543.13 346.789 542.592C346.279 542.49 345.913 542.042 345.913 541.522V537.185C345.913 536.421 345.292 535.8 344.528 535.8H340.405C339.641 535.8 339.019 536.421 339.019 537.185V541.522C339.019 542.042 338.653 542.49 338.144 542.592C335.396 543.146 332.811 544.219 330.456 545.782C330.022 546.068 329.448 546.012 329.081 545.645L326.008 542.573C325.467 542.032 324.589 542.032 324.048 542.573L321.133 545.487C320.592 546.027 320.592 546.906 321.133 547.446L324.205 550.518C324.573 550.885 324.63 551.461 324.343 551.893C322.78 554.246 321.707 556.831 321.152 559.578C321.05 560.087 320.602 560.453 320.082 560.453H315.743C314.979 560.453 314.358 561.074 314.358 561.839V565.961C314.358 566.723 314.979 567.345 315.743 567.345H320.082C320.602 567.345 321.05 567.711 321.152 568.22C321.707 570.965 322.78 573.551 324.343 575.905C324.63 576.338 324.573 576.913 324.205 577.281L321.133 580.352C320.593 580.892 320.592 581.772 321.133 582.311L324.048 585.226C324.589 585.766 325.467 585.766 326.008 585.226L329.081 582.153C329.446 581.786 330.023 581.727 330.456 582.016C331.84 582.935 333.398 583.711 335.086 584.321C335.518 584.478 335.806 584.888 335.806 585.348V588.909C335.806 589.512 335.317 590 334.714 590Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M310.248 595.493H335.752V590.506H310.248V595.493ZM336.876 598H309.124C308.503 598 308 597.439 308 596.747V589.254C308 588.561 308.503 588 309.124 588H336.876C337.496 588 338 588.561 338 589.254V596.747C338 597.439 337.496 598 336.876 598Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M336.107 578C335.931 578 335.752 577.956 335.587 577.862C330.29 574.855 327 569.164 327 563.005C327 553.629 334.497 546 343.711 546C350.224 546 356.188 549.905 358.903 555.949C359.149 556.497 358.912 557.143 358.375 557.394C357.837 557.643 357.201 557.402 356.955 556.856C354.587 551.584 349.389 548.18 343.711 548.18C335.678 548.18 329.141 554.831 329.141 563.005C329.141 568.374 332.011 573.337 336.63 575.959C337.147 576.252 337.332 576.916 337.044 577.441C336.848 577.799 336.484 578 336.107 578Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M326.803 588C325.892 588 324.982 587.653 324.289 586.96L321.386 584.056C320.001 582.672 320 580.415 321.386 579.028L323.829 576.585C322.531 574.464 321.582 572.182 321.004 569.781H317.555C315.595 569.781 314 568.187 314 566.226V562.12C314 560.16 315.595 558.564 317.555 558.564H321.004C321.583 556.162 322.531 553.881 323.829 551.76L321.386 549.317C320 547.931 320 545.676 321.386 544.29L324.289 541.386C325.675 540 327.931 540 329.317 541.386L331.76 543.828C333.881 542.53 336.162 541.583 338.564 541.004V537.555C338.564 535.595 340.159 534 342.119 534H346.226C348.186 534 349.781 535.595 349.781 537.555V541.004C352.183 541.583 354.465 542.53 356.585 543.828L359.028 541.386C360.37 540.042 362.713 540.042 364.056 541.386L366.959 544.29C367.63 544.961 368 545.853 368 546.803C368 547.753 367.63 548.646 366.959 549.317L364.516 551.761C365.569 553.482 366.397 555.331 366.984 557.267C367.158 557.842 366.833 558.449 366.258 558.623C365.685 558.798 365.077 558.473 364.903 557.897C364.291 555.879 363.39 553.965 362.223 552.21C361.938 551.779 361.994 551.206 362.361 550.84L365.421 547.78C365.682 547.519 365.825 547.172 365.825 546.803C365.825 546.434 365.682 546.088 365.421 545.828L362.518 542.924C361.997 542.402 361.087 542.402 360.567 542.924L357.506 545.984C357.139 546.351 356.567 546.407 356.135 546.121C353.791 544.564 351.215 543.495 348.478 542.943C347.971 542.841 347.606 542.395 347.606 541.877V537.555C347.606 536.794 346.987 536.175 346.226 536.175H342.119C341.358 536.175 340.739 536.794 340.739 537.555V541.877C340.739 542.395 340.374 542.841 339.867 542.943C337.131 543.495 334.555 544.564 332.21 546.121C331.777 546.406 331.205 546.35 330.84 545.984L327.779 542.924C327.24 542.385 326.366 542.385 325.828 542.924L322.923 545.827C322.385 546.365 322.385 547.241 322.924 547.78L325.984 550.84C326.349 551.206 326.407 551.779 326.121 552.21C324.565 554.555 323.495 557.131 322.943 559.867C322.84 560.374 322.394 560.739 321.877 560.739H317.555C316.794 560.739 316.175 561.358 316.175 562.12V566.226C316.175 566.987 316.794 567.606 317.555 567.606H321.877C322.394 567.606 322.84 567.971 322.943 568.478C323.494 571.213 324.564 573.79 326.121 576.136C326.407 576.567 326.349 577.139 325.984 577.505L322.923 580.566C322.386 581.105 322.385 581.981 322.923 582.518L325.828 585.423C326.366 585.96 327.24 585.96 327.779 585.423L330.84 582.361C331.204 581.995 331.778 581.936 332.21 582.224C333.588 583.139 335.14 583.913 336.821 584.521C337.386 584.726 337.678 585.35 337.474 585.915C337.269 586.478 336.644 586.771 336.081 586.566C334.535 586.007 333.086 585.318 331.761 584.515L329.317 586.96C328.624 587.653 327.713 587.999 326.803 588Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M335.565 587C335.438 587 335.311 586.979 335.185 586.933C325.503 583.404 319 574.072 319 563.712C319 550.085 329.992 539 343.502 539C354.381 539 363.804 546.055 366.952 556.553C367.131 557.149 366.796 557.778 366.205 557.958C365.614 558.14 364.99 557.802 364.812 557.206C361.952 547.665 353.388 541.255 343.502 541.255C331.224 541.255 321.236 551.329 321.236 563.712C321.236 573.126 327.147 581.605 335.945 584.812C336.525 585.024 336.826 585.67 336.616 586.256C336.452 586.715 336.022 587 335.565 587Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M342.56 564.564H344.439V561.436H342.56V564.564ZM344.787 567H342.214C340.994 567 340 566.056 340 564.894V561.106C340 559.944 340.994 559 342.214 559H344.787C346.007 559 347 559.944 347 561.106V564.894C347 566.056 346.007 567 344.787 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M354.56 564.564H356.439V561.436H354.56V564.564ZM356.786 567H354.213C352.992 567 352 566.056 352 564.894V561.106C352 559.944 352.992 559 354.213 559H356.786C358.006 559 359 559.944 359 561.106V564.894C359 566.056 358.006 567 356.786 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M362.856 567C362.225 567 361.712 566.455 361.712 565.782V562.858C361.248 563.141 360.646 563.047 360.281 562.599C359.866 562.09 359.917 561.322 360.394 560.881L362.105 559.298C362.444 558.986 362.923 558.912 363.331 559.109C363.738 559.308 364 559.741 364 560.218V565.782C364 566.455 363.487 567 362.856 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M364.798 567H361.201C360.537 567 360 566.553 360 566C360 565.447 360.537 565 361.201 565H364.798C365.462 565 366 565.447 366 566C366 566.553 365.462 567 364.798 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M377.856 567C377.224 567 376.712 566.455 376.712 565.782V562.858C376.246 563.141 375.645 563.047 375.281 562.599C374.866 562.09 374.917 561.322 375.394 560.881L377.106 559.298C377.445 558.986 377.924 558.912 378.331 559.109C378.738 559.308 379 559.741 379 560.218V565.782C379 566.455 378.487 567 377.856 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M378.798 567H375.201C374.538 567 374 566.553 374 566C374 565.447 374.538 565 375.201 565H378.798C379.461 565 380 565.447 380 566C380 566.553 379.461 567 378.798 567Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M342.56 574.564H344.439V571.436H342.56V574.564ZM344.787 577H342.214C340.994 577 340 576.055 340 574.894V571.106C340 569.944 340.994 569 342.214 569H344.787C346.007 569 347 569.944 347 571.106V574.894C347 576.055 346.007 577 344.787 577Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M349.856 577C349.225 577 348.712 576.455 348.712 575.782V572.859C348.247 573.142 347.645 573.047 347.281 572.601C346.866 572.093 346.917 571.324 347.394 570.882L349.105 569.298C349.444 568.986 349.923 568.912 350.33 569.109C350.738 569.308 351 569.741 351 570.218V575.782C351 576.455 350.487 577 349.856 577Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M351.798 575H348.202C347.537 575 347 574.553 347 574C347 573.447 347.537 573 348.202 573H351.798C352.462 573 353 573.447 353 574C353 574.553 352.462 575 351.798 575Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M354.56 574.564H356.439V571.436H354.56V574.564ZM356.786 577H354.213C352.992 577 352 576.055 352 574.894V571.106C352 569.944 352.992 569 354.213 569H356.786C358.006 569 359 569.944 359 571.106V574.894C359 576.055 358.006 577 356.786 577Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M362.856 577C362.225 577 361.712 576.455 361.712 575.782V572.859C361.248 573.142 360.646 573.047 360.281 572.601C359.866 572.093 359.917 571.324 360.394 570.882L362.105 569.298C362.444 568.986 362.923 568.912 363.33 569.109C363.738 569.308 364 569.741 364 570.218V575.782C364 576.455 363.487 577 362.856 577Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M364.798 575H361.201C360.537 575 360 574.553 360 574C360 573.447 360.537 573 361.201 573H364.798C365.462 573 366 573.447 366 574C366 574.553 365.462 575 364.798 575Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M369.56 574.564H371.439V571.436H369.56V574.564ZM371.786 577H369.214C367.993 577 367 576.055 367 574.894V571.106C367 569.944 367.993 569 369.214 569H371.786C373.006 569 374 569.944 374 571.106V574.894C374 576.055 373.006 577 371.786 577Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M349.856 585C349.225 585 348.712 584.455 348.712 583.782V580.859C348.247 581.142 347.645 581.047 347.281 580.601C346.866 580.093 346.917 579.324 347.394 578.882L349.105 577.299C349.444 576.985 349.923 576.912 350.33 577.109C350.738 577.308 351 577.741 351 578.217V583.782C351 584.455 350.487 585 349.856 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M351.798 585H348.202C347.537 585 347 584.553 347 584C347 583.447 347.537 583 348.202 583H351.798C352.462 583 353 583.447 353 584C353 584.553 352.462 585 351.798 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M362.856 585C362.225 585 361.712 584.455 361.712 583.782V580.859C361.248 581.142 360.646 581.047 360.281 580.601C359.866 580.093 359.917 579.324 360.394 578.882L362.105 577.299C362.444 576.985 362.923 576.912 363.33 577.109C363.738 577.308 364 577.741 364 578.217V583.782C364 584.455 363.487 585 362.856 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M364.798 585H361.201C360.537 585 360 584.553 360 584C360 583.447 360.537 583 361.201 583H364.798C365.462 583 366 583.447 366 584C366 584.553 365.462 585 364.798 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M369.56 582.565H371.439V579.436H369.56V582.565ZM371.786 585H369.214C367.993 585 367 584.055 367 582.894V579.106C367 577.944 367.993 577 369.214 577H371.786C373.006 577 374 577.944 374 579.106V582.894C374 584.055 373.006 585 371.786 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M377.856 585C377.224 585 376.712 584.455 376.712 583.782V580.859C376.246 581.142 375.645 581.047 375.281 580.601C374.866 580.093 374.917 579.324 375.394 578.882L377.106 577.299C377.445 576.985 377.924 576.912 378.33 577.109C378.738 577.308 379 577.741 379 578.217V583.782C379 584.455 378.487 585 377.856 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M378.798 585H375.201C374.538 585 374 584.553 374 584C374 583.447 374.538 583 375.201 583H378.798C379.461 583 380 583.447 380 584C380 584.553 379.461 585 378.798 585Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M342.56 592.565H344.439V589.436H342.56V592.565ZM344.787 595H342.214C340.994 595 340 594.056 340 592.894V589.106C340 587.944 340.994 587 342.214 587H344.787C346.007 587 347 587.944 347 589.106V592.894C347 594.056 346.007 595 344.787 595Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M349.856 595C349.225 595 348.712 594.455 348.712 593.782V590.86C348.247 591.142 347.645 591.048 347.281 590.601C346.866 590.093 346.917 589.324 347.394 588.883L349.105 587.299C349.444 586.985 349.923 586.912 350.33 587.11C350.738 587.308 351 587.741 351 588.218V593.782C351 594.455 350.487 595 349.856 595Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M351.798 595H348.202C347.537 595 347 594.553 347 594C347 593.447 347.537 593 348.202 593H351.798C352.462 593 353 593.447 353 594C353 594.553 352.462 595 351.798 595Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M354.56 592.565H356.439V589.436H354.56V592.565ZM356.786 595H354.213C352.992 595 352 594.056 352 592.894V589.106C352 587.944 352.992 587 354.213 587H356.786C358.006 587 359 587.944 359 589.106V592.894C359 594.056 358.006 595 356.786 595Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M369.56 592.565H371.439V589.436H369.56V592.565ZM371.786 595H369.214C367.993 595 367 594.056 367 592.894V589.106C367 587.944 367.993 587 369.214 587H371.786C373.006 587 374 587.944 374 589.106V592.894C374 594.056 373.006 595 371.786 595Z"
                          fill="#FF1236"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M377.856 595C377.224 595 376.712 594.455 376.712 593.782V590.86C376.246 591.142 375.645 591.048 375.281 590.601C374.866 590.093 374.917 589.324 375.394 588.883L377.106 587.299C377.445 586.985 377.924 586.912 378.33 587.11C378.738 587.308 379 587.741 379 588.218V593.782C379 594.455 378.487 595 377.856 595Z"
                          fill="#FF1236"
                        />
                      </g>

                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M249.656 210C248.36 210 247.312 208.996 247.312 207.756V197.163L245.883 198.354C244.908 199.161 243.43 199.07 242.576 198.132C241.726 197.197 241.828 195.779 242.806 194.967L248.118 190.55C248.812 189.975 249.793 189.836 250.629 190.203C251.465 190.568 252 191.366 252 192.244V207.756C252 208.996 250.952 210 249.656 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M254.704 210H244.297C243.027 210 242 208.881 242 207.5C242 206.118 243.027 205 244.297 205H254.704C255.973 205 257 206.118 257 207.5C257 208.881 255.973 210 254.704 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.655 210C289.36 210 288.311 208.996 288.311 207.756V197.163L286.883 198.354C285.908 199.161 284.429 199.07 283.575 198.132C282.726 197.197 282.829 195.779 283.806 194.967L289.117 190.55C289.811 189.975 290.795 189.836 291.628 190.203C292.465 190.568 293 191.366 293 192.244V207.756C293 208.996 291.951 210 290.655 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M294.704 210H284.297C283.028 210 282 208.881 282 207.5C282 206.118 283.028 205 284.297 205H294.704C295.973 205 297 206.118 297 207.5C297 208.881 295.973 210 294.704 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M306.932 194.486C306.8 194.486 306.689 194.592 306.689 194.718V205.281C306.689 205.408 306.8 205.513 306.932 205.513H314.065C314.2 205.513 314.311 205.408 314.311 205.281V194.718C314.311 194.592 314.2 194.486 314.065 194.486H306.932ZM314.065 210H306.932C304.212 210 302 207.883 302 205.281V194.718C302 192.116 304.212 190 306.932 190H314.065C316.785 190 319 192.116 319 194.718V205.281C319 207.883 316.785 210 314.065 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M331.656 210C330.36 210 329.312 208.996 329.312 207.756V197.163L327.883 198.354C326.908 199.161 325.429 199.07 324.575 198.132C323.726 197.197 323.828 195.779 324.806 194.967L330.118 190.55C330.813 189.975 331.793 189.836 332.629 190.203C333.464 190.568 334 191.366 334 192.244V207.756C334 208.996 332.951 210 331.656 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M336.703 210H326.297C325.027 210 324 208.881 324 207.5C324 206.118 325.027 205 326.297 205H336.703C337.973 205 339 206.118 339 207.5C339 208.881 337.973 210 336.703 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M348.932 194.486C348.799 194.486 348.689 194.592 348.689 194.718V205.281C348.689 205.408 348.799 205.513 348.932 205.513H356.065C356.2 205.513 356.311 205.408 356.311 205.281V194.718C356.311 194.592 356.2 194.486 356.065 194.486H348.932ZM356.065 210H348.932C346.212 210 344 207.883 344 205.281V194.718C344 192.116 346.212 190 348.932 190H356.065C358.785 190 361 192.116 361 194.718V205.281C361 207.883 358.785 210 356.065 210Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M223.932 219.486C223.8 219.486 223.689 219.592 223.689 219.72V230.28C223.689 230.409 223.8 230.515 223.932 230.515H231.065C231.201 230.515 231.31 230.409 231.31 230.28V219.72C231.31 219.592 231.201 219.486 231.065 219.486H223.932ZM231.065 235H223.932C221.212 235 219 232.882 219 230.279V219.72C219 217.118 221.212 215 223.932 215H231.065C233.785 215 236 217.118 236 219.72V230.279C236 232.882 233.785 235 231.065 235Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M249.656 235C248.36 235 247.312 233.997 247.312 232.757V222.162L245.883 223.352C244.908 224.161 243.43 224.066 242.576 223.131C241.726 222.195 241.828 220.778 242.806 219.966L248.118 215.55C248.812 214.972 249.793 214.838 250.629 215.202C251.465 215.568 252 216.365 252 217.243V232.757C252 233.997 250.952 235 249.656 235Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M254.704 234H244.297C243.027 234 242 232.882 242 231.5C242 230.118 243.027 229 244.297 229H254.704C255.973 229 257 230.118 257 231.5C257 232.882 255.973 234 254.704 234Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M265.932 219.486C265.799 219.486 265.689 219.592 265.689 219.72V230.28C265.689 230.409 265.799 230.515 265.932 230.515H273.065C273.2 230.515 273.31 230.409 273.31 230.28V219.72C273.31 219.592 273.2 219.486 273.065 219.486H265.932ZM273.065 235H265.932C263.212 235 261 232.882 261 230.279V219.72C261 217.118 263.212 215 265.932 215H273.065C275.785 215 278 217.118 278 219.72V230.279C278 232.882 275.785 235 273.065 235Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.655 235C289.36 235 288.311 233.997 288.311 232.757V222.162L286.883 223.352C285.908 224.161 284.429 224.066 283.575 223.131C282.726 222.195 282.829 220.778 283.806 219.966L289.117 215.55C289.811 214.972 290.795 214.838 291.628 215.202C292.465 215.568 293 216.365 293 217.243V232.757C293 233.997 291.951 235 290.655 235Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M294.704 234H284.297C283.028 234 282 232.882 282 231.5C282 230.118 283.028 229 284.297 229H294.704C295.973 229 297 230.118 297 231.5C297 232.882 295.973 234 294.704 234Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M372.655 235C371.36 235 370.311 233.997 370.311 232.757V222.162L368.883 223.352C367.908 224.161 366.428 224.066 365.575 223.131C364.726 222.195 364.829 220.778 365.806 219.966L371.118 215.55C371.811 214.972 372.795 214.838 373.628 215.202C374.464 215.568 375 216.365 375 217.243V232.757C375 233.997 373.951 235 372.655 235Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.703 234H367.297C366.027 234 365 232.882 365 231.5C365 230.118 366.027 229 367.297 229H377.703C378.973 229 380 230.118 380 231.5C380 232.882 378.973 234 377.703 234Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M223.932 243.486C223.8 243.486 223.689 243.592 223.689 243.721V254.28C223.689 254.41 223.8 254.514 223.932 254.514H231.065C231.201 254.514 231.31 254.41 231.31 254.28V243.721C231.31 243.592 231.201 243.486 231.065 243.486H223.932ZM231.065 259H223.932C221.212 259 219 256.882 219 254.279V243.72C219 241.118 221.212 239 223.932 239H231.065C233.785 239 236 241.118 236 243.72V254.279C236 256.882 233.785 259 231.065 259Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M265.932 243.486C265.799 243.486 265.689 243.592 265.689 243.721V254.28C265.689 254.41 265.799 254.514 265.932 254.514H273.065C273.2 254.514 273.31 254.41 273.31 254.28V243.721C273.31 243.592 273.2 243.486 273.065 243.486H265.932ZM273.065 259H265.932C263.212 259 261 256.882 261 254.279V243.72C261 241.118 263.212 239 265.932 239H273.065C275.785 239 278 241.118 278 243.72V254.279C278 256.882 275.785 259 273.065 259Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M249.656 284C248.36 284 247.312 282.997 247.312 281.757V271.163L245.883 272.353C244.908 273.161 243.43 273.07 242.576 272.132C241.726 271.196 241.828 269.779 242.806 268.966L248.118 264.55C248.812 263.974 249.793 263.838 250.629 264.202C251.465 264.567 252 265.365 252 266.243V281.757C252 282.997 250.952 284 249.656 284Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M254.704 285H244.297C243.027 285 242 283.882 242 282.5C242 281.118 243.027 280 244.297 280H254.704C255.973 280 257 281.118 257 282.5C257 283.882 255.973 285 254.704 285Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M265.932 268.486C265.799 268.486 265.689 268.592 265.689 268.718V279.281C265.689 279.408 265.799 279.513 265.932 279.513H273.065C273.2 279.513 273.311 279.408 273.311 279.281V268.718C273.311 268.592 273.2 268.486 273.065 268.486H265.932ZM273.065 284H265.932C263.212 284 261 281.884 261 279.281V268.718C261 266.116 263.212 264 265.932 264H273.065C275.785 264 278 266.116 278 268.718V279.281C278 281.884 275.785 284 273.065 284Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M223.932 294.486C223.8 294.486 223.689 294.591 223.689 294.72V305.279C223.689 305.409 223.8 305.514 223.932 305.514H231.065C231.201 305.514 231.311 305.409 231.311 305.279V294.72C231.311 294.591 231.201 294.486 231.065 294.486H223.932ZM231.065 310H223.932C221.212 310 219 307.882 219 305.279V294.72C219 292.118 221.212 290 223.932 290H231.065C233.785 290 236 292.118 236 294.72V305.279C236 307.882 233.785 310 231.065 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M265.932 294.486C265.799 294.486 265.689 294.591 265.689 294.72V305.279C265.689 305.409 265.799 305.514 265.932 305.514H273.065C273.2 305.514 273.311 305.409 273.311 305.279V294.72C273.311 294.591 273.2 294.486 273.065 294.486H265.932ZM273.065 310H265.932C263.212 310 261 307.882 261 305.279V294.72C261 292.118 263.212 290 265.932 290H273.065C275.785 290 278 292.118 278 294.72V305.279C278 307.882 275.785 310 273.065 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.655 310C289.36 310 288.311 308.997 288.311 307.757V297.162L286.883 298.352C285.908 299.16 284.429 299.068 283.575 298.131C282.726 297.195 282.829 295.778 283.806 294.965L289.117 290.55C289.811 289.973 290.795 289.838 291.628 290.202C292.465 290.567 293 291.365 293 292.243V307.757C293 308.997 291.951 310 290.655 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M294.704 310H284.297C283.028 310 282 308.882 282 307.5C282 306.118 283.028 305 284.297 305H294.704C295.973 305 297 306.118 297 307.5C297 308.882 295.973 310 294.704 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M372.655 310C371.36 310 370.311 308.997 370.311 307.757V297.162L368.883 298.352C367.908 299.16 366.428 299.068 365.575 298.131C364.726 297.195 364.829 295.778 365.806 294.965L371.118 290.55C371.811 289.973 372.795 289.838 373.628 290.202C374.464 290.567 375 291.365 375 292.243V307.757C375 308.997 373.951 310 372.655 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M377.703 310H367.297C366.027 310 365 308.882 365 307.5C365 306.118 366.027 305 367.297 305H377.703C378.973 305 380 306.118 380 307.5C380 308.882 378.973 310 377.703 310Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M223.932 317.486C223.8 317.486 223.689 317.592 223.689 317.721V328.28C223.689 328.41 223.8 328.515 223.932 328.515H231.065C231.201 328.515 231.31 328.41 231.31 328.28V317.721C231.31 317.592 231.201 317.486 231.065 317.486H223.932ZM231.065 333H223.932C221.212 333 219 330.882 219 328.279V317.72C219 315.118 221.212 313 223.932 313H231.065C233.785 313 236 315.118 236 317.72V328.279C236 330.882 233.785 333 231.065 333Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M249.656 333C248.36 333 247.312 331.997 247.312 330.757V320.162L245.883 321.352C244.908 322.16 243.43 322.066 242.576 321.13C241.726 320.195 241.828 318.778 242.806 317.965L248.118 313.549C248.812 312.974 249.793 312.838 250.629 313.201C251.465 313.567 252 314.364 252 315.242V330.757C252 331.997 250.952 333 249.656 333Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M254.704 334H244.297C243.027 334 242 332.882 242 331.5C242 330.118 243.027 329 244.297 329H254.704C255.973 329 257 330.118 257 331.5C257 332.882 255.973 334 254.704 334Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M290.655 333C289.36 333 288.311 331.997 288.311 330.757V320.162L286.883 321.352C285.908 322.16 284.429 322.066 283.575 321.13C282.726 320.195 282.829 318.778 283.806 317.965L289.117 313.549C289.811 312.974 290.795 312.838 291.628 313.201C292.465 313.567 293 314.364 293 315.242V330.757C293 331.997 291.951 333 290.655 333Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M294.704 334H284.297C283.028 334 282 332.882 282 331.5C282 330.118 283.028 329 284.297 329H294.704C295.973 329 297 330.118 297 331.5C297 332.882 295.973 334 294.704 334Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M331.656 333C330.36 333 329.312 331.997 329.312 330.757V320.162L327.883 321.352C326.908 322.16 325.429 322.066 324.575 321.13C323.726 320.195 323.828 318.778 324.806 317.965L330.118 313.549C330.813 312.974 331.793 312.838 332.629 313.201C333.464 313.567 334 314.364 334 315.242V330.757C334 331.997 332.951 333 331.656 333Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M336.703 334H326.297C325.027 334 324 332.882 324 331.5C324 330.118 325.027 329 326.297 329H336.703C337.973 329 339 330.118 339 331.5C339 332.882 337.973 334 336.703 334Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M348.932 317.486C348.799 317.486 348.689 317.592 348.689 317.721V328.28C348.689 328.41 348.799 328.515 348.932 328.515H356.065C356.2 328.515 356.31 328.41 356.31 328.28V317.721C356.31 317.594 356.198 317.486 356.065 317.486H348.932ZM356.065 333H348.932C346.212 333 344 330.882 344 328.279V317.72C344 315.118 346.212 313 348.932 313H356.065C358.785 313 361 315.118 361 317.72V328.279C361 330.882 358.785 333 356.065 333Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M331.5 234.414C314.359 234.414 300.414 248.359 300.414 265.5C300.414 282.642 314.359 296.585 331.5 296.585C348.641 296.585 362.585 282.642 362.585 265.5C362.585 248.359 348.641 234.414 331.5 234.414ZM331.5 301C311.926 301 296 285.075 296 265.5C296 245.925 311.926 230 331.5 230C351.074 230 367 245.925 367 265.5C367 285.075 351.074 301 331.5 301Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M352.794 233C352.394 233 351.991 232.888 351.628 232.651C345.516 228.679 338.453 226.578 331.204 226.578C329.986 226.578 329 225.554 329 224.289C329 223.024 329.986 222 331.204 222C339.282 222 347.154 224.34 353.964 228.77C354.998 229.441 355.309 230.854 354.664 231.925C354.246 232.62 353.528 233 352.794 233Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M371.802 260C370.756 260 369.828 259.23 369.64 258.135C368.678 252.503 366.576 247.257 363.392 242.544C362.7 241.519 362.949 240.114 363.943 239.405C364.94 238.689 366.308 238.949 366.999 239.971C370.55 245.226 372.893 251.074 373.967 257.355C374.175 258.582 373.378 259.751 372.183 259.967C372.054 259.989 371.929 260 371.802 260Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M370.557 281C370.28 281 369.998 280.96 369.718 280.873C368.385 280.463 367.678 279.17 368.143 277.984C368.916 276.004 369.516 273.948 369.927 271.876C370.169 270.641 371.496 269.827 372.886 270.031C374.276 270.251 375.207 271.428 374.96 272.661C374.504 274.972 373.834 277.263 372.971 279.474C372.607 280.412 371.615 281 370.557 281Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M334.215 309C333.068 309 332.095 308.075 332.007 306.862C331.913 305.587 332.827 304.475 334.049 304.378C340.258 303.882 346.329 301.8 351.606 298.356C352.646 297.672 354.014 298.005 354.662 299.09C355.312 300.173 354.997 301.602 353.958 302.28C348.075 306.12 341.307 308.441 334.387 308.993C334.328 308.998 334.272 309 334.215 309Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M316.741 307C316.496 307 316.249 306.96 316.005 306.877C309.949 304.797 304.306 301.336 299.686 296.868C298.79 296.002 298.769 294.576 299.638 293.684C300.507 292.792 301.936 292.769 302.832 293.635C306.979 297.646 312.042 300.753 317.478 302.62C318.656 303.025 319.282 304.306 318.877 305.483C318.554 306.415 317.679 307 316.741 307Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M293.534 283C292.547 283 291.613 282.465 291.236 281.59C289.088 276.627 288 271.391 288 266.027C288 265.027 288.039 264.035 288.113 263.053C288.21 261.837 289.387 260.949 290.745 261.002C292.102 261.089 293.127 262.144 293.034 263.36C292.964 264.242 292.93 265.13 292.93 266.027C292.93 270.843 293.908 275.542 295.833 279.994C296.325 281.13 295.694 282.409 294.425 282.851C294.134 282.953 293.831 283 293.534 283Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M295.542 247C295.11 247 294.673 246.9 294.273 246.69C293.056 246.048 292.639 244.627 293.341 243.518C294.842 241.152 296.583 238.899 298.52 236.82C299.434 235.836 301.041 235.725 302.104 236.555C303.174 237.384 303.304 238.851 302.395 239.825C300.656 241.694 299.092 243.716 297.748 245.839C297.276 246.585 296.422 247 295.542 247Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M314.172 232C313.369 232 312.6 231.471 312.222 230.559C311.695 229.281 312.138 227.738 313.214 227.112C319.037 223.721 325.3 222 331.83 222C333.029 222 334 223.152 334 224.577C334 226.001 333.029 227.152 331.83 227.152C325.968 227.152 320.348 228.694 315.125 231.736C314.818 231.914 314.492 232 314.172 232Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M316.5 278C315.118 278 314 276.852 314 275.433V272.567C314 271.148 315.118 270 316.5 270C317.882 270 319 271.148 319 272.567V275.433C319 276.852 317.882 278 316.5 278Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M345.5 278C344.118 278 343 276.852 343 275.433V272.567C343 271.148 344.118 270 345.5 270C346.882 270 348 271.148 348 272.567V275.433C348 276.852 346.882 278 345.5 278Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M341.5 259.752C340.349 259.752 339.412 260.762 339.412 262C339.412 263.239 340.349 264.249 341.5 264.249C342.65 264.249 343.588 263.239 343.588 262C343.588 260.762 342.65 259.752 341.5 259.752ZM341.5 269C337.915 269 335 265.861 335 261.999C335 258.139 337.915 255 341.5 255C345.084 255 348 258.139 348 261.999C348 265.861 345.084 269 341.5 269Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M334.738 280C333.909 280 333.113 279.502 332.715 278.64L331.5 276.006L330.284 278.64C329.721 279.857 328.361 280.35 327.245 279.734C326.128 279.12 325.68 277.632 326.243 276.412L328.078 272.435C328.77 270.932 330.081 270 331.5 270C332.917 270 334.228 270.932 334.922 272.433L336.756 276.412C337.32 277.632 336.871 279.12 335.755 279.734C335.428 279.915 335.081 280 334.738 280Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M334.419 284.172H334.857C335.858 284.172 336.741 284.842 337.028 285.816C337.112 286.108 337.377 286.4 337.775 286.4C338.173 286.4 338.438 286.108 338.523 285.816C338.81 284.842 339.692 284.172 340.693 284.172H342.663L344.141 276.089C344.34 274.999 345.277 274.209 346.367 274.209H349.195C349.9 274.209 350.473 273.625 350.473 272.908V263.873C350.473 253.447 342.128 244.802 331.87 244.602C331.753 244.599 331.634 244.598 331.514 244.598C326.632 244.598 321.991 246.547 318.416 250.112C314.675 253.839 312.528 259.01 312.528 264.297V272.908C312.528 273.625 313.101 274.209 313.806 274.209H316.636C317.726 274.209 318.663 274.999 318.862 276.089L320.338 284.172H322.307C323.309 284.172 324.191 284.842 324.478 285.816C324.563 286.108 324.828 286.4 325.225 286.4C325.624 286.4 325.889 286.108 325.973 285.816C326.26 284.842 327.143 284.172 328.144 284.172H328.582C329.584 284.172 330.466 284.842 330.753 285.816C330.838 286.108 331.103 286.4 331.5 286.4C331.899 286.4 332.164 286.108 332.248 285.816C332.535 284.842 333.418 284.172 334.419 284.172ZM337.775 291C336.61 291 335.522 290.623 334.637 289.963C332.868 291.283 330.131 291.283 328.363 289.963C327.478 290.623 326.39 291 325.225 291C323.477 291 321.905 290.151 320.929 288.772H318.455C317.365 288.772 316.428 287.981 316.229 286.892L314.754 278.809H313.806C310.605 278.809 308 276.163 308 272.908V264.297C308 257.783 310.64 251.417 315.245 246.828C319.782 242.309 325.68 239.921 331.958 240.002C344.664 240.249 355 250.959 355 263.873V272.908C355 276.163 352.396 278.809 349.194 278.809H348.248L346.771 286.892C346.572 287.981 345.635 288.772 344.545 288.772H342.071C341.096 290.151 339.523 291 337.775 291Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M322.5 259.752C321.349 259.752 320.412 260.762 320.412 262C320.412 263.239 321.349 264.249 322.5 264.249C323.65 264.249 324.588 263.239 324.588 262C324.588 260.762 323.65 259.752 322.5 259.752ZM322.5 269C318.915 269 316 265.861 316 261.999C316 258.139 318.915 255 322.5 255C326.085 255 329 258.139 329 261.999C329 265.861 326.085 269 322.5 269Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 360H610V356H0V360Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M300.354 57H292.971C292.095 57 291.384 56.2858 291.384 55.4051C291.384 54.5243 292.095 53.8113 292.971 53.8113H300.354C305.026 53.8113 308.826 49.9931 308.826 45.3005C308.826 40.9729 305.601 37.3401 301.324 36.85C300.817 36.792 300.368 36.4929 300.119 36.0448C299.869 35.5979 299.849 35.0572 300.065 34.5926C300.74 33.1382 301.081 31.6012 301.081 30.0256C301.081 24.0502 296.242 19.1887 290.294 19.1887C285.824 19.1887 281.766 22.0232 280.198 26.2422C280.02 26.717 279.629 27.0803 279.143 27.2185C278.659 27.3578 278.135 27.2549 277.736 26.9427C276.233 25.7674 274.438 25.1465 272.545 25.1465C267.874 25.1465 264.073 28.9641 264.073 33.6573C264.073 34.0604 264.111 34.4982 264.19 34.9935C264.266 35.4802 264.115 35.9766 263.778 36.336C263.442 36.6959 262.965 36.8756 262.469 36.8312C262.199 36.8045 261.924 36.7891 261.647 36.7891C256.975 36.7891 253.174 40.6073 253.174 45.3005C253.174 49.9931 256.975 53.8113 261.647 53.8113H268.364C269.241 53.8113 269.951 54.5243 269.951 55.4051C269.951 56.2858 269.241 57 268.364 57H261.647C255.225 57 250 51.7518 250 45.3005C250 39.1016 254.824 34.0138 260.899 33.6249C260.916 27.1883 266.134 21.9572 272.545 21.9572C274.487 21.9572 276.355 22.4314 278.034 23.3423C280.45 18.8834 285.162 16 290.294 16C297.992 16 304.256 22.291 304.256 30.0256C304.256 31.4079 304.053 32.7657 303.654 34.0809C308.528 35.5183 312 40.0353 312 45.3005C312 51.7518 306.775 57 300.354 57Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M262.81 40C262.19 40 261.594 39.662 261.299 39.077C260.437 37.3674 260 35.5287 260 33.6102C260 30.0945 261.531 26.7437 264.199 24.4169C264.898 23.807 265.963 23.8742 266.58 24.5663C267.194 25.2584 267.127 26.3122 266.429 26.9216C264.486 28.614 263.373 31.0526 263.373 33.6102C263.373 35.0062 263.691 36.3439 264.317 37.5858C264.733 38.4106 264.395 39.4133 263.561 39.8245C263.32 39.9441 263.062 40 262.81 40Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M311.366 47C310.463 47 309.731 46.2489 309.731 45.3227C309.731 40.3773 305.768 36.3535 300.898 36.3535C299.955 36.3535 299.027 36.5036 298.141 36.799C297.277 37.0878 296.359 36.6029 296.08 35.7226C295.802 34.8418 296.271 33.8958 297.13 33.6087C298.343 33.2051 299.611 33 300.898 33C307.571 33 313 38.5278 313 45.3227C313 46.2489 312.268 47 311.366 47Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M122.125 155.781H142.876V151.219H122.125V155.781ZM144.438 159H120.563C119.7 159 119 158.279 119 157.39V149.61C119 148.721 119.7 148 120.563 148H144.438C145.301 148 146 148.721 146 149.61V157.39C146 158.279 145.301 159 144.438 159Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M112.35 117.186C110.598 117.186 109.175 118.615 109.175 120.371V143.63C109.175 145.386 110.598 146.815 112.35 146.815H152.65C154.401 146.815 155.825 145.386 155.825 143.63V120.371C155.825 118.615 154.401 117.186 152.65 117.186H112.35ZM152.65 150H112.35C108.848 150 106 147.142 106 143.63V120.37C106 116.858 108.848 114 112.35 114H152.65C156.152 114 159 116.858 159 120.37V143.63C159 147.142 156.152 150 152.65 150Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M157.412 144H107.587C106.711 144 106 143.3 106 142.437V122.562C106 121.699 106.711 121 107.587 121H115.691C116.568 121 117.278 121.699 117.278 122.562C117.278 123.426 116.568 124.125 115.691 124.125H109.175V140.875H155.825V124.125H150.365C149.488 124.125 148.777 123.426 148.777 122.562C148.777 121.699 149.488 121 150.365 121H157.412C158.289 121 159 121.699 159 122.562V142.437C159 143.3 158.289 144 157.412 144Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M121.2 124H115.8C114.806 124 114 123.105 114 122C114 120.895 114.806 120 115.8 120H121.2C122.194 120 123 120.895 123 122C123 123.105 122.194 124 121.2 124Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.352 124H128.648C127.738 124 127 123.105 127 122C127 120.895 127.738 120 128.648 120H137.352C138.262 120 139 120.895 139 122C139 123.105 138.262 124 137.352 124Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M151.2 124H145.8C144.806 124 144 123.105 144 122C144 120.895 144.806 120 145.8 120H151.2C152.194 120 153 120.895 153 122C153 123.105 152.194 124 151.2 124Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M167.413 158H97.5874C96.7108 158 96 157.104 96 155.999C96 154.894 96.7108 154 97.5874 154H167.413C168.289 154 169 154.894 169 155.999C169 157.104 168.289 158 167.413 158Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M274.441 66C274.023 66 273.604 65.8224 273.285 65.4679L269.479 61.2337C268.84 60.5246 268.84 59.3742 269.479 58.6645C270.117 57.9541 271.151 57.9541 271.79 58.6645L274.441 61.6122L277.211 58.5323C277.849 57.8226 278.883 57.8226 279.521 58.5323C280.16 59.242 280.16 60.3924 279.521 61.1021L275.596 65.4679C275.277 65.8224 274.859 66 274.441 66Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M274 65C272.896 65 272 64.2855 272 63.4043V42.5951C272 41.7139 272.896 41 274 41C275.104 41 276 41.7139 276 42.5951V63.4043C276 64.2855 275.104 65 274 65Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M282.634 49C282.216 49 281.797 48.8231 281.479 48.4679C280.84 47.7575 280.84 46.6078 281.479 45.8974L285.404 41.5323C286.043 40.8226 287.076 40.8226 287.715 41.5323L291.521 45.7652C292.16 46.4749 292.16 47.6253 291.521 48.3357C290.883 49.0454 289.849 49.0454 289.21 48.3357L286.559 45.3873L283.789 48.4679C283.471 48.8231 283.052 49 282.634 49Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M287 65C285.896 65 285 64.2855 285 63.4043V42.5951C285 41.7139 285.896 41 287 41C288.104 41 289 41.7139 289 42.5951V63.4043C289 64.2855 288.104 65 287 65Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M499.556 301H497.362C496.418 301 495.653 300.218 495.653 299.252C495.653 298.286 496.418 297.504 497.362 297.504H499.556C506.739 297.504 512.582 291.529 512.582 284.184C512.582 276.84 506.739 270.866 499.556 270.866C498.87 270.866 498.146 270.934 497.343 271.073C496.785 271.161 496.216 270.978 495.824 270.559C495.432 270.143 495.267 269.554 495.384 268.988C495.567 268.106 495.66 267.209 495.66 266.323C495.66 259.25 490.032 253.496 483.116 253.496C476.42 253.496 470.925 258.857 470.604 265.702C470.573 266.379 470.16 266.977 469.546 267.234C468.93 267.494 468.227 267.366 467.739 266.904C465.824 265.103 463.347 264.109 460.764 264.109C455.076 264.109 450.448 268.841 450.448 274.659L450.457 274.82C450.464 275.34 450.245 275.835 449.858 276.173C449.473 276.51 448.959 276.655 448.461 276.567C447.838 276.459 447.274 276.406 446.735 276.406C441.046 276.406 436.419 281.138 436.419 286.956C436.419 292.772 441.046 297.504 446.735 297.504H451.637C452.581 297.504 453.347 298.286 453.347 299.252C453.347 300.218 452.581 301 451.637 301H446.735C439.162 301 433 294.699 433 286.956C433 279.076 439.337 272.617 447.134 272.917C447.976 265.992 453.767 260.613 460.764 260.613C463.189 260.613 465.541 261.269 467.612 262.492C469.296 255.286 475.615 250 483.116 250C491.917 250 499.078 257.323 499.078 266.323C499.078 266.675 499.066 267.026 499.044 267.378C508.398 267.096 516 274.738 516 284.184C516 293.457 508.624 301 499.556 301Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M487.328 301H462.672C461.749 301 461 300.105 461 299C461 297.895 461.749 297 462.672 297H487.328C488.252 297 489 297.895 489 299C489 300.105 488.252 301 487.328 301Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M444.409 325.656H503.591V312.346H444.409V325.656ZM505.295 329H442.704C441.763 329 441 328.252 441 327.328V310.673C441 309.748 441.763 309 442.704 309H505.295C506.236 309 507 309.748 507 310.673V327.328C507 328.252 506.236 329 505.295 329Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M452.915 317.314C451.619 317.314 450.565 318.294 450.565 319.499C450.565 320.703 451.619 321.684 452.915 321.684H457.087C458.382 321.684 459.435 320.703 459.435 319.499C459.435 318.294 458.382 317.314 457.087 317.314H452.915ZM457.087 325H452.915C449.653 325 447 322.533 447 319.499C447 316.467 449.653 314 452.915 314H457.087C460.347 314 463 316.467 463 319.499C463 322.533 460.347 325 457.087 325Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M470.664 317.314C469.423 317.314 468.414 318.294 468.414 319.499C468.414 320.703 469.423 321.684 470.664 321.684H495.335C496.575 321.684 497.584 320.703 497.584 319.499C497.584 318.294 496.575 317.314 495.335 317.314H470.664ZM495.335 325H470.664C467.541 325 465 322.533 465 319.499C465 316.467 467.541 314 470.664 314H495.335C498.459 314 501 316.467 501 319.499C501 322.533 498.459 325 495.335 325Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M444.409 349.656H503.591V336.346H444.409V349.656ZM505.295 353H442.704C441.763 353 441 352.252 441 351.328V334.673C441 333.748 441.763 333 442.704 333H505.295C506.236 333 507 333.748 507 334.673V351.328C507 352.252 506.236 353 505.295 353Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M452.915 341.316C451.619 341.316 450.565 342.296 450.565 343.5C450.565 344.705 451.619 345.686 452.915 345.686H457.087C458.382 345.686 459.435 344.705 459.435 343.5C459.435 342.296 458.382 341.316 457.087 341.316H452.915ZM457.087 349H452.915C449.653 349 447 346.533 447 343.5C447 340.467 449.653 338 452.915 338H457.087C460.347 338 463 340.467 463 343.5C463 346.533 460.347 349 457.087 349Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M470.664 341.316C469.423 341.316 468.414 342.296 468.414 343.5C468.414 344.705 469.423 345.686 470.664 345.686H495.335C496.575 345.686 497.584 344.705 497.584 343.5C497.584 342.296 496.575 341.316 495.335 341.316H470.664ZM495.335 349H470.664C467.541 349 465 346.533 465 343.5C465 340.467 467.541 338 470.664 338H495.335C498.459 338 501 340.467 501 343.5C501 346.533 498.459 349 495.335 349Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M456.318 313C455.388 313 454.636 312.236 454.636 311.292V287.417H447.682C446.754 287.417 446 286.653 446 285.708C446 284.764 446.754 284 447.682 284H456.318C457.247 284 458 284.764 458 285.708V311.292C458 312.236 457.247 313 456.318 313Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M492.682 313C491.753 313 491 312.236 491 311.292V285.708C491 284.764 491.753 284 492.682 284H501.318C502.247 284 503 284.764 503 285.708C503 286.653 502.247 287.417 501.318 287.417H494.364V311.292C494.364 312.236 493.611 313 492.682 313Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M457 337C455.895 337 455 336.253 455 335.33V327.67C455 326.747 455.895 326 457 326C458.105 326 459 326.747 459 327.67V335.33C459 336.253 458.105 337 457 337Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M492 337C490.895 337 490 336.253 490 335.33V327.67C490 326.747 490.895 326 492 326C493.105 326 494 326.747 494 327.67V335.33C494 336.253 493.105 337 492 337Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M403 475.914L402.237 473C391.375 482.065 379.188 489.68 366 495.531L367.115 498C380.134 492.227 392.197 484.772 403 475.914Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M180.297 449V453.006L180 453.192C202.037 481.663 233.76 502.265 270.179 510C270.811 509.133 271.419 508.313 272 507.543C234.652 499.941 202.24 478.581 180.297 449Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M389.115 546C399.202 541.396 408.857 535.995 418 529.876L417.276 527C408.026 533.254 398.238 538.758 388 543.433L389.115 546Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M348 608.315L349.186 611C387.374 603.96 422.654 588.236 453 565.899L450.809 564C420.737 586.007 385.798 601.458 348 608.315Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M68 462.209C75.3657 479.166 84.4239 495.171 94.9441 510L96 506.658C86.2853 492.737 77.8638 477.79 70.9303 462L68 462.209Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M542.008 269L539 269.061C549.441 296.458 555.156 326.079 555.158 356.982L558 357C558 326.092 552.347 296.45 542.008 269Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M497 522.099L499.067 524C515.846 504.369 529.713 482.222 540 458.218L537.027 458C526.906 481.367 513.356 502.943 497 522.099Z"
                        fill="#FF1236"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M340.538 592.585C340.542 592.533 340.523 592.478 340.461 592.415L340.538 592.585Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M54 318.438L51.3025 317C49.1319 330.246 48 343.823 48 357.652C48 371.375 49.1141 384.85 51.251 398L53.7713 395.442C51.8767 383.108 50.8907 370.49 50.8907 357.652C50.8907 344.319 51.9573 331.224 54 318.438Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M48.0136 355C48.0111 355.436 48 355.87 48 356.307C48 370.148 49.1576 383.738 51.3798 397L54 394.421C52.0304 381.981 51.0046 369.255 51.0046 356.307C51.0046 355.87 51.0163 355.436 51.0188 355H48.0136Z"
                        fill="#FF1236"
                      />
                    </g>
                    {/* Connector to the right-hand label — desktop only, the
                          labels stack below the illustration on mobile. */}
                    <path
                      d="M525 225H787V293"
                      stroke="#78797D"
                      strokeWidth="4"
                      className="hidden min-[1360px]:block"
                    />
                  </svg>
                </div>
                <div
                  className="order-2 mt-4 w-full min-[1360px]:order-none min-[1360px]:mt-0 min-[1360px]:absolute min-[1360px]:top-[302px] min-[1360px]:right-[-150px] min-[1360px]:w-[334px] min-h-[104px] opacity-100 gap-2 p-4 lg:p-6 rounded-tl-[7px] rounded-bl-[7px] rounded-br-[7px] bg-gradient-to-r from-[#1F2428] to-[#15181D] flex items-center"
                  style={{ animation: "fadeIn 0.5s ease-out 0.2s both" }}
                >
                  <p className="text-white text-sm font-avenir">
                    Reverse engineer application to understand internal structure
                  </p>
                </div>
                <div className="order-1 mt-4 min-[1360px]:order-none min-[1360px]:mt-0 min-[1360px]:absolute min-[1360px]:top-[356px] min-[1360px]:left-[-188px]">
                  <svg
                    width="177"
                    height="78"
                    viewBox="0 0 177 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="hidden min-[1360px]:block"
                  >
                    <path d="M177 2H2V78" stroke="#78797D" strokeWidth="4" />
                  </svg>
                  <div
                    className="w-full min-[1360px]:absolute min-[1360px]:top-[92px] min-[1360px]:left-[-112px] min-[1360px]:w-[334px] min-h-[104px] opacity-100 gap-2 p-4 lg:p-6 rounded-tl-[7px] rounded-bl-[7px] rounded-br-[7px] bg-gradient-to-r from-[#1F2428] to-[#15181D] flex items-center"
                    style={{ animation: "fadeIn 0.5s ease-out 0.4s both" }}
                  >
                    <p className="text-white text-sm font-avenir">
                      Fuzz and inject malformed data to discover security issues
                    </p>
                  </div>
                </div>

                <div className="order-3 mt-4 min-[1360px]:order-none min-[1360px]:mt-0 min-[1360px]:absolute min-[1360px]:top-[542px] min-[1360px]:right-3">
                  <svg
                    width="223"
                    height="63"
                    viewBox="0 0 223 63"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="hidden min-[1360px]:block"
                  >
                    <path d="M0 61H221V0" stroke="#78797D" strokeWidth="4" />
                  </svg>
                  <div
                    className="w-full min-[1360px]:absolute min-[1360px]:top-[-114px] min-[1360px]:right-[-162px] min-[1360px]:w-[334px] min-h-[104px] opacity-100 gap-2 p-4 lg:p-6 rounded-tl-[7px] rounded-bl-[7px] rounded-br-[7px] bg-gradient-to-r from-[#1F2428] to-[#15181D] flex items-center"
                    style={{ animation: "fadeIn 0.5s ease-out 0.6s both" }}
                  >
                    <p className="text-white text-sm font-avenir">
                      Write exploit or proof-of-concept code to validate the vulnerability
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>

        {/* Body copy */}
        <div className="flex flex-col gap-6 sm:gap-7 text-text-highlight">
          <ScrollReveal direction="up" delay={0}>
            <p className="body-1">
              Software vulnerability is responsible for a majority of security breaches. The
              unstoppable growth of digital transformation makes software security even more
              important as hackers constantly attack and exploit vulnerable applications to
              infiltrate an organization. Despite its criticality, software are still buggy and
              vulnerable to all kind of attacks owing to the lack of software quality assurance and
              testing.
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <p className="body-1">
              In contrary to <span className="text-primary">Secure Code Review</span> service where
              source code is required for security analysis, ECQ offers Application Security
              Analysis service to test closed source or proprietary software for potential security
              issues. The service is offered from a Black Box point of view where no source code or
              internal structure of the software is provided.
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <p className="body-1">
              The following describes three major activities that are normally involved.
            </p>
          </ScrollReveal>
        </div>

        {/* Three activity sub-sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-x-12 md:gap-y-10">
          <ScrollReveal direction="up" delay={0}>
            <div className="flex flex-col gap-3">
              <h3 className="flex items-stretch gap-3 text-text-highlight font-bold text-[16px] sm:text-[18px] leading-[24px] font-[var(--font-avenir)]">
                <span aria-hidden className="w-[3px] bg-primary self-stretch" />
                <span>Fuzzing</span>
              </h3>
              <p className="body-1 text-text-highlight">
                ECQ carries out fuzzing and fault injection against various interfaces of the
                targeted application such as protocols, input parameters, or file formats to trigger
                crashes or unusual responses. Software crashes are then debugged and analyzed for
                reproducibility and exploitability.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <div className="flex flex-col gap-3">
              <h3 className="flex items-stretch gap-3 text-text-highlight font-bold text-[16px] sm:text-[18px] leading-[24px] font-[var(--font-avenir)]">
                <span aria-hidden className="w-[3px] bg-primary self-stretch" />
                <span>Reverse Engineer</span>
              </h3>
              <p className="body-1 text-text-highlight">
                Reverse engineer is the process of decomposing or disassembling the application to
                understand the inner working of its components, structures, functions, and data
                flows. This process is important for ECQ to analyze and decide whether a potential
                crash is actually a security vulnerability.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="flex flex-col gap-3">
              <h3 className="flex items-stretch gap-3 text-text-highlight font-bold text-[16px] sm:text-[18px] leading-[24px] font-[var(--font-avenir)]">
                <span aria-hidden className="w-[3px] bg-primary self-stretch" />
                <span>Exploit Development</span>
              </h3>
              <p className="body-1 text-text-highlight">
                For high risk security vulnerability that would result in serious impact such as
                arbitrary code execution or privilege escalation, ECQ Consultants write
                Proof-of-Concept (PoC) and develop exploit to validate the vulnerability. Through
                this exercise, ECQ can assert the true existence of the vulnerability and the
                difficulty and prerequisite for successful exploitation.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </section>
  );
};

export default ApplicationSecurityAnalysis;
